/*
*/

import React from 'react';
import { useState, useEffect } from 'react';
//import { Dimensions } from 'react-native';
//import { useWindowDimensions } from 'react-native';

import { 
  ActivityIndicator, 
  CheckBox, 
  Image, 
  ImageBackground,
  Text, 
  TextInput, 
  TouchableOpacity, 
  View, 
//  Picker, 
  ScrollView, 
//  StyleSheet,
//  KeyboardAvoidingView,
} from 'react-native'; // react-native-web の場合は iOS で error が発生
import Icon from 'react-native-vector-icons/FontAwesome';
//import StepIndicator from 'react-native-step-indicator';
import { Video } from 'expo-av'; // for expo
//import { Video } from 'react-native-unimodules'; // for react-native
//import { RadioButton } from 'react-native-paper';
//import { Calendar } from 'react-native-calendars';
//import QRCode from 'react-native-qrcode-svg';
//import Ticker, { Tick } from "react-native-ticker";

import { bf } from './bf';
import { ic } from './ic';
import { cf } from './cf';

import { iv } from './iv';

import { df } from './df';

export class ce { // common element 

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////
  static c(po_type, pd_pmrs={}, pa_clds=null) {
    return React.createElement(po_type, pd_pmrs, pa_clds);
  };

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////
  static _elm(pd_defs, p_idx='-1') {
    //
    if (false) {
    }
    else if (pd_defs.type == 'Avt'){
      return (
        <ce.Avt
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          uri={pd_defs.uri}
          name={pd_defs.name}
          onPrs={pd_defs.onPrs}
        />
      );
    }
    else if (pd_defs.type == 'Btn'){
      return (
        <ce.Btn
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_rvs={pd_defs.b_rvs}
          pfx={pd_defs.pfx}
          stlCta={pd_defs.stlCta}
          stlBtn={pd_defs.stlBtn}
          stlPfx={pd_defs.stlPfx}
          onPrs={pd_defs.onPrs}
        />
      );
    }
    else if (pd_defs.type == 'Btns'){
      return (
        <ce.Btns
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          ld_defss={pd_defs.ld_defss}
          stlCta={pd_defs.stlCta}
          b_srl={pd_defs.b_srl}
          old_defss={pd_defs.old_defss}
        />
      );
    }
    else if (pd_defs.type == 'Chb'){
      return (
        <ce.Chb
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          onChg={pd_defs.onChg}
        />
      );
    }
    else if (pd_defs.type == 'Chts'){
      return (
        <ce.Chts
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          pfx={pd_defs.pfx}
          ldd_isss={pd_defs.ldd_isss}
          n_vsbIdx={pd_defs.n_vsbIdx}
        />
      );
    }
    else if (pd_defs.type == 'Clds'){
      return (
        <ce.Clds
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          b_dlt={pd_defs.b_dlt}
          b_newLine={pd_defs.b_newLine}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          dd_defss={pd_defs.dd_defss}
          b_row={pd_defs.b_row}
          b_ttl={pd_defs.b_ttl}
          do_stlRows={pd_defs.do_stlRows}
          b_withNo={pd_defs.b_withNo}
          b_spr={pd_defs.b_spr}
          stlCta={pd_defs.stlCta}
          b_wotData={pd_defs.b_wotData}
          d_insDats={pd_defs.d_insDats}          
        />
      );
    }
    else if (pd_defs.type == 'Files'){
//          b_edt={pd_defs.b_edt}
      return (
        <ce.Files
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_lblBtnVsb={pd_defs.b_lblBtnVsb}
          ob_dltBtnVsb={pd_defs.ob_dltBtnVsb}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          n_pntW={pd_defs.n_pntW}
          stlCta={pd_defs.stlCta}
          o_stlCta={pd_defs.o_stlCta}
          o_vsb={pd_defs.o_vsb}
          ct10t110={pd_defs.ct10t110}
          o_sfx={pd_defs.o_sfx}
          b_dltBtnVsb={pd_defs.b_dltBtnVsb}
          stlSfx={pd_defs.stlSfx}
        />
      );
    }
    else if (pd_defs.type == 'Img'){
      return (
        <ce.Img
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          uri={pd_defs.uri}
          msg={pd_defs.msg}
          stlCta={pd_defs.stlCta}
          stlImg={pd_defs.stlImg}
        />
      );
    }
    else if (pd_defs.type == 'Imgs'){
      return (
        <ce.Imgs
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          pfx={pd_defs.pfx}
          msg={pd_defs.msg}
          stlCta={pd_defs.stlCta}
          stlImg={pd_defs.stlImg}
          ld_defss={pd_defs.ld_imgss}
        />
      );
    }
    else if (pd_defs.type == 'Inp'){
      return (
        <ce.Inp
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          d_ids={pd_defs.d_ids}
          ctlVal={pd_defs.ctlVal}
          ini={pd_defs.ini}
          pfx={pd_defs.pfx}
          b_mln={pd_defs.b_mln}
          phd={pd_defs.phd}
          onBlur={pd_defs.onBlur}
          onChg={pd_defs.onChg}
          onFcs={pd_defs.onFcs}
          onPrs={pd_defs.onPrs}
          stlCta={pd_defs.stlCta}
          stlInp={pd_defs.stlInp}
          n_lyr={pd_defs.n_lyr}
          d_btnDefs={pd_defs.d_btnDefs}
          n_pntW={pd_defs.n_pntW}
          n_col={pd_defs.n_col}
          o_stlVal={pd_defs.o_stlVal}
          kbdType={pd_defs.kbdType}
          stlLbl={pd_defs.stlLbl}
          sfx={pd_defs.sfx}
          n_maxCnt={pd_defs.n_maxCnt}
        />
      );
/*
          b_cmm={pd_defs.b_cmm}
          b_row={pd_defs.b_row}
 */
    }
    else if (pd_defs.type == 'InpTree') {
      return (
        <ce.InpTree
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          phd={pd_defs.phd}
        />
      );
    }
    else if (pd_defs.type == 'InpTree2') {
      return (
        <ce.InpTree2
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          phd={pd_defs.phd}
          d_elmDefs={pd_defs.d_elmDefs}
        />
      );
    }
    else if (pd_defs.type == 'InpTree3') {
      return (
        <ce.InpTree3
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          phd={pd_defs.phd}
          dd_elmDefss={pd_defs.dd_elmDefss}
        />
      );
    }
    else if (pd_defs.type == 'Lbl'){
      return (
        <ce.Lbl
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_btnVsb={pd_defs.b_btnVsb}
          pfx={pd_defs.pfx}
          iconName={pd_defs.iconName}
          onBtnPrs={pd_defs.onBtnPrs}
          stlCta={pd_defs.stlCta}
          stlPfx={pd_defs.stlPfx}
          stlBtn={pd_defs.stlBtn}
          n_col={pd_defs.n_col}
        />
      );
    }
    else if (pd_defs.type == 'Lines'){
//          lld_isss={pd_defs.lld_isss}
      return (
        <ce.Lines
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          pfx={pd_defs.pfx}
          d_defs={pd_defs.d_defs}
          ld_iss={pd_defs.ld_iss}
        />
      );
//          ld_defss={pd_defs.ld_defss}
    }
    else if (pd_defs.type == 'List'){
      return (
        <ce.List
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          state={pd_defs.state}
          ld_itemss={pd_defs.ld_itemss}
          pfx={pd_defs.pfx}
          b_chb={false}
          b_prs={pd_defs.b_prs}
          onPrs={(_d_items, _key) => {
            if (pd_defs.onPrs) {
              pd_defs.onPrs(_d_items, _idx);
            }
            else {
              if (bf.f(pd_defs.nextRole) && bf.f(pd_defs.nextPage)) {
                let _d_pageInfs = {
                  sgc_pageRole: pd_defs.nextRole,
                  sgc_pageName: pd_defs.nextPage,
                  sgc_pageKey: _d_items.key, // sgcd_pagePntKeys に統合？
                  sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => {
                    if (pd_defs.pagePntKeyName) { // UserList 等において dtl へ key を引き継ぐために必要
                      _next[pd_defs.pagePntKeyName] = _d_items.key;
                    };
                  }),
                  sgc_pageMode: 'show',
                };
//bf.l('313:{}'.f(_d_pageInfs))
                cf.myRN_move_fwd(_d_pageInfs);
              };
            };
          }}
          dtmFld={pd_defs.dtmFld}
          sumFld={pd_defs.sumFld}
        />
      );
    }
    else if (pd_defs.type == 'ListBean'){
      return (
        <ce.ListBean
          key={p_idx}
          state={pd_defs.state}
          stlCta={pd_defs.stlCta}
          onPrs={pd_defs.onPrs}
        />
      );
    }
    else if (pd_defs.type == 'ListCard'){
      return (
        <ce.ListCard
          key={p_idx}
          n_col={pd_defs.n_col}
          b_vsb={pd_defs.b_vsb}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          b_chb={false}
          b_bdr={pd_defs.b_bdr} // 枠線の表示
          b_img={pd_defs.b_img} // 画像の表示
          b_menu={pd_defs.b_menu} // メニューの表示
          onPrs={(_d_items) => {
            //
            if (bf.f(pd_defs.nextPage)) { // 画面遷移は nextPage の有無により決定
              let _d_pageInfs = {
                sgc_pageName: pd_defs.nextPage,
                sgc_pageKey: _d_items.key,
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
                sgcb_pageEdt: pd_defs.b_edt,
              };
              cf.myRN_move_fwd(_d_pageInfs);
            };
          }} 
        />
      );
    }
    else if (pd_defs.type == 'ListChat'){
      return (
        <ce.ListChat
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          b_chb={false}
          b_prs={pd_defs.b_prs}
          b_avt={pd_defs.b_avt}
          onPrs={(_d_items) => {
            //
            let _d_pageInfs = {
              sgc_pageName: pd_defs.nextPage,
              sgc_pageKey: _d_items.key,
              sgc_pageMode: 'show',
              sgc_pagePrc: '',
              sgcb_pageEdt: pd_defs.b_edt,
            };
            cf.myRN_move_fwd(_d_pageInfs);
          }} 
          b_edt={pd_defs.b_edt}
          b_chk={pd_defs.b_chk}
          ob_chk={pd_defs.ob_chk}
        />
      );
    }
    else if (pd_defs.type == 'ListEnt') {
      return (
        <ce.ListEnt
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          stlHdr={pd_defs.stlHdr}
        />
      );
    }
    else if (pd_defs.type == 'Msg'){
      return (
        <ce.Msg
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          pfx={pd_defs.pfx}
          stlCta={pd_defs.stlCta}
        />
      );
    }
    else if (pd_defs.type == 'Mp4'){
      return (
        <ce.Mp4
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          uri={pd_defs.uri}
          msg={pd_defs.msg}
          onPrs={pd_defs.onPrs}
        />
      );
    }
    else if (pd_defs.type == 'Pck'){
      return (
        <ce.Pck
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          d_ids={pd_defs.d_ids}
          ctlVal={pd_defs.ctlVal}
          ini={pd_defs.ini}
          pfx={pd_defs.pfx}
          phd={pd_defs.phd}
          phdCcd={pd_defs.phdCcd}
          ld_iss={pd_defs.ld_iss}
          onDltPrs={pd_defs.onDltPrs}
          onChg={(_key, _d_items)=>{
            if (pd_defs.onChg){
              pd_defs.onChg(_key, _d_items);
            };
          }}
          onBlur={(_key, _d_items)=>{
            if (pd_defs.onBlur){
              pd_defs.onBlur(_key, _d_items);
            };
          }}
          stlCta={pd_defs.stlCta}
          stlPfx={pd_defs.stlPfx}
          n_col={pd_defs.n_col}
          stlLbl={pd_defs.stlLbl}
        />
      );
    }                
    else if (pd_defs.type == 'PckDate'){
      return (
        <ce.PckDate
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          onChg={(_d_is)=>{
            if (pd_defs.onChg){
              pd_defs.onChg(_d_is);
            };
          }}
        />
      );
    }
    else if (pd_defs.type == 'PckSch') {
      return (
        <ce.PckSch
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
        />
      );
    }
    else if (pd_defs.type == 'PckSchs') {
      return (
        <ce.PckSchs
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
        />
      );
    }
    else if (pd_defs.type == 'Qr'){
        return (
            <ce.Qr
                key={p_idx}
                b_vsb={pd_defs.b_vsb}
                pfx={pd_defs.pfx}
                val={pd_defs.val}
            />
        );
    }
    else if (pd_defs.type == 'Rdrs'){
//bf.l('457:{}'.f(pd_defs))
//          lld_isss={pd_defs.lld_isss}
      return (
        <ce.Rdrs
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          pfx={pd_defs.pfx}
          ld_iss={pd_defs.ld_iss}
          d_defs={pd_defs.d_defs}
        />
      );
    }
    else if (pd_defs.type == 'Rfr'){
        return (
            <ce.Rfr
                key={p_idx}
                b_vsb={pd_defs.b_vsb}
                b_edt={pd_defs.b_edt}
                state={pd_defs.state}
                pfx={pd_defs.pfx}
                onChgStr={pd_defs.onChgStr}
                onChgKey={pd_defs.onChgKey}
            />
        );
    }
    else if (pd_defs.type == 'Spr'){
        return (
            <ce.Spr
                key={p_idx}
            />
        );
    }
    else if (pd_defs.type == 'Tck'){
        return (
            <ce.Tck
                key={p_idx}
                b_vsb={pd_defs.b_vsb}
                n_cnt={pd_defs.n_cnt}
                n_val={pd_defs.n_val}
                stlCta={pd_defs.stlCta}
                stlPfx={pd_defs.stlPfx}
            />
        );
    };
    //
    return (
      <Text>incorrect def</Text>
    );
  }

    static _elms(pld_defss) {
        //
        return pld_defss?.map((_d_defs, _idx) => {
            //
            return ce._elm(_d_defs, _idx);
        });
    }

    static Avt (pd) { // avator
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <View
                        style={ [{
                            width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                            marginTop: ic.gn_mgnNrm,
                            marginBottom: ic.gn_mgnNrm,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }, pd.stlCta] }
                    >
                        { (pd.pfx) ?
                            <Text 
                                style={ [{
                                    fontSize: ic.gn_fontSizeSml,
                                    color: ic.g_fontCcdSml,
                                    paddingTop: ic.gn_mgnNrm,
                                    paddingBottom: ic.gn_mgnNrm,
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                    fontWeight: 'bold',
                                }, pd.stlPfx] }
                            >
                                { pd.pfx }
                            </Text>
                        : null }
                        <TouchableOpacity
                            onPress={pd.onPrs}
                        >
                            <View
                                style={{
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <ce.Img
                                    uri={pd.uri}
                                    msg={pd.name.replace(/ /g, '').replace(/　/g, '').substring(0,2)}
                                    stlCta={{
                                        width: ic.gn_iconSizeLrg * 2.5,
                                        height: ic.gn_iconSizeLrg * 2.5,
                                        margin: ic.gn_mgnNrm,
                                    }}
                                    stlImg={{
                                        width: ic.gn_iconSizeLrg * 2.5,
                                        height: ic.gn_iconSizeLrg * 2.5,
                                    }}
                                />
                                <Text
                                    style={{
                                        fontSize: ic.gn_fontSizeSml,
                                        color: ic.g_fontCcdSml,
                                    }}
                                >
                                    {pd.name}
                                </Text>
                            </View>
                        </TouchableOpacity>
                    </View>
                : null }
            </View>
        );
    }

    static Bdy (pd) {
        //
        const [_so_scrView, _setScrView] = useState(null);
        const [_sn_oldScrH, _setOldScrH] = useState(0);
        const [_sn_cttSizeChgCnt, _setCttSizeChgCnt] = useState(0); // content size change count : １回目までが初回ロード
        const [_sn_crrScrY, _setCrrScrY] = useState(0);        

/*
        useEffect(() => {
          if (global.c?.state.sgcn_srl > 0) {
            _so_scrView.scrollTo({y: global.c?.state.sgcn_srl, animated: false});
          };
        }, [
          global.c?.state.sgcn_srl,
        ]);
*/
/*
        useEffect(() => { // iMsgDtl のためだけの対応
bf.l('639: here')
          if (pd.b_ste == true && global.c?.state.sgcn_btmDh > 0) {
bf.l('641: here')
            _so_scrView.scrollToEnd({animated: false});
          };
        }, [
          global.c?.state.sgcn_btmDh,
        ]);
*/

        //
//bf.l('593:{}'.f(pd.stlInr))
//let _n_w = (global.c?.state.sgcd_dmns.n_w - global.c?.state.sgcd_dmns.n_bdyW) / 2;
//bf.l('664: {}, {}, {}'.f(global.c?.state.sgcd_dmns.n_w, global.c?.state.sgcd_dmns.n_bdyW, _n_w))
        return (
          <View
            style={[{
              position: 'absolute',
              zIndex: ic.gn_zIdxBdy,
              top: (global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY,
//              left: ((pd.n_bdyW) ? (global.c?.state.sgcd_dmns.n_w - pd.n_bdyW) / 2 : 0),
              left: (global.c?.state.sgcd_dmns.n_w - global.c?.state.sgcd_dmns.n_bdyW) / 2,
//              width: ((pd.n_bdyW) ? pd.n_bdyW : global.c?.state.sgcd_dmns.n_w),
              width: global.c?.state.sgcd_dmns.n_bdyW,
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'stretch',
              borderWidth: 0,
              margin: 0,
              marginLeft: 'auto',
              marginRight: 'auto',
              padding: 0,
              backgroundColor: ic.g_ccdWN,
            }, pd.stlCta]}
            ref={(_o) => {
            }}
            onLayout={() => {
              if (pd.b_ste == true && _so_scrView) {
                _so_scrView.scrollToEnd({animated: false});
              };
            }}
          >
            <ScrollView
              contentContainerStyle={[{
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                borderWidth: 0,
                margin: 0,
                padding: 0,
              }]}
              showsVerticalScrollIndicator={true}
              ref={(_o) => {
                _setScrView(_o);
              }}
              onContentSizeChange={async (_w, _h)=> {
                await _setCttSizeChgCnt(_sn_cttSizeChgCnt+1);
                if (pd.b_ste == true && _so_scrView) { // 最下行を常に表示（スクロールしている場合をのぞく）
                  if (_sn_cttSizeChgCnt >= 2 && _sn_crrScrY == 0) { // データロード後でスクロールが先頭にあるサイズ変更の場合
                    let _dffH = _h - _sn_oldScrH;
                    _so_scrView.scrollTo({
                      y: _dffH, 
                      animated: false
                    });
                  };
                  if (_sn_cttSizeChgCnt < 2 || _sn_cttSizeChgCnt >= 2 && _sn_crrScrY != 0) { // データロード前か、データロード後でスクロールが先頭にないサイズ変更の場合（＝データ追加のあった場合）
                    _so_scrView.scrollToEnd({
                      animated: false
                    });
                  };
                  _setOldScrH(_h)
                };
              }}
              scrollEventThrottle={global.c?.state.sgcd_dmns.n_bdyH}
              onScroll={async (_e)=>{
                //
                _setCrrScrY(_e.nativeEvent.contentOffset.y);
                //
                if (pd.onScrTop){ // for infinit scroll
                  if (_e.nativeEvent.contentOffset.y == 0){
                    pd.onScrTop();
                  };
                };
                if (pd.onScrBtm){ // for infinit scroll
                  if ((_e.nativeEvent.contentSize.height-_e.nativeEvent.contentOffset.y)<=_e.nativeEvent.layoutMeasurement.height){
                    pd.onScrBtm();
                  };
                };
              }}
            >
              <View
                style={[{
                  width: ((pd.n_bdyW) ? pd.n_bdyW : global.c?.state.sgcd_dmns.n_w) - ic.gn_scbW,
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'stretch',
                  borderWidth: 0,
                  margin: 'auto',
                  padding: 0,
                }, pd.stlInr]}
              >
                { pd.children }
              </View>
            </ScrollView>
          </View>
        );
    }

    static Top (pd) {
        return (
          <>
            { (pd.b_vsb) ?
              <View
                style={{
                  position: 'absolute',
                  zIndex: ic.gn_zIdxBdy,
                  top: ic.gn_hdrH,
                  left: 0,
                  height: pd.n_h,
                  width: global.c?.state.sgcd_dmns.n_w,
                  backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                }}
              >                
                  { (pd.ld_defss) ? ce._elms(pd.ld_defss) : null }
              </View>
            : null }
          </>
        );
    };

/*
  static Btm (pd) {
    if (pd.b_vsb == false) return null; 
    return (
      <View
        style={{
          position: 'absolute',
          zIndex: ic.gn_zIdxBdy,
//          top: ((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY) + ic.gn_h - (ic.gn_hdrH + ((pd.n_h) ? pd.n_h : 0) + ic.gn_ftrH),
//          top: ic.gn_bdyY + (cf.myRN_chk_os('a') ? 0 : (global.c?.state.sgcn_dy ?? 0)) + ic.gn_h - (ic.gn_hdrH + (pd.n_h ?? 0) + ic.gn_ftrH),
//          top: ((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY) + ic.gn_h - (ic.gn_hdrH + ((pd.n_h) ? pd.n_h : 0) + ic.gn_ftrH),
//          top: ic.gn_bdyY + ic.gn_h - (ic.gn_hdrH + (pd.n_h ?? 0) + ic.gn_ftrH),
          top: (global.c?.state.sgcn_bdyY ?? ic.gn_bdyY) + ic.gn_h - (ic.gn_hdrH + (pd.n_h ?? 0) + ic.gn_ftrH),
          left: (global.c?.state.sgcd_dmns.n_w - ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW)) / 2,
          height: (pd.n_h) ? pd.n_h : 0,
          width: (pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW,
        }}
      >                
        { (pd.ld_defss) ? ce._elms(pd.ld_defss) : null }
      </View>
    );
  };
*/

  static Btm (pd) {
    if (pd.b_vsb == false) return null; 
//let _top = (ic.gn_h - ((pd.n_h ?? 0) + ic.gn_ftrH) - (global.c?.state.sgcn_dy ?? 0));
//bf.l('761: {}, {}, {}, {}, {}'.f(_top, ic.gn_h, pd.n_h, ic.gn_ftrH, global.c?.state.sgcn_dy));
    return (
      <View
        style={{
          position: 'absolute',
          zIndex: ic.gn_zIdxBdy,
//          top: ((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY) + ic.gn_h - (ic.gn_hdrH + ((pd.n_h) ? pd.n_h : 0) + ic.gn_ftrH),
//          top: ic.gn_bdyY + (cf.myRN_chk_os('a') ? 0 : (global.c?.state.sgcn_dy ?? 0)) + ic.gn_h - (ic.gn_hdrH + (pd.n_h ?? 0) + ic.gn_ftrH),
//          top: ((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY) + ic.gn_h - (ic.gn_hdrH + ((pd.n_h) ? pd.n_h : 0) + ic.gn_ftrH),
//          top: ic.gn_bdyY + ic.gn_h - (ic.gn_hdrH + (pd.n_h ?? 0) + ic.gn_ftrH),
//          top: (global.c?.state.sgcn_bdyY ?? ic.gn_bdyY) + ic.gn_h - (ic.gn_hdrH + (pd.n_h ?? 0) + ic.gn_ftrH),
//          top: ic.gn_bdyY + ic.gn_h - (ic.gn_hdrH + (pd.n_h ?? 0) + ic.gn_ftrH),
//          top: (ic.gn_h - ((pd.n_h ?? 0) + ic.gn_ftrH) - (global.c?.state.sgcn_dy ?? 0)),
//          top: ic.gn_bdyY + (ic.gn_h - (ic.gn_hdrH + (pd.n_h ?? 0) + ic.gn_ftrH)) - (global.c?.state.sgcn_dy ?? 0),
          top: ic.gn_bdyY + (global.c?.state.sgcd_dmns.n_h - (ic.gn_hdrH + (pd.n_h ?? 0) + ic.gn_ftrH)) - (global.c?.state.sgcn_dy ?? 0),
          left: (global.c?.state.sgcd_dmns.n_w - ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW)) / 2,
          height: (pd.n_h) ? pd.n_h : 0,
          width: (pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW,
        }}
      >                
        { (pd.ld_defss) ? ce._elms(pd.ld_defss) : null }
      </View>
    );
  };

    static Btn (pd) {
      if (pd.b_vsb == false) {
        return null;
      };
      return (
        <View 
          style={[{
            height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2,
//            width: global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            width: global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: 0,
            marginBottom: 0,
            paddingStart: 0,
            paddingEnd: 0,
            paddingTop: 0,
            paddingBottom: 0,
          }, pd.stlCta]}
        >
          <TouchableOpacity
            onPress={()=>{
              if (pd.onPrs) {
                pd.onPrs();
              };
            }}
            style={{
              marginStart: 'auto',
              marginEnd: 'auto',
              marginTop: 0,
              marginBottom: 0,
              paddingStart: 0,
              paddingEnd: 0,
              paddingTop: 0,
              paddingBottom: 0,
            }}
          >
            <View
              style={ [{ 
                height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2, 
                lineHeight: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2, 
                width: ic.gn_btnWNrm, 
                backgroundColor: (pd.b_rvs) ? ic.g_ccdWN : (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                borderWidth: ic.gn_bdrWNrw,
                borderColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                borderRadius: ic.gn_bdrRdsNrm,
                marginStart: 0,
                marginEnd: 0,
                marginTop: 0,
                marginBottom: 0,
                paddingStart: 0,
                paddingEnd: 0,
                paddingTop: 0,
                paddingBottom: 0,
                flex: 1,
                flexDirection: 'column',
                justifyContent: 'center', 
                alignItems: 'center',
              }, pd.stlBtn]}
            >
              <Text
                style={[{ 
                  fontSize: ic.gn_fontSizeNrm,
                  color: (pd.b_rvs) ? (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd : ic.g_ccdWN,
                }, pd.stlPfx]}
                numberOfLines={1}
              >
                { pd.pfx }
              </Text>
            </View>
          </TouchableOpacity>
        </View>
      );
    }
/*
 */

  static BtnIcon (pd) {
    if (pd.b_vsb == false) {
      return null;
    };

    return (
      <View
        key={-1}
        style={[{
          height: ic.gn_btnIconSize,
          width: ic.gn_btnIconSize,
          marginTop: 0,
          marginBottom: 0,
          marginLeft: 0,
          marginRight: 0,
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
        }, pd.stlCta]}
      >
        <TouchableOpacity
          key={-1}
          onPress={pd.onPrs}
        >
          <View
            key={-1}
            style={[{
              height: ic.gn_btnIconSize,
              width: ic.gn_btnIconSize,
              marginTop: 0,
              marginBottom: 0,
//                marginTop: 'auto',
//                marginBottom: 'auto',
              marginLeft: 0,
              marginRight: 0,
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 0,
              paddingRight: 0,
              backgroundColor: '#dddddd',
              borderColor: '#dddddd',
              borderRadius: ic.gn_btnIconSize/2,
            }, pd.stlBtn]}
          >
            <Icon
              key={-1}
              name={pd.iconName}
              type="FontAwesome"
              underlayColor="transparent"
              size={ic.gn_btnIconSize - ic.gn_mgnNrm * 2}
              style={[{
                color: '#555555',
                marginTop: 'auto',
                marginBottom: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto',
              }, pd.stlIcon]}
            />
          </View>
        </TouchableOpacity>
      </View>
    );
  }

static BtnIconPfx(pd){
  if (pd.b_vsb == false) return;
//          color={ic.g_backCcd}
  return (
    <TouchableOpacity
        onPress={pd.onPrs}
    >
      <View
        style={[{
          height: ic.gn_iconSizeSml*1.2 + ic.gn_fontSizeSml * 0.3,
          minWidth: ic.gn_btnWSml, // 全角5文字まで
          marginLeft: 0,
          marginRight: 0,
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }, pd.stlCta]}
      >
        <Icon
          name={pd.iconName}
          size={ic.gn_iconSizeSml*1.2}
          color={pd.ccd ?? ic.g_backCcd}
        />
        <Text
          style={{
            fontSize: ic.gn_fontSizeSml*0.7,
//            color: ic.g_backCcd,
            color: pd.ccd ?? ic.g_backCcd,
            margin: 'auto',
          }}
        >
          {pd.pfx}
        </Text>
        { (bf.f(pd.n_cnt) && pd.n_cnt > 0) ?
          <View
            style={{
              position: 'absolute',
              top: -4,
              right: -4,
              height: 12,
              width: 36,
              backgroundColor: '#ff0000',
              borderRadius: 6,
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Text
              style={{
                fontSize: 10,
                fontWeight: 'bold',
                color: '#ffffff',
                textAlign: 'center',
              }}
            >
              {pd.n_cnt}
            </Text>
          </View>
        : null }
      </View>
    </TouchableOpacity>
  );
}

static Btns (pd) {

  if ( pd.b_vsb == false ) return null;

  let _ld_defss = (pd.old_defss) ? pd.old_defss() : pd.ld_defss;

  if ( bf.f(_ld_defss) == false ) return null;

  let _r = [];

  const [ _sn_crrIdx, _setCrrIdx] = useState(0);

  for (let [_idx, _d_defs] of bf.e(_ld_defss)) {

    if (_d_defs.b_vsb == false) continue;

    _r.push(
      <TouchableOpacity
        key={_idx}
        onPress={() => {
          _setCrrIdx(_idx);
          if (_d_defs.onPrs) _d_defs.onPrs(_d_defs);
        }}
      >
        <View
          key={1}
          style={ [{ 
            height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2, 
            lineHeight: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2, 
            // width: ic.gn_btnWNrm, 
            backgroundColor: 
                (_d_defs.b_rvs || (pd.b_srl == true && _sn_crrIdx != _idx)) ? 
                  ic.g_ccdWN 
                : 
                  (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? 
                    ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd 
                  : 
                    ic.gdd_ccdDefss.cmn.bdyCcd
            ,
            borderWidth: ic.gn_bdrWNrw,
            borderBottomWidth: (pd.b_srl == true && _sn_crrIdx != _idx) ? 0 : ic.gn_bdrWNrw,
            borderColor: 
              (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? 
                ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd 
              : 
                ic.gdd_ccdDefss.cmn.bdyCcd
            ,
//            borderRadius: ic.gn_bdrRdsNrm,
            borderTopLeftRadius: ic.gn_bdrRdsNrm,
            borderTopRightRadius: ic.gn_bdrRdsNrm,
            borderBottomLeftRadius: (pd.b_srl == true) ? 0 : ic.gn_bdrRdsNrm,
            borderBottomRightRadius: (pd.b_srl == true) ? 0 : ic.gn_bdrRdsNrm,
            marginStart: (pd.b_srl == true) ? ic.gn_mgnNrm : 0,
            marginEnd: 0,
            marginTop: 0,
            marginBottom: 0,
//            paddingStart: 0,
//            paddingEnd: 0,
            paddingLeft: ic.gn_mgnNrm,
            paddingRight: ic.gn_mgnNrm,
            paddingTop: 0,
            paddingBottom: 0,
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center', 
            alignItems: 'center',
          }, _d_defs.stlBtn]}
        >
          <Text
            key={1}
            style={[{ 
              fontSize: ic.gn_fontSizeNrm,
              color: 
                (_d_defs.b_rvs || (pd.b_srl == true && _sn_crrIdx != _idx)) ? 
                  (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? 
                    ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd 
                  : 
                    ic.gdd_ccdDefss.cmn.bdyCcd 
                : 
                  ic.g_ccdWN
              ,
            }, _d_defs.stlPfx]}
            numberOfLines={1}
          >
            { _d_defs.pfx }
          </Text>
        </View>
      </TouchableOpacity>
    );
  };
  //
//          showsHorizontalScrollIndicator={true}
  return (
    <>
      { ( pd.b_srl == true ) ?
        <ScrollView
          contentContainerStyle={[{
            height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2,
//            width: ((pd.n_bdyW) ? pd.n_bdyW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            flexDirection: 'row',
//            justifyContent: 'around-space',
            justifyContent: 'space-around',
            alignItems: 'center',
/*
            borderWidth: 0,
            borderBottomWidth: ic.gn_bdrWNrw,
            borderBottomColor:
              (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? 
                ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd 
              : 
                ic.gdd_ccdDefss.cmn.bdyCcd 
            ,
*/
            marginTop: ic.gn_mgnNrm,
            marginBottom: 0,
            padding: 0,
          }]}
          style={{
            width: ((pd.n_bdyW) ? pd.n_bdyW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            marginLeft: 'auto',
            marginRight: 'auto',
            borderWidth: 0,
            borderBottomWidth: ic.gn_bdrWNrw,
            borderBottomColor:
              (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? 
                ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd 
              : 
                ic.gdd_ccdDefss.cmn.bdyCcd 
            ,
          }}
          horizontal={true}
        >
          {_r}
        </ScrollView>
      :
        <View 
          style={[{
            height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2,
            width: ((pd.n_bdyW) ? pd.n_bdyW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: 0,
            marginBottom: 0,
            paddingStart: 0,
            paddingEnd: 0,
            paddingTop: 0,
            paddingBottom: 0,
            flexDirection: 'row',
            justifyContent: 'space-around',
            alignItems: 'center',
          }, pd.stlCta]}
        >
          {_r}
        </View>
      }
    </>
  );
}

    static Box (pd) {
      return (
        <View
          style={[{
            marginStart: 0,
            marginEnd: 0,
            marginTop: 0,
            marginBottom: 0,
            borderWidth: 0,
//            backgroundColor: 'red',
          }, pd.stlCta]}
        >
          { pd.children }
        </View>
      );
    }

    static Files (pd) {
      if (pd.b_vsb == false) return null;
      //
      let _r = [];
      //
      for (let [_idx, _d_files] of bf.e(global.c?.state[pd.state])) {
        if (pd.o_vsb && pd.o_vsb(_d_files.d_ct10s) == false) {
          continue;
        };
        if (bf.f(_d_files) && _d_files.b_dlt != true) {
          _r.push(
            <View
              key={_idx}
              style={[{
                height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2,
                width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                marginTop: ic.gn_mgnNrm,
                marginBottom: ic.gn_mgnNrm,
                marginLeft: 'auto',
                marginRight: 'auto',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                paddingTop: ic.gn_mgnNrm,
                paddingBottom: ic.gn_mgnNrm,
                paddingLeft: ic.gn_mgnNrm,
                paddingRight: ic.gn_mgnNrm,
              }, (pd.stlCta) ? pd.stlCta : ((pd.o_stlCta) ? pd.o_stlCta(_d_files.d_ct10s) : null)]}
            >
              { (_d_files.lct == 'ext' && bf.f(_d_files.file)) ?
                <ce.Link
                  key={-1}
                  file={_d_files.file}
                  stlLink={{
                    color: '#ffaa00',
                  }}
                >
                  {_d_files.name}
                </ce.Link>
              : null }
              { (_d_files.lct == 'ext' && bf.f(_d_files.url)) ?
                <ce.Link
                  key={-1}
                  url={_d_files.url}
                  file={_d_files.file}
                  stlLink={{
                    color: '#ffaa00',
                  }}
                >
                  {_d_files.name}
                </ce.Link>
              : null }
              { (_d_files.lct == 'int') ?
                <Text>
                  {_d_files.name}
                </Text>
              : null }
              { (pd.o_sfx) ?
                <Text
                  style={[{
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                    color: ic.g_ccdHN,
                    fontSize: ic.gn_fontSizeSml,
                    textAlign: 'right',
                  }, pd.stlSfx]}
                >{pd.o_sfx(_d_files)}</Text>
              : null }
              <ce.BtnIcon
                key={-2}
                b_vsb={(pd.ob_dltBtnVsb) ? pd.ob_dltBtnVsb(_d_files.d_ct10s) : pd.b_dltBtnVsb}
                iconName="trash"
                onPrs={()=>{
                  if (_d_files.lct == 'int'){ // 内部ファイルの場合
                    // list から ファイルを削除
                    let _ld_files = global.c?.state[pd.state];
                    // 削除対象が内部ファイルの場合
                    _ld_files = bf.myCM_rmv(_ld_files, _d_files);
                    global.c?.setState({
                      [pd.state]: _ld_files,
                    });
                  }; 
                  if (_d_files.lct == 'ext'){ // 外部ファイルの場合
                    let _ld_files = global.c?.state[pd.state];
                    _ld_files = bf.myCM_rmv(_ld_files, _d_files);
                    _d_files.b_dlt = true;
                    _ld_files.push(_d_files);
                    global.c?.setState({
                      [pd.state]: _ld_files,
                    });
                  }; 
                }}
                stlCta={{
                    position: 'absolute',
                    top: ic.gn_mgnNrm + ic.gn_bdrWNrw * 1.5 / 2, // boderWidth 分を追加
                    right: ic.gn_mgnNrm,
                    backgroundColor: ic.gn_backCcd,
                }}
              />
            </View>
          );
        };
      };
/*
                b_vsb={pd.ob_dltBtnVsb(_d_files.d_ct10s)}
                stlBtn={{
                  backgroundColor: ic.gn_backCcd,
                }}
*/

      return (
        <>
          <ce.Lbl
            key={-1}
            pfx={pd.pfx}
            iconName={'plus'}
            b_btnVsb={pd.b_lblBtnVsb}
            onBtnPrs={()=>{
              cf.myFS_pck_file()
              .then(async (_d_files) => {
                if ( global.c && pd.state && global.c?.state[pd.state]) {
                  global.c?.setState({
                    [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                      _d_files.d_ct10s = {
                        ct10t110: pd.ct10t110 || global.c?.state.sgcd_pagePntKeys.cm10c410,
                        ct10cy20: global.c?.state.sgcd_pagePntKeys.cm10_key,
                      };
                      _next.push(_d_files);
                    }),
                  });
                };
              });
            }}
          />
          {_r}
        </>
      );
    }

    static Ftr (pd) {
        //
        let _r = [];
        //
        const _fnc1 = (pd_defs) => {
//bf.l('1283: {}'.f(pd_defs))
          if (pd_defs.page) { // 内部画面の場合
            cf.myRN_clr_pageInf(()=>{
              new Promise((_o_end1) => {
                if (pd_defs.sgcd_pagePntKeys) {
                  global.c?.setState({
                    sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => {
                      for (let [_key, _val] of bf.e(pd_defs.sgcd_pagePntKeys)) {
                        _next[_key] = _val;
                      };
                    }),
                  }, ()=>{
                    _o_end1();
                  })
                }
                else {
                  _o_end1();
                };
              })
              .then(()=>{
                let _d_pageInfs = { // pagePntKey の切り替えは Ftr では行わない
                  sgc_pageRole: pd_defs.role, // pageRole の切り替えにも対応
                  sgc_pageName: pd_defs.page,
                  sgc_pageKey: global.c?.state.sgc_pageKey, // メニューを押した際に pageKey を引き継げるよう、初期化しない
                  sgc_pageMode: 'show',
                };
//bf.l('1308: {}'.f(_d_pageInfs))
                cf.myRN_move_fwd(_d_pageInfs);
              });
            });
          };
          if (pd_defs.url) { // 外部URLの場合
            cf.myRN_open_url(pd_defs.url);
          };
        };
        //
//bf.l('1159:{}, {}'.f(global.c?.state.sgc_pageRole, pd.dd_defss[global.c?.state.sgc_pageRole]));
        for (let [_key, _d_defs] of bf.e(pd.dd_defss[global.c?.state.sgc_pageRole])){
            if (_d_defs.b_vsb == false) { // ftr において、表示対象外も定義可能とするため
              continue;
            };
            if (_d_defs.type == 'iconPfx'){
//bf.l('1162:{}'.f(_d_defs))
              _r.push(
                <ce.BtnIconPfx
                  key={_key}
                  iconName={_d_defs.iconName}
                  pfx={_d_defs.pfx}
                  onPrs={() => {
                    if (_d_defs.fnc == 'logout') {
                      cf.myRN_logout();
                    }
                    else {
                      _fnc1(_d_defs);
                    };
                  }}
                  n_cnt={(_d_defs.state) ? global.c?.state[_d_defs.state] : null}
                />
              );
            };
            if (_d_defs.type == 'pfx'){
              _r.push(
                <TouchableOpacity
                  key={_key}
                  onPress={() => _fnc1(_d_defs)}
                >
                  <View
                    style={{
                      height: ic.gn_ftrH,
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Text
                      style={{
                        fontSize: ic.gn_fontSizeNrm,
                        color: ic.g_backCcd,
                        margin: 'auto',
                      }}
                    >
                      {_d_defs.pfx}
                    </Text>
                  </View>
                </TouchableOpacity>
              );
            };
            if (_d_defs.type == 'img-sch'){
                _r.push(
                  <TouchableOpacity
                    key={_key}
                    onPress={() => _fnc1(_d_defs)}
                  >
                    <View
                      style={{
                        height: ic.gn_ftrH,
                        width: ic.gn_ftrH,
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Image
                        style={[{
                          height: ic.gn_iconSizeNrm,
                          width: ic.gn_iconSizeNrm / _d_defs.h * _d_defs.w,
                          margin: 'auto',
                        }]}
                        source={'./icon-sch.png'}　// 文字列に変換しておかないと error が発生
                      />
                    </View>
                  </TouchableOpacity>
                );
            };
            if (_d_defs.type == 'img-msg'){
                _r.push(
                  <TouchableOpacity
                    key={_key}
                    style={{
                      height: ic.gn_ftrH,
                      width: ic.gn_ftrH,
                    }}
                    onPress={() => _fnc1(_d_defs)}
                  >
                    <View
                      style={{
                        height: ic.gn_ftrH,
                        width: ic.gn_ftrH,
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Image
                        style={[{
                          height: ic.gn_iconSizeNrm,
                          width: ic.gn_iconSizeNrm / _d_defs.h * _d_defs.w,
                          margin: 'auto',
                        }]}
                        source={'./icon-msg.png'}　// 文字列に変換しておかないと error が発生
                      />
                    </View>
                  </TouchableOpacity>
                );
            };
            if (_d_defs.type == 'img-usr'){
              _r.push(
                <TouchableOpacity
                  key={_key}
                  style={{
                    height: ic.gn_ftrH,
                    width: ic.gn_ftrH,
                  }}
                  onPress={() => _fnc1(_d_defs)}
                >
                  <View
                    style={{
                      height: ic.gn_ftrH,
                      width: ic.gn_ftrH,
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    { (bf.f(global.c?.state.sgc_user_img)) ?
                      <Image
                        style={[{
                          height: ic.gn_iconSizeNrm,
                          width: ic.gn_iconSizeNrm,
                          marginTop: 'auto',
                          marginBottom: 'auto',
                          borderRadius: ic.gn_bdrRdsNrm,
                        }]}
                        source={{uri:cf.myRN_get_uri(global.c?.state.sgc_user_img)}}　// 文字列に変換しておかないと error が発生
                      />
                    :
                      <Icon
                        name={'user'}
                        color={(ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].ftrCcd : ic.gdd_ccdDefss.cmn.ftrCcd}
                        size={ic.gn_iconSizeSml}
                        style={{
                          margin: 'auto',
                        }}
                      />
                    }
                  </View>
                </TouchableOpacity>
              );
            };
        };

//bf.l('1311:{}'.f(bf.myCM_get_len(pd.dd_defss[global.c?.state.sgc_pageRole])))
        if (bf.myCM_get_len(pd.dd_defss[global.c?.state.sgc_pageRole]) == 1) { // 要素が 1つの場合は表示しない, error が発生する場合は sgc_pageRole が誤っていないか確認
          _r = [];
        };

        return (
          <View style={[{ 
            position: 'absolute',
            zIndex: 20,
//            top: ic.gn_ftrY,
            top: ic.gn_hdrH + global.c?.state.sgcd_dmns.n_bdyH,
            left: 0,
            height: ic.gn_ftrH,
//            width: global.c?.state.sgcd_dmns.n_w,
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'space-around',
//            alignItems: 'center',
            alignItems: cf.myRN_chk_os('i') ? 'flex-start' : 'center',
            backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].ftrCcd : ic.gdd_ccdDefss.cmn.ftrCcd,
            padding: ic.gn_mgnNrm,
            borderTopWidth: ic.gn_bdrWNrm,
            borderTopColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].ftrCcd : ic.gdd_ccdDefss.cmn.ftrCcd,
          }, pd.stlCta]}>
            {_r}
          </View>
        );
    }

    static Hdr (pd) {
        let _logo = '{}'.f(pd.logo)
//bf.l('1512: "{}"'.f(pd.pfx))
/*
        let _top =
          cf.myRN_chk_os('a') ?
            - ( (global.c?.state.sgcn_bdyY ?? ic.gn_bdyY) - ic.gn_bdyY )
          : 0
        ;
*/
/*
        let _top =
            - ( (global.c?.state.sgcn_bdyY ?? ic.gn_bdyY) - ic.gn_bdyY )
        ;
bf.l('1507: {}, {}, {}'.f(_top, global.c?.state.sgcn_bdyY, ic.gn_bdyY))
*/
        return (
            <View style={{ 
              position: 'absolute',
              zIndex: ic.gn_zIdxHdr,
              top: (ic.gn_hdrY ?? 0) - (global.c?.state.sgcn_dy ?? 0),
              left: 0,
              height: ic.gn_hdrH,
//              width: global.c?.state.sgcd_dmns.n_w,
              width: '100%',
              flexDirection: 'column',
              justifyContent: cf.myRN_chk_os('i') ? 'flex-end' : 'center',
              alignItems: 'center',
              backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
              borderColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
              borderBottomWidth: ic.gn_bdrWNrm,
            }}>
                <View style={{
                  position: 'absolute',
                  zIndex: ic.gn_zIdxHdr + 1,
//                  top: ((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY - ic.gn_hdrH : ic.gn_bdyY - ic.gn_hdrH) + ic.gn_hdrBarH,
//                  top: ((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY - ic.gn_hdrH : ic.gn_bdyY - ic.gn_hdrH) + ic.gn_hdrBarH,
                  top: ic.gn_hdrBarH,
                  left: 0,
                  height: ic.gn_hdrH - ic.gn_hdrBarH,
                  width:ic.gn_btnWSml * 3,
//                 width:ic.gn_btnWSml * 2,
                  marginLeft: ic.gn_mgnNrm,
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}>
                    { (pd.b_logo) ?
                      <Image
                        style={[{
                          height: ic.gn_iconSizeLrg,
                          width: ic.gn_iconSizeLrg / ic.gn_logoH * ic.gn_logoW,
                        }]}
                        source={'./logo.png'} // you need logo.png at ./srn ※ 文字列に変換しておかないと error が発生
                      />
                    : null }
                    { (pd.logo) ?
                      <Text
                        style={[{
                          fontSize: ic.gn_fontSizeNrm,
                          color: ic.g_backCcd,
                          textAlign: 'center',
                        }]}
                      >
                        {pd.logo}
                      </Text>
                    : null }
                    { (bf.f(pd.leftIconName) && !bf.f(pd.leftPfx) && pd.b_leftVsb != false) ?
                      ce.Icon({
                        name: pd.leftIconName,
                        n_size: 30,
                        ccd: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                        onPrs: pd.onLeftPrs,
                      })
                    : null }
                    { (bf.f(pd.leftPfx) && !bf.f(pd.leftIconName) && pd.b_leftVsb != false) ? // logo がある場合、leftPfx が改行される場合がある
                      ce.Btn({
                        pfx:pd.leftPfx, 
                        b_vsb:true,
                        stlCta:bf.myCM_upd({
                          width: ic.gn_btnWNrm,
                        }, pd.stlLeftCta),
                        stlBtn:bf.myCM_upd({
                          borderColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                          backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'flex-start',
                        }, pd.stlLeftBtn),
                        stlPfx:bf.myCM_upd({
                          color: ic.g_backCcd,
                        }, pd.stlLeftPfx),
                        onPrs:pd.onLeftPrs,
                      })
                    : null }
                    { (bf.f(pd.leftIconName) && bf.f(pd.leftPfx) && pd.b_leftVsb != false) ?
                      <ce.BtnIconPfx
                        iconName={pd.leftIconName}
                        pfx={pd.leftPfx}
                        onPrs={pd.onLeftPrs}
                        stlCta={{
                          minWidth: ic.gn_iconSizeNrm + ic.gn_mgnNrm / 2 * 2,
                        }}
                      />
                    : null}
                    { (pd.b_sch) ?
                        <ce.BtnIconPfx
                          iconName='search'
                          pfx='検索'
                          onPrs={pd.onSchPrs}
                        />
                    : null}
                </View>
                <View
                  style={{
                    height: ic.gn_hdrH - ic.gn_hdrBarH,
                    width: global.c?.state.sgcd_dmns.n_w,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Text
                    style={[{
                      fontSize: ic.gn_fontSizeNrm,
                      color: ic.g_backCcd,
                      textAlign: 'center',
                    }]}
                  >
                    {pd.pfx}
                  </Text>
                </View>
                <View
                  style={{
                    position: 'absolute',
                    zIndex: ic.gn_zIdxHdr + 1,
//                    top: (((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY) - ic.gn_hdrH) + ic.gn_hdrBarH,
                    top: ic.gn_hdrBarH,
                    right: 0,
                    height: ic.gn_hdrH - ic.gn_hdrBarH,
                    width:ic.gn_btnWSml * 3,
                    marginTop: 0,
                    marginBottom: 0,
                    marginRight: ic.gn_mgnNrm,
                    marginLeft: 0,
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                  }}
                >
                    { (pd.b_rhtVsb != false && bf.f(pd.rhtIconName) && bf.f(pd.rhtPfx)) ?
                      <ce.BtnIconPfx
                        iconName={pd.rhtIconName}
                        pfx={pd.rhtPfx}
                        onPrs={pd.onRhtPrs}
                        stlCta={{
                          minWidth: ic.gn_iconSizeNrm + ic.gn_mgnNrm / 2 * 2,
                        }}
                      />
                    : null}
                    { (pd.b_subVsb != false && bf.f(pd.subIconName) && bf.f(pd.subPfx)) ?
                      <ce.BtnIconPfx
                        iconName={pd.subIconName}
                        pfx={pd.subPfx}
                        onPrs={pd.onSubPrs}
                        stlCta={{
                          minWidth: ic.gn_iconSizeNrm + ic.gn_mgnNrm / 2 * 2,
                        }}
                      />
                    : null}
                </View>
            </View>
        );
    }
/*
                    { (pd.b_rhtVsb != false && bf.f(pd.rhtPfx) && !bf.f(pd.rhtIconName)) ? 
                        ce.Btn({
                            b_vsb:pd.b_rhtVsb,
                            pfx:pd.rhtPfx, 
                            stlCta:bf.myCM_upd({
                                width: ic.gn_btnWNrm,
                            }, pd.stlRhtCta),
                            stlBtn:bf.myCM_upd({
                                backgroundColor: ic.g_backCcd,
                                borderColor: ic.g_backCcd,
                            }, pd.stlRhtBtn),
                            stlPfx:pd.stlRhtPfx,
                            onPrs:pd.onRhtPrs
                        }) 
                    : null}
                    { (pd.b_rhtVsb != false && bf.f(pd.rhtIconName) && !bf.f(pd.rhtPfx)) ?
                        ce.Icon({
                            name: pd.rhtIconName,
                            n_size: 30,
                            ccd:ic.g_hdrCcd,
                            onPrs: pd.onRhtPrs,
                        }) 
                    : null}
                    {(pd.b_trs) ? 
                        <ce.BtnIconPfx
                            iconName='trash'
                            pfx='削除'
                            onPrs={pd.onTrsPrs}
                        />
                    : null }
 */

    static HdrTrs (pd) {
        return (
            <>
                { (pd.b_vsb) ?
                    <View style={{ 
                        position: 'absolute',
                        zIndex: ic.gn_zIdxHdr + 1,
//                        top: ((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY) - ic.gn_hdrH,
                        left: 0,
                        height: ic.gn_hdrH,
                        width: global.c?.state.sgcd_dmns.n_w,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                        borderBottomColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                        borderBottomWidth: ic.gn_bdrWNrm,
                        padding: ic.gn_mgnNrm,
                    }}>
                        <ce.BtnIconPfx
                            iconName='trash'
                            pfx='選択項目を削除'
                            onPrs={pd.onPrs}
                        />
                        <ce.BtnIconPfx
                            iconName='close'
                            pfx='キャンセル'
                            onPrs={pd.onCls}
                        />
                    </View>
                : null }
            </>
        );
    }

    static HdrSch (pd) {
        //
        if (pd.b_vsb == false) {
            return null;
        };
        // 
        return (
            <View style={{ 
                position: 'absolute',
                zIndex: ic.gn_zIdxHdr + 1,
//                top: (((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY) - ic.gn_hdrH) + ic.gn_hdrBarH,
                left: 0,
                height: ic.gn_hdrH - ic.gn_hdrBarH,
                width: global.c?.state.sgcd_dmns.n_w,

                paddingTop: ic.gn_mgnNrm,
                paddingBottom: ic.gn_mgnNrm,
                paddingLeft: ic.gn_mgnNrm,
                paddingRight: ic.gn_mgnNrm,

                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',

                backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                borderBottomColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                borderBottomWidth: ic.gn_bdrWNrm,
            }}>
                <View 
                    style={ [{
                        height: ic.gn_hdrH - ic.gn_mgnNrm * 2,
                        width: global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm - ic.gn_mgnNrm - ic.gn_btnWNrm - ic.gn_mgnNrm,

                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                    }] }
                >
                    <Icon
                        name='search'
                        color={ic.g_backCcd}
                        size={ic.gn_iconSizeSml}
                    />
                    <TextInput 
                        editable={true}
                        multiline={false}
                        placeholder={(pd.phd) ? pd.phd : '検索文字を入力後に確定ください'}
                        placeholderTextColor={ic.g_backCcd}
                        style={{
                            width: global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm - ic.gn_iconSizeSml - ic.gn_mgnNrm - ic.gn_mgnNrm - ic.gn_btnWNrm - ic.gn_mgnNrm,
                            color: ic.g_backCcd,
                            fontSize: ic.gn_fontSizeNrm,
                            borderWidth: ic.gn_bdrWNrw * 1.5,
                            borderColor: (pd.b_edt == true) ? ic.g_bdrCcd : ic.g_ccdWN,
                            borderRadius: ic.gn_bdrRdsNrm,
                            marginTop: ic.gn_mgnNrm,
                            marginBottom: ic.gn_mgnNrm,
                            marginLeft: ic.gn_mgnNrm,
                            marginRight: 0,
                            paddingTop: ic.gn_mgnNrm,
                            paddingBottom: ic.gn_mgnNrm,
                            paddingLeft: ic.gn_mgnNrm,
                            paddingRight: ic.gn_mgnNrm,
                            borderRadius: (pd.b_mln || pd.b_bdr != false) ? ic.gn_bdrRdsNrm : 0,
                            minHeight: (pd.b_mln) ? ic.gn_fontSizeNrm * 8 : ic.gn_fontSizeNrm * 3,
                        }}
                        onChangeText={(_schKey)=>{
                          global.c?.setState({
                            sgcd_schs: bf.p(global.c?.state.sgcd_schs, _next => {
                              _next.word= _schKey;
                            }),
                          }, () => {
//bf.l('1560:{}'.f(global.c?.state.sgcd_schs.word))
                          });
                        }}
                        onSubmitEditing={()=>{
                          if (pd.onEnt) {
                            pd.onEnt();
                          };
                        }}
                    />
                </View>
                <ce.BtnIconPfx
                    iconName='close'
                    pfx='閉じる'
                    onPrs={pd.onCls}
                />
            </View>
        );
    }
/*
                        onChangeText={(_schKey)=>{
                            if (pd.onEnt) {
                                pd.onEnt(_schKey);
                            };
                        }}
 */
    static Icon (pd) {
        return (
            <TouchableOpacity onPress={()=>{if ( pd.onPrs != null ) { pd.onPrs(); };}}>
                <View
                    style={[{
                        justifyContent:'center',
                        alignItems:'center',
                        margin: 'auto',
                    }, pd.stlCta]}
                >
                    <Icon
                        name={pd.name}
                        color={pd.ccd}
                        size={(pd.n_size) ? pd.n_size : ic.gn_iconSizeNrm}
                    />
                </View>
            </TouchableOpacity>
        );
    }

    static Img (pd) {
        let _r = [];
        _r.push(
            <View
                key={1}
                style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <View
                    style={[{
                        height: ic.gn_iconSizeLrg,
                        width: ic.gn_iconSizeLrg,
                        marginLeft: ic.gn_mgnNrm,
                        marginRight: ic.gn_mgnNrm,
                    }, pd.stlCta]}
                >
                    { ((global.c != null && pd.state != null && bf.f(global.c?.state[pd.state])) || (bf.f(pd.uri))) ?
                        <Image
                            style={[{
                                height: ic.gn_iconSizeLrg,
                                width: ic.gn_iconSizeLrg,
                                borderRadius: ic.gn_bdrRdsNrm,
                            }, pd.stlImg]}
                            source={(global.c != null && pd.state != null) ? { uri: global.c?.state[pd.state]} : pd.uri}　// 文字列に変換しておかないと error が発生、pd.uri は require された文字列でないと image が表示されない
                        />
                    :
                        <View
                            style={{
                                height: '100%',
                                width: '100%',
                                backgroundColor: ic.g_ccdHP,
                                borderRadius: ic.gn_bdrRdsNrm,
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Text
                                style={{
                                    fontSize: ic.gn_fontSizeNrm,
                                    color: ic.g_ccdWN,
                                }}
                            >
                                {pd.msg}
                            </Text>
                        </View>
                    }
                </View>
            </View>
        );
        //
        return (
            <View>
                { (pd.pfx) ?
                    <View
                        style={{
                            width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                            marginTop: ic.gn_mgnNrm,
                            marginBottom: ic.gn_mgnNrm,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                    >
                        <Text 
                            style={ [{
                                fontSize: ic.gn_fontSizeSml,
                                color: ic.g_fontCcdSml,
                                paddingTop: ic.gn_mgnNrm,
                                paddingBottom: ic.gn_mgnNrm,
                                paddingLeft: 0,
                                paddingRight: 0,
                                fontWeight: 'bold',
                            }, pd.stlPfx] }
                        >
                            { pd.pfx }
                        </Text>
                    </View>
                : null }
                {(pd.b_edt == true) ?
                    <TouchableOpacity onPress={()=>{
                        if (pd.b_edt == true) {
                            cf.myIP_pick_img((_d_ress) => {
                                if ( global.c != null && pd.state != null ) {
                                    global.c?.setState({[pd.state]:String(_d_ress.uri)})
                                };
                                if (pd.onPrs) {
                                    pd.onPrs(_d_ress.uri);
                                };
                            }, 'image');
                        };
                    }}>
                        {_r}
                    </TouchableOpacity>
                :
                    _r
                }
            </View>
        );
    }

    static Imgs (pd) {
        //
        let _r = [];
        //
        bf.myCM_for_each(pd.ld_defss, (_d_defs, _idx) => {
            _r.push(
                <ce.Img
                    key={_idx}
                    
                    state={_d_defs.state}
                    b_edt={pd.b_edt}
                    msg={_d_defs.msg}
                    uri={_d_defs.uri}
                    stlCta={pd.stlCta}
                    stlImg={pd.stlImg}
                />
            );
        });
        //
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <View
                        style={ [{
                            width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                            marginTop: ic.gn_mgnNrm,
                            marginBottom: ic.gn_mgnNrm,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }, pd.stlBox] }
                    >
                        <View>
                            { (pd.pfx) ?
                                <Text 
                                    style={ [{
                                        fontSize: ic.gn_fontSizeSml,
                                        color: ic.g_fontCcdSml,
                                        paddingTop: ic.gn_mgnNrm,
                                        paddingBottom: ic.gn_mgnNrm,
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        fontWeight: 'bold',
                                    }, pd.stlPfx] }
                                >
                                    { pd.pfx }
                                </Text>
                            : null }
                        </View>
                        <View
                            style={[{
                                marginTop: ic.gn_mgnLrg,
                                marginBottom: ic.gn_mgnLrg,
                                marginLeft: ic.gn_mgnNrm,
                                marginRight: ic.gn_mgnNrm,
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexWrap:'wrap'                    
                            }, pd.stlBox]}
                        >
                            {_r}
                        </View>
                    </View>
                : null }
            </View>
        );
    }

/*
    static Inp (pd) {

        const [_so_textInput, _setTextInput] = useState(null);
        const [_s_val, _setVal] = useState('');

        useEffect(()=>{
          if (global.c?.state[pd.state] || global.c?.state[pd.state] == ''){ // 空白の場合に更新が反映されないことを考慮
            _setVal((pd.o_stlVal) ? pd.o_stlVal({mode: 'on', val: global.c?.state[pd.state]}) : global.c?.state[pd.state]);
            if (pd.onChg) {
              pd.onChg(global.c?.state[pd.state]);
            }
          };
        }, [global.c?.state[pd.state]]);

        useEffect(()=>{
          if (bf.f(pd.ctlVal)){ // 空白の場合に更新が反映されないことを考慮
            if (bf.f(pd.state)) { // clds でない state が指定されている場合
              global.c?.setState({
                [pd.state]: _ctlVal
              });
            }
            else { // clds であり state が指定されていない場合
              _setVal((pd.o_stlVal) ? pd.o_stlVal({mode: 'on', val: pd.ctlVal}) : pd.ctlVal);

              if (pd.onChg) {
                pd.onChg(pd.ctlVal, pd.d_ids);
              }
            }
          };
        }, [pd.ctlVal]);

        if (pd.b_vsb == false) {
            return null;
        }

        const _o_onBlur = () => {
          new Promise( _o_end1 => {
            if (pd.o_stlVal) { // comma の設定
              _setVal(pd.o_stlVal({mode:'on', val: _s_val}), () => {
                _o_end1();
              });
            }
            else {
              _o_end1();
            };
          })
          .then(() => {
            if (pd.state) { // clds ではない場合
              if (pd.onBlur) {
                pd.onBlur(_s_val);
              };
            }
            else { // clds の場合＋（sch等の）通常の入力欄の場合
              if (pd.onBlur) {
                pd.onBlur(_s_val, pd.d_ids);
              };
            };
          });
        };

        const _o_onChangeText = (_s) => {
          if (_s != _s_val) { // 値に変更のあった場合
            _setVal(_s);
            if (pd.state) { // clds ではない場合
              global.c?.setState({ // 外部からの更新を考慮し、onChg は useEffect で実行
                [pd.state]: _s
              }, ()=>{
              });
            }
            else { // clds の場合＋（sch等の）通常の入力欄の場合
              if (pd.onChg) {
                pd.onChg(_s, pd.d_ids);
              }
            };
            if (_so_textInput) {
              _so_textInput.measure((originX, originY, width, height, pageX, pageY) => { // 選択した inp の位置を保存
                global.c?.setState({
                  sgcd_msrs: {x:pageX, y:pageY, w:width, h:height, ox:originX, oy:originY},
                });
              })
            };
          };
        };

        const _o_onContentSizeChange = (_e) => { // PCでは不要な処理のため、keyboard が表示されたときの配置調整は、textinput ではなく、画面ごとに行う
          if (_so_textInput) {
            _so_textInput.measure((originX, originY, width, height, pageX, pageY) => { // 選択した inp の位置を保存
              global.c?.setState({
                sgcd_msrs: {x:pageX, y:pageY, w:width, h:height, ox:originX, oy:originY},
              });
            })
          };
        };

        const _o_onFocus = (_e) => { // PCでは不要な処理のため、keyboard が表示されたときの配置調整は、textinput ではなく、画面ごとに行う
          if (pd.o_stlVal) { // comma の解除
            _setVal(pd.o_stlVal({mode:'off', val:_s_val}));
          };
          if (_so_textInput) {
            _so_textInput.measure((originX, originY, width, height, pageX, pageY) => { // 選択した inp の位置を保存
              global.c?.setState({
                sgcd_msrs: {x:pageX, y:pageY, w:width, h:height, ox:originX, oy:originY},
              });
            })
          };
          if (pd.onFcs) { // Focus された場合の処理、modal を表示する場合などに使用
            if (pd.state) { // clds ではない場合
              pd.onFcs();
            }
            else { // clds の場合＋（sch等の）通常の入力欄の場合
              pd.onFcs(_s_val, pd.d_ids);
            };
          };
        };

        const _o_onLayout = () => {
          if (bf.f(_so_textInput) && pd.b_fcs == true) {
            _so_textInput.focus();
          };
          if (pd.onLay) {
            pd.onLay();
          };
        };

        const _stlTextInput = {
          width: (pd.n_col) ? (pd.n_col * ic.gn_fontSizeNrm) : ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ((pd.n_lyr || 1)- 1) * ic.gn_fontSizeNrm * 2 - ic.gn_mgnNrm * 2,
          color: ic.g_fontCcdNrm,
          fontSize: ic.gn_fontSizeNrm,
          borderWidth: ic.gn_bdrWNrw * 1.5,
          borderColor: (pd.b_edt == true) ? ic.g_bdrCcd : 'transparent',
          borderRadius: ic.gn_bdrRdsNrm,
          marginLeft: ((pd.n_lyr || 1) > 1) ? 'auto' : 0,
          marginRight: 0,
          paddingTop: ic.gn_mgnNrm,
          paddingBottom: ic.gn_mgnNrm,
          paddingLeft: ic.gn_mgnNrm,
          paddingRight: ic.gn_mgnNrm,
          borderRadius: (pd.b_mln || pd.b_bdr != false) ? ic.gn_bdrRdsNrm : 0,
          minHeight: ((pd.b_mln) ? ic.gn_fontSizeNrm * 3 : ic.gn_fontSizeNrm) + ic.gn_mgnNrm * 2 + ic.gn_mgnNrm * 2,
          textAlign: 'left',
          textAlignVertical: (cf.myRN_chk_os('a') && pd.b_mln) ? 'top' : null,
        };

        return (
          <View
            key={-1}
            style={[{
              width: (pd.n_col) ? (pd.n_col * ic.gn_fontSizeNrm) : ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
              maxWidth: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
              marginTop: ic.gn_mgnNrm,
              marginBottom: ic.gn_mgnNrm,
              marginLeft: (pd.n_col) ? ic.gn_mgnNrm : 'auto',
              marginRight: (pd.n_col) ? 0 : 'auto',
            }, pd.stlCta]}
          >
            <View 
              key={-1}
              style={ [{
              }]}
            >
                { (pd.pfx) ?
                  <ce.Lbl
                    key={-1}
                    pfx={pd.pfx}
                    stlPfx={pd.stlLbl}
                  />
                : null }
                { (pd.b_edt) ? 
                  <TextInput
                    key={-2}
                    editable={pd.b_edt}
                    placeholder={pd.phd}
                    multiline={pd.b_mln}
                    selectTextOnFocus={true}
                    style={[_stlTextInput, pd.stlInp]}
                    ref={(_o) => {
                      _setTextInput(_o);
                    }}
                    value={_s_val}
                    onBlur={_o_onBlur}
                    onChangeText={_o_onChangeText}
                    onContentSizeChange={_o_onContentSizeChange}
                    onFocus={_o_onFocus}
                    onLayout={_o_onLayout}
                    keyboardType={pd.kbdType}
                  />
                :
                  <TouchableOpacity
                    onPress={() => {
                      if (pd.onPrs) {
                        if (pd.state) {
                          pd.onPrs();
                        }
                        else {
                          pd.onPrs(pd.d_ids);
                        };
                      };
                    }}
                  >
                    <Text
                      style={[_stlTextInput, pd.stlInp]} >{_s_val}</Text>
                  </TouchableOpacity>
                }
                { (pd.d_btnDefs?.onBtnPrs) ?
                  <ce.BtnIcon
                    key={-3}
                    b_vsb={true}
                    iconName={pd.d_btnDefs?.btnIconName}
                    onPrs={()=>{
                      if (pd.d_btnDefs?.onBtnPrs) {
                        pd.d_btnDefs?.onBtnPrs(pd.d_ids);
                      };
                    }}
                    stlCta={{
                        position: 'absolute',
                        top: ic.gn_mgnNrm + ic.gn_bdrWNrw * 1.5 / 2, // boderWidth 分を追加
                        right: (pd.d_btnDefs?.onDltPrs) ? (ic.gn_mgnNrm + ic.gn_btnIconSize + ic.gn_mgnNrm) : ic.gn_mgnNrm,
                        backgroundColor: ic.gn_backCcd,
                    }}
                  />
                : null }
                { (pd.d_btnDefs?.onDltPrs) ?
                  <ce.BtnIcon
                    key={-4}
                    b_vsb={true}
                    iconName={'trash'}
                    onPrs={()=>{
                      if (pd.d_btnDefs?.onDltPrs) {
                        pd.d_btnDefs?.onDltPrs(pd.d_ids);
                      };
                    }}
                    stlCta={{
                        position: 'absolute',
                        top: ic.gn_mgnNrm + ic.gn_bdrWNrw * 1.5 / 2, // boderWidth 分を追加
                        right: ic.gn_mgnNrm,
                        backgroundColor: ic.gn_backCcd,
                    }}
                  />
                : null }
                { (pd.sfx) ?
                  <Text
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      right: 0,
                      color: ic.g_ccdHN
                    }}
                  >{pd.sfx}</Text>
                : null }
            </View>
            { (pd.d_btnDefs?.onHdrPrs) ?
              <ce.BtnIcon
                key={-2}
                b_vsb={true}
                iconName={pd.d_btnDefs?.hdrIconName}
                onPrs={()=>{
                  if (pd.d_btnDefs?.onHdrPrs) {
                    pd.d_btnDefs?.onHdrPrs(pd.d_ids);
                  };
                }}
                stlBtn={{
                  backgroundColor: ic.gn_backCcd,
                }}
                stlCta={{
                  position: 'absolute',
                  top: ic.gn_mgnNrm +  ic.gn_mgnNrm,
                  left: ic.gn_mgnNrm * (ic.gn_btnIconSize + ic.gn_mgnNrm) * ((pd.n_lyr || 1) - 1),
                  backgroundColor: ic.gn_backCcd,
                }}
              />
            : null }
          </View>
        );
    }
*/

static Inp (pd) {

    const [_so_textInput, _setTextInput] = useState(null);
    const [_s_val, _setVal] = useState('');
//    const [_s_h, _setH] = useState(0);

    useEffect(()=>{
      if (global.c?.state[pd.state] || global.c?.state[pd.state] == ''){ // 空白の場合に更新が反映されないことを考慮
//        _setVal((pd.o_stlVal) ? pd.o_stlVal({mode: 'on', val: global.c?.state[pd.state]}) : global.c?.state[pd.state]);
        _setVal(global.c?.state[pd.state]);
        if (pd.onChg) {
          pd.onChg(global.c?.state[pd.state]);
        }
      };
    }, [global.c?.state[pd.state]]);

    useEffect(()=>{
      if (bf.f(pd.ctlVal)){ // 空白の場合に更新が反映されないことを考慮
        if (bf.f(pd.state)) { // clds でない state が指定されている場合
          global.c?.setState({
            [pd.state]: _ctlVal
          });
        }
        else { // clds であり state が指定されていない場合
//          _setVal((pd.o_stlVal) ? pd.o_stlVal({mode: 'on', val: pd.ctlVal}) : pd.ctlVal);
          _setVal(pd.ctlVal);
          if (pd.onChg) {
            pd.onChg(pd.ctlVal, pd.d_ids);
          }
        }
      };
    }, [pd.ctlVal]);

    if (pd.b_vsb == false) {
        return null;
    }

    const _o_onBlur = () => {
//bf.l('2316: here')
/*
      new Promise( _o_end1 => {
        if (pd.o_stlVal) { // comma の設定
          _setVal(pd.o_stlVal({mode:'on', val: _s_val}), () => {
            _o_end1();
          });
        }
        else {
          _o_end1();
        };
      })
      .then(() => {
*/
/*
        global.c?.setState({
          sgcd_msrs: {x:pageX, y:pageY, w:width, h:height, ox:originX, oy:originY},
          dy: 0,
        }, () => {
        });
*/
          if (pd.state) { // clds ではない場合
            if (pd.onBlur) {
              pd.onBlur(_s_val);
            };
          }
          else { // clds の場合＋（sch等の）通常の入力欄の場合
            if (pd.onBlur) {
              pd.onBlur(_s_val, pd.d_ids);
            };
          };
//      });
    };

    const _o_onChangeText = (_s) => {
      if (_s != _s_val) { // 値に変更のあった場合
        if (pd.n_maxCnt > 0 && bf.myCM_cnv('bytes', _s) > pd.n_maxCnt) {
          _s = bf.myCM_substr(_s, pd.n_maxCnt);
          alert('半角{}文字まで入力できます'.f(pd.n_maxCnt))
        }
        _setVal(_s);
        if (pd.state) { // clds ではない場合
          global.c?.setState({ // 外部からの更新を考慮し、onChg は useEffect で実行
            [pd.state]: _s
          }, ()=>{
          });
        }
        else { // clds の場合＋（sch等の）通常の入力欄の場合
          if (pd.onChg) {
            pd.onChg(_s, pd.d_ids);
          }
        };
        if (_so_textInput) {
          _so_textInput.measure((originX, originY, width, height, pageX, pageY) => { // 選択した inp の位置を保存
            global.c?.setState({
              sgcd_msrs: {x:pageX, y:pageY, w:width, h:height, ox:originX, oy:originY},
            });

          })
        };
      };
    };

    const _o_onContentSizeChange = (_e) => { // PCでは不要な処理のため、keyboard が表示されたときの配置調整は、textinput ではなく、画面ごとに行う
      if (_so_textInput) {
        _so_textInput.measure((originX, originY, width, height, pageX, pageY) => { // 選択した inp の位置を保存
          global.c?.setState({
            sgcd_msrs: {x:pageX, y:pageY, w:width, h:height, ox:originX, oy:originY},
          }, () => {
/*
            if ((pd.n_maxCnt ?? 0) == 0 || (pd.n_maxCnt > 0 && bf.myCM_cnv('bytes', _s_val) <= pd.n_maxCnt)) { // 最大文字数までは高さを自動調整
              _setH(height);
            };
*/
          });

/*
          global.c?.setState({
            sgcdd_ptnss: bf.p( global.c?.state.sgcdd_ptnss, _next => {
              _next.d_msrs = {x:pageX, y:pageY, w:width, h:height, ox:originX, oy:originY};
            }),
          }, () => {
bf.l('2411: {}'.f(global.c?.state.sgcdd_ptnss))
//            cf.myRN_adjPtn({ctr: 'set'});
          });
*/

        })
      };
    };

    const _o_onFocus = (_e) => { // PCでは不要な処理のため、keyboard が表示されたときの配置調整は、textinput ではなく、画面ごとに行う
//bf.l('2463: onFocus')
/*
      if (pd.o_stlVal) { // comma の解除
        _setVal(pd.o_stlVal({mode:'off', val:_s_val}));
      };
*/
      if (_so_textInput) {
        _so_textInput.measure((originX, originY, width, height, pageX, pageY) => { // 選択した inp の位置を保存
          global.c?.setState({
            sgcd_msrs: {x:pageX, y:pageY, w:width, h:height, ox:originX, oy:originY},
//            dy: 150,
//            sgcn_srl: pageY + height,
          }, () => {
//bf.l('2492: {}'.f(global.c?.state.sgcn_srl))
          });

/*
          global.c?.setState({
            sgcdd_ptnss: bf.p( global.c?.state.sgcdd_ptnss, _next => {
              _next.d_msrs = {x:pageX, y:pageY, w:width, h:height, ox:originX, oy:originY};
            }),
          }, () => {
bf.l('2436: {}'.f(global.c?.state.sgcdd_ptnss))
//            cf.myRN_adjPtn({ctr: 'set'});
          });
*/
        })
      };
      if (pd.onFcs) { // Focus された場合の処理、modal を表示する場合などに使用
        if (pd.state) { // clds ではない場合
          pd.onFcs();
        }
        else { // clds の場合＋（sch等の）通常の入力欄の場合
          pd.onFcs(_s_val, pd.d_ids);
        };
      };
    };

    const _o_onLayout = () => {
      if (bf.f(_so_textInput) && pd.b_fcs == true) {
        _so_textInput.focus();
      };
      if (pd.onLay) {
        pd.onLay();
      };
    };

/*
    const _o_onSelectionChagen = (_evt) => {
      let _n_end = _evt.nativeEvent.selection.end ?? 0; // 現在のカーソル位置
      let _n_cnt = String(_s_val).substr(0,_n_end).match(/\n/g)?.length ?? 0; // 現在のカーソル位置までの改行数
//      let _n_ptn = (_n_cnt + 1) * ic.gn_fontSizeNrm + ic.gn_mgnNrm + ic.gn_bdrWNrw * 1.5
      let _n_ptn = (_n_cnt + 1) * (ic.gn_fontSizeNrm + ic.gn_mgnNrm) + ic.gn_bdrWNrw * 1.5
bf.l('2501: {}, {}'.f(_n_cnt, _n_ptn))
      if (global.c?.state.sgcd_msrs.y == undefined) return;
//      let _dy = (po_this?.state.sgcd_msrs.y + po_this?.state.sgcd_msrs.h) - (ic.gn_h - _e.endCoordinates.screenY);
      let _dy = (global.c?.state.sgcd_msrs.y + _n_ptn) - (ic.gn_h - global.c?.state.sgcd_kbds.screenY);
      if (_dy <= 0) _dy = 0; // 下側が被った場合のみが対象
      if (_dy >= global.c?.state.sgcd_kbds.height) _dy = global.c?.state.sgcd_kbds.height; // キーボード分のみが対象
      global.c?.setState({
        sgcn_bdyY: ic.gn_bdyY - _dy - global.c?.state.sgcn_adjY,
//        sgcn_hdrY: global.c?.state.sgcd_kbds.height - global.c?.state.sgcd_msrs.h - ic.gn_mgnNrm,
        sgcn_hdrY: global.c?.state.sgcd_kbds.height - _n_ptn - ic.gn_mgnNrm,
      });

      global.c?.setState({
        sgcn_csrs: _n_ptn
      }, () => {
bf.l('2471: {}'.f(global.c?.state.sgcdd_ptnss))
//        cf.myRN_adjPtn({ctr: 'set'});
      });
    }; 
*/

    const _stlTextInput = {
      width: (pd.n_col) ? (pd.n_col * ic.gn_fontSizeNrm) : ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ((pd.n_lyr || 1)- 1) * ic.gn_fontSizeNrm * 2 - ic.gn_mgnNrm * 2,
      color: ic.g_fontCcdNrm,
      fontSize: ic.gn_fontSizeNrm,
      borderWidth: ic.gn_bdrWNrw * 1.5,
      borderColor: (pd.b_edt == true) ? ic.g_bdrCcd : 'transparent',
      borderRadius: ic.gn_bdrRdsNrm,
      marginLeft: ((pd.n_lyr || 1) > 1) ? 'auto' : 0,
      marginRight: 0,
      paddingTop: ic.gn_mgnNrm,
      paddingBottom: ic.gn_mgnNrm,
      paddingLeft: ic.gn_mgnNrm,
      paddingRight: ic.gn_mgnNrm,
      borderRadius: (pd.b_mln || pd.b_bdr != false) ? ic.gn_bdrRdsNrm : 0,
      minHeight: ((pd.b_mln) ? ic.gn_fontSizeNrm * 3 : ic.gn_fontSizeNrm) + ic.gn_mgnNrm * 2 + ic.gn_mgnNrm * 2,
//      height: _s_h,
      textAlign: 'left',
      textAlignVertical: (cf.myRN_chk_os('a') && pd.b_mln) ? 'top' : null,
    };

/*
              <TouchableOpacity
                onPress={() => {
                  if (pd.onPrs) {
                    if (pd.state) {
                      pd.onPrs();
                    }
                    else {
                      pd.onPrs(pd.d_ids);
                    };
                  };
                }}
              >
                <Text
                  style={[_stlTextInput, pd.stlInp]} >{(pd.o_stlVal) ? pd.o_stlVal(_s_val) : _s_val}</Text>
              </TouchableOpacity>

                onBlur={_o_onBlur}

                onSelectionChange={_evt=>{
bf.l('2511: {}'.f(_evt.nativeEvent.selection))
                }}

                onSelectionChange={_o_onSelectionChagen}
                scrollEnabled={false}

                returnKeyType={'done'}
                onSubmitEditing={() => {
alert('2620: here')
                }}
                showSoftInputOnFocus={true}

*/

    return (
      <View
        key={-1}
        style={[{
          width: (pd.n_col) ? (pd.n_col * ic.gn_fontSizeNrm) : ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
          maxWidth: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
          marginTop: ic.gn_mgnNrm,
          marginBottom: ic.gn_mgnNrm,
          marginLeft: (pd.n_col) ? ic.gn_mgnNrm : 'auto',
          marginRight: (pd.n_col) ? 0 : 'auto',
        }, pd.stlCta]}
      >
        <View 
          key={-1}
          style={ [{
          }]}
        >
            { (pd.pfx) ?
              <ce.Lbl
                key={-1}
                pfx={pd.pfx}
                stlPfx={pd.stlLbl}
              />
            : null }
            { (pd.b_edt) ? 
              <TextInput
                key={-2}
                editable={pd.b_edt}
                placeholder={pd.phd}
                multiline={pd.b_mln}
                selectTextOnFocus={true}
                style={[_stlTextInput, pd.stlInp]}
                ref={(_o) => {
                  _setTextInput(_o);
                }}
                value={_s_val}
                onBlur={_o_onBlur}
                onChangeText={_o_onChangeText}
                onContentSizeChange={_o_onContentSizeChange}
                onFocus={_o_onFocus}
                onLayout={_o_onLayout}
                keyboardType={pd.kbdType ?? 'default'}
              />
            : (pd.onPrs) ?
              <TouchableOpacity
                onPress={() => {
                  if (pd.state) {
                    pd.onPrs();
                  }
                  else {
                    pd.onPrs(pd.d_ids);
                  };
                }}
              >
                <Text
                  style={[_stlTextInput, pd.stlInp]} >{(pd.o_stlVal) ? pd.o_stlVal(_s_val) : _s_val}</Text>
              </TouchableOpacity>
            :
              <Text
                style={[_stlTextInput, pd.stlInp]} >{(pd.o_stlVal) ? pd.o_stlVal(_s_val) : _s_val}</Text>
            }
            { (pd.d_btnDefs?.onBtnPrs) ?
              <ce.BtnIcon
                key={-3}
                b_vsb={true}
                iconName={pd.d_btnDefs?.btnIconName}
                onPrs={()=>{
                  if (pd.d_btnDefs?.onBtnPrs) {
                    pd.d_btnDefs?.onBtnPrs(pd.d_ids);
                  };
                }}
                stlCta={[{
                    position: 'absolute',
                    top: (pd.b_mln) ? null : ic.gn_mgnNrm + ic.gn_bdrWNrw * 1.5 / 2, // boderWidth 分を追加
                    bottom: (pd.b_mln) ? ic.gn_mgnNrm : null, // b_mln の場合は下端に表示
                    right: (pd.d_btnDefs?.onDltPrs) ? (ic.gn_mgnNrm * 3 + ic.gn_btnIconSize + ic.gn_mgnNrm) : ic.gn_mgnNrm,
                    backgroundColor: ic.gn_backCcd,
                }, pd.d_btnDefs?.btnStlCta]}
              />
            : null }
            { (pd.d_btnDefs?.onDltPrs) ?
              <ce.BtnIcon
                key={-4}
                b_vsb={true}
                iconName={'trash'}
                onPrs={()=>{
                  if (pd.d_btnDefs?.onDltPrs) {
                    pd.d_btnDefs?.onDltPrs(pd.d_ids);
                  };
                }}
                stlCta={{
                    position: 'absolute',
                    top: (pd.b_mln) ? null : ic.gn_mgnNrm + ic.gn_bdrWNrw * 1.5 / 2, // boderWidth 分を追加
                    bottom: (pd.b_mln) ? ic.gn_mgnNrm : null, // b_mln の場合は下端に表示
                    right: ic.gn_mgnNrm,
                    backgroundColor: ic.gn_backCcd,
                }}
              />
            : null }
            { (pd.sfx) ?
              <Text
                style={[{
                  position: 'absolute',
                  bottom: 0,
                  right: 0,
                  color: ic.g_ccdHN,
                  fontSize: ic.gn_fontSizeSml,
                  textAlign: 'right',
                }, pd.stlSfx]}
              >{pd.sfx}</Text>
            : null }
        </View>
        { (pd.d_btnDefs?.onHdrPrs) ?
          <ce.BtnIcon
            key={-2}
            b_vsb={true}
            iconName={pd.d_btnDefs?.hdrIconName}
            onPrs={()=>{
              if (pd.d_btnDefs?.onHdrPrs) {
                pd.d_btnDefs?.onHdrPrs(pd.d_ids);
              };
            }}
            stlBtn={{
              backgroundColor: ic.gn_backCcd,
            }}
            stlCta={{
              position: 'absolute',
              top: ic.gn_mgnNrm +  ic.gn_mgnNrm,
              left: ic.gn_mgnNrm * (ic.gn_btnIconSize + ic.gn_mgnNrm) * ((pd.n_lyr || 1) - 1),
              backgroundColor: ic.gn_backCcd,
            }}
          />
        : null }
      </View>
    );
}


  static Lbl (pd) {
    if (pd.b_vsb == false) {
      return null;
    };

    return (
      <View
        key={(pd.idx) ? pd.idx : -1}
        style={[{
          height: ic.gn_fontSizeSml + ic.gn_mgnNrm * 2,
//          width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
          width: (pd.n_col) ? (pd.n_col * ic.gn_fontSizeNrm) : (((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW),
          maxWidth: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
          marginTop: ic.gn_mgnNrm,
          marginBottom: ic.gn_mgnNrm,
          marginLeft: (pd.n_col) ? ic.gn_mgnNrm : 'auto',
          marginRight: (pd.n_col) ? 0 : 'auto',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }, pd.stlCta]}
      >
        <TouchableOpacity
          key={-1}
          onPress={pd.onBtnPrs}
        >
          <Text 
            key={-1}
            style={[{
  //              height: ic.gn_fontSizeSml + ic.gn_mgnNrm * 2,
              fontSize: ic.gn_fontSizeSml,
              color: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
  //              paddingTop: ic.gn_mgnNrm,
  //              paddingBottom: ic.gn_mgnNrm,
              paddingTop: 'auto',
              paddingBottom: 'auto',
              paddingLeft: 0,
              paddingRight: 0,
              fontWeight: 'bold',
            }, pd.stlPfx]}
          >
            { pd.pfx }
          </Text>
        </TouchableOpacity>
        <ce.BtnIcon
          key={-2}
          b_vsb={(pd.b_btnVsb != false && pd.onBtnPrs) ? true : false}
          iconName={(pd.iconName) ? pd.iconName : 'ellipsis-v'}
          onPrs={pd.onBtnPrs}
          stlCta={{
            position: 'absolute',
//                                top: 0,
                                top: ic.gn_btnIconSize * (1.0 - 0.6) / 2,
//                                right: 0,
//            top: ic.gn_mgnNrm,
            right: ic.gn_mgnNrm,
          }}
          stlBtn={{
            height: ic.gn_btnIconSize * 0.6,
            width: ic.gn_btnIconSize * 0.6,
            backgroundColor: ic.g_bdyCcd,
          }}
          stlIcon={[{
            color: '#555555',
          }, pd.stlIcon]}
        />
      </View>
    );
  }
/*
        <View
          key={-1}
          style={{
//            height: ic.gn_fontSizeSml + ic.gn_mgnNrm * 2,
//            width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW - (ic.gn_fontSizeLrg + ic.gn_mgnNrm * 2),
            marginTop: 'auto',
            marginBottom: 'auto',
          }}
        >
        </View>
 */

    static Chb(pd) {
        //
        const [_sb_val, _setVal] = useState(false);
        useEffect(()=>{
            _setVal(pd.val);
        }, [pd.b_val])
        //
        return (
            <>
                { (pd.b_vsb) ?
                    <View
                        style={[{
                        }, pd.stlCta]}
                    >
                        <CheckBox 
                            disabled={false}
                            value={_sb_val}
                            onChange={()=>{
                                let _b_val = !_sb_val;
                                _setVal(_b_val);
                                if (pd.onChg) {
                                    pd.onChg(_b_val);
                                };
                            }}
                        />
                    </View>
                : null }
            </>
        );
    };

static Chk = pd => { // checkbox

  const [_sb_val, _setVal] = useState(pd.b_val ?? false);

  useEffect(() => {
    _setVal(pd.b_val ?? false)
  }, [pd.b_val])

  return (
    ce.c(TouchableOpacity, {
      key: 'Chk',
      onPress: () => {
//bf.l('2896: here')
        if (pd.b_edt != false) {
          let _b_val = !_sb_val; // 同時並行で処理するために必要
          _setVal(_b_val);
//bf.l('2899: here')
          if (pd.o_onPrs) pd.o_onPrs(_b_val);
        };
      },
      style: [{
        width: ic.gn_fontSizeNrm + ic.gn_bdrWNrm,
        marginTop: 'auto',
        marginBottom: 'auto',
        flexDirection: 'column',
        jusityContent: 'center',
        alignItems: 'center',
      }, pd.stlCta]
    }, [
      ce.c(View, {
        key: '-1',
        style: {
          height: ic.gn_fontSizeNrm,
          width: ic.gn_fontSizeNrm,
//          borderColor: (pd.b_edt != false) ? ic.g_fontCcdNrm: 'lightgray',
          borderColor: (pd.b_edt != false) ? ic.g_fontCcdNrm: ic.g_ccdWN,
          borderWidth: ic.gn_bdrWNrm,
          backgroundColor: (_sb_val) ? ic.g_fontCcdNrm : null,
          borderRadius: ic.gn_fontSizeNrm / 2,
        },
      })
    ])
  );
}

    static Clds(pd) {
      //
      if (pd.b_vsb == false) {
        return null;
      };
      //
      let _r = [];
      //
      const [_sld_sortss, _setSortss] = useState([]); // 並び順の項目 [{fld:'', dtn:'asc/desc/none'}]

      useEffect(() => { // 並び順の変更
        global.c?.setState({
          [pd.state]: bf.myCM_sort({
            ld_itemss: global.c?.state[pd.state], 
            ld_sortss: _sld_sortss,
          }), 
        });
      }, [_sld_sortss]);

      for (let [_defKey, _d_defs] of bf.e(pd.dd_defss)) { // 二重上書きを防ぐため別出し

        let _onFcs = _d_defs.onFcs;
        _d_defs.onFcs = (pa_vals, pd_ids) => { // pd_ids は clds の二重登録を防ぐために必要（？）
          if (bf.f(_onFcs)){
            _onFcs(bf.p(pd_ids, _next => {
              _next.val = pa_vals;
            }));
          };
        };

/*
        let _onChg = _d_defs.onChg;
        _d_defs.onChg = (pa_vals, pd_ids) => { // pd_ids は clds の二重登録を防ぐために必要（？）
          let _pastVal = null;
          if (
            bf.f(pd.state) && 
            bf.f(pd_ids) && 
            bf.f(global.c?.state[pd.state]) &&
            bf.f(global.c?.state[pd.state][pd_ids.idx]) &&
            bf.f(global.c?.state[pd.state][pd_ids.idx][pd_ids.fld])
          ){
            _pastVal = global.c?.state[pd.state][pd_ids.idx][pd_ids.fld];
          };

          let _nextVal = (pa_vals.key) ? pa_vals.key : pa_vals;

          if (bf.f(_onChg)){ // onBlur が実行されていない場合、pd_ids.idx は new のままである
            _onChg(bf.p(pd_ids, _next => {
              _next.next = _nextVal;
              _next.past = _pastVal;
            }));
          };
        };
*/
        let _onChg = _d_defs.onChg;
        _d_defs.onChg = (pa_vals, pd_ids) => { // Pck を考慮し、pd.state への push および idx の設定は Chg で実施要
//alert('2251:clds:here')
          let _pastVal = null;
          if (
            bf.f(pd.state) && 
            bf.f(pd_ids) && 
            bf.f(global.c?.state[pd.state]) &&
            bf.f(global.c?.state[pd.state][pd_ids.idx]) &&
            bf.f(global.c?.state[pd.state][pd_ids.idx][pd_ids.fld])
          ){
            _pastVal = global.c?.state[pd.state][pd_ids.idx][pd_ids.fld];
          };

          let _nextVal = (pa_vals.key) ? pa_vals.key : pa_vals;

          if (_nextVal != _pastVal) { // 値が変更されている場合
            global.c?.setState({
              [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                let _idx = pd_ids.idx;
                if (_idx != 'new') { // 既存データの場合, 0 の場合 else となるため、undefined や null でることを確認 
                  _next[_idx][pd_ids.fld] = _nextVal;
//                  _next[_idx].b_dlt = false;
//                  _next[_idx].b_ups = true;
//                  _next[_idx].b_upd = true;
//                  _next[_idx].b_ins = false;
//                  _next[_idx].mode = 'upd';
                  _next[_idx].mode = ( _next[_idx].mode == 'ins' ) ? 'ins' : 'upd';
                }
                else { // 新規データの場合
/*
                  _next.push({
                    '_KEY': pd_ids.key,
                    [pd_ids.fld]: _nextVal,
                    mode: 'ins',
                  });
*/
                  let _d = {
                    '_KEY': pd_ids.key,
                    [pd_ids.fld]: _nextVal,
                    mode: 'ins',
                  };
                  if ( pd.d_insDats ) _d = bf.c(pd.d_insDats, _d);                    
                  _next.push(_d);
                };
              }),
            }, () => {
              if (bf.f(_onChg)){
                _onChg(bf.p(pd_ids, _next => {
                  _next.idx = (pd_ids.idx == 'new') ? bf.myCM_get_len(global.c?.state[pd.state])-1 : pd_ids.idx;
                  _next.next = _nextVal;
                  _next.past = _pastVal;
//bf.l('2289:{}'.f(_next))
                }));
              };
            });
          };
        };

        // onChg によって pastVal が 常に更新されるため、onBlur の場合に nextVal と pastVal が異なることはありえない
        let _onBlur = _d_defs.onBlur;
        _d_defs.onBlur = (pa_vals, pd_ids) => { // Pck を考慮し、push および idx の設定は Chg で実施要
          //
          let _pastVal = null;
          if (
            bf.f(pd.state) && 
            bf.f(pd_ids) && 
            bf.f(global.c?.state[pd.state]) &&
            bf.f(global.c?.state[pd.state]) &&
            bf.f(global.c?.state[pd.state][pd_ids.idx]) &&
            bf.f(global.c?.state[pd.state][pd_ids.idx][pd_ids.fld])
          ){
            _pastVal = global.c?.state[pd.state][pd_ids.idx][pd_ids.fld];
          };

          let _nextVal = (pa_vals.key) ? pa_vals.key : pa_vals;


//alert('2312:{}, {}, {}'.f(pd_ids, _nextVal, _pastVal))
//          if (_nextVal != _pastVal) { // 値が変更されている場合
/*
            global.c?.setState({
              [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                let _idx = pd_ids.idx;
                if (_idx != 'new') { // 既存データの場合, 0 の場合 else となるため、undefined や null でることを確認 
                  _next[_idx][pd_ids.fld] = _nextVal;
                  _next[_idx].b_dlt = false;
                  _next[_idx].b_ups = true;
                }
                else { // 新規データの場合
                  _next.push({
                    '_KEY': pd_ids.key,
                    [pd_ids.fld]: _nextVal,
                    b_dlt: false,
                    b_ups: true,
                  });
                };
              }),
            }, () => {
              if (bf.f(_onBlur)){
                _onBlur(bf.p(pd_ids, _next => {
                  _next.idx = (pd_ids.idx == 'new') ? bf.myCM_get_len(global.c?.state[pd.state])-1 : pd_ids.idx;
                  _next.next = _nextVal;
                  _next.past = _pastVal;
//bf.l('2289:{}'.f(_next))
                }));
              };
            });
*/
            if (bf.f(_onBlur)){
              _onBlur(bf.p(pd_ids, _next => {
                _next.idx = (pd_ids.idx == 'new') ? bf.myCM_get_len(global.c?.state[pd.state])-1 : pd_ids.idx;
                _next.next = _nextVal;
                _next.past = _pastVal;
  //bf.l('2289:{}'.f(_next))
              }));
            };
//          };
        };

//        if (pd.b_dlt == true) {
        if (_d_defs.b_dlt == true) { // 複数項目ある場合を考慮
          let _onDltPrs = _d_defs.onDltPrs;
          _d_defs.onDltPrs = (pd_ids) => { // pd_ids は clds の二重登録を防ぐために必要（？）
            global.c?.setState({
              [pd.state]: bf.p(global.c?.state[pd.state], _next => {
/*
                let _idx = bf.myCM_get_dct({
                  mode: 'idx',
                  ld_itemss: global.c?.state[pd.state], 
                  fld: '_KEY', 
                  val: pd_ids.key
                });
                _next[_idx].b_dlt = true;
*/
//                _next[pd_ids.idx].b_dlt = true;
                _next[pd_ids.idx].mode = 'dlt';
              }),
            }, () => {
              if (bf.f(_onDltPrs)){
                _onDltPrs(pd_ids);
              };
            });
          };
        };
      };
      //
      let _i = 0;
      //
      if (bf.myCM_get_len(pd.dd_defss) == 1) { // 単一項目の場合
        _r.push(ce._elm({
          type:'Lbl',
          b_vsb: true,
          pfx: '{}'.f(pd.pfx),
          iconName: null,
          onBtnPrs: null,
          stlCta: null,
          stlPfx: null,
        }, '{}.Lbl'.f('cmn')));
      };
      
      if (pd.b_ttl == false) { // 個別行にタイトルを表示しない場合
        let _r2 = [];

        if (pd.b_withNo) {
          _r2.push(
            ce._elm({
              type:'Lbl',
              b_vsb: true,
              pfx: '番号',
              n_col: 3,
            }, '-1.No')
          );
        }

        for (let [_defKey, _d_defs] of bf.e(pd.dd_defss)) {
          _r2.push(ce._elm({
            type:'Lbl',
            b_vsb: true,
            pfx: _d_defs.pfx, // pd.pfx に {} が存在する場合に _i を出力
            b_btnVsb: (bf.i({fld:_defKey, dtn:'asc'}, _sld_sortss) || bf.i({fld:_defKey, dtn:'desc'}, _sld_sortss)) ? true : false,
            iconName:
              bf.i({fld:_defKey, dtn:'asc'}, _sld_sortss) ? 
                'chevron-down' 
              : 
                bf.i({fld:_defKey, dtn:'desc'}, _sld_sortss) ? 
                  'chevron-up'
                :
                  'minus'
//                  null
            ,
            onBtnPrs: () => {
              if (_d_defs.d_btnDefs?.onLblBtnPrs) {
                _d_defs.d_btnDefs?.onLblBtnPrs({fld: _defKey});
              }
              else {
                if (!bf.f(_sld_sortss)) {
                  _setSortss([{
                    fld: _defKey,
                    dtn: 'asc',
                  }]);
                }
                else {
                  _setSortss(bf.p(_sld_sortss, _next => {
                    let _idx = 0;
                    if (_next[_idx].fld == _defKey) {
//                      _next[_idx].dtn = (_next[_idx].dtn == 'asc') ? 'desc': ((_next[_idx].dtn == 'desc') ? 'none' : 'asc');
                      _next[_idx].dtn = (_next[_idx].dtn == 'asc') ? 'desc': 'asc';
                    }
                    else {
                      _next[_idx].fld = _defKey;
                      _next[_idx].dtn = 'asc';
                    }
                  }));
                }
              };
            },
            stlCta: null,
            stlPfx: null,
/*
            stlBtn: {
              height: ic.gn_btnIconSize / 2,
              width: ic.gn_btnIconSize / 2,
            },
*/
            n_col: _d_defs.n_col
          }, 'ttl.{}'.f(_defKey)));
        }
        _r.push(
          <View
            key={'ttl'}
            style={{
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
//              alignItems: 'flex-start',
              alignItems: 'center',
              backgroundColor: ic.g_ccdWN, // ScrollView の stickyHeaderIndices を考慮し、背景色を固定
            }}
          >
            {_r2}
          </View>
        );
      } 

//      if (pd.b_wotData != true) { //  without data
      for (let [_itemIdx, _d_items] of bf.e(global.c?.state[pd.state])) {

//        if (_d_items.b_dlt == true) { // 削除対象の場合
        if (_d_items.mode == 'dlt') { // 削除対象の場合
          continue;
        }

        if (pd.b_wotData == true && '{}'.f(_d_items['_KEY']).substr(0,3) != 'new') { //  without data の場合、new 以外は表示対象外
          continue;
        };

        _i += 1;

        if (pd.b_spr != false && bf.myCM_get_len(pd.dd_defss) > 1) { // 複数項目の場合
          _r.push(ce._elm({
            type:'Spr',
          }, '{}.Spr'.f(_d_items._KEY)));
          if (pd.b_ttl != false) {
            _r.push(ce._elm({
              type:'Lbl',
              b_vsb: true,
              pfx: '{}'.f(pd.pfx).f2(_d_items).f(_i), // pd.pfx に {} が存在する場合に _i を出力
              iconName: null,
              onBtnPrs: null,
              stlCta: null,
              stlPfx: null,
            }, '{}.Lbl'.f(_d_items._KEY)));
          }
        };

        let _r2 = [];

        if (pd.b_withNo) {
          _r2.push(
            ce._elm({
              type:'Inp',
              b_vsb: true,
              b_edt: false,
              pfx: '',
              ctlVal: '{}'.f(_itemIdx+1), // pd.pfx に {} が存在する場合に _i を出力
              n_col: 3,
            }, '{}.No'.f(_d_items._KEY))
          );
        }

        for (let [_defKey, _d_defs] of bf.e(pd.dd_defss)) {

          let _d = bf.myCM_copy(_d_defs); // _d_defs そのものを更新しないために

          _d.pfx = (pd.b_ttl != false) ? _d.pfx : ''; // title の表示 

//          _d.ini = _d_items[_defKey];
          _d.ini = _d_items[_defKey] || _d_defs.ini || '';

          _d.d_ids = {
            idx: _itemIdx,
            key: _d_items._KEY, 
            fld: _defKey
          };  // clds の二重登録を防ぐために必要

          if (
            global.c?.state[pd.state] && 
            _d.d_ids && 
            _d.d_ids.key && 
            _d.d_ids.fld
          ) {
              _d.ctlVal = _d_items[_d.d_ids.fld];
          }
          else {
            _d.ctlVal = null;
          };

          _d.pfx = _d.pfx.f2(_d_items);

          if (_d.ob_edt) {
            _d.b_edt = _d.ob_edt(_d.d_ids);
          };

          if (_d_defs.do_stlInps) {
            _d.stlInp = _d_defs.do_stlInps({
              idx: _itemIdx, 
              key: _d_items._KEY,
              fld: _defKey,
              d_vals: _d_items,
            });
          }

          _r2.push(
            ce._elm(
              _d, 
              '{}.{}'.f(
                _d.d_ids.key, 
                _d.d_ids.fld
              )
            )
          );

        };
        _r.push(
          <View
            key={_itemIdx}
            style={[{
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
//              alignItems: 'flex-start',
              alignItems: 'center',
//              backgroundColor: ic.g_ccdAP,
            }, (pd.do_stlRows) ? pd.do_stlRows({
              idx: _itemIdx, 
              key: _d_items._KEY,
              d_vals: _d_items,
            }) : null]}
          >
            {_r2}
          </View>
        );
      };
//    };

      //
      if (
        pd.b_vsb && 
        pd.b_edt && 
        pd.b_newLine != false
      ) {
        //
        _i += 1;
        //
        let _itemKey = bf.myCM_get_newKey(global.c?.state[pd.state]); // dff、ランダムな文字列を追加する必要あり？
        //
        if (bf.myCM_get_len(pd.dd_defss) > 1) { // 複数項目の場合
          _r.push(ce._elm({
            type:'Spr',
          }, '{}.Spr'.f(_itemKey)));
          //
          _r.push(ce._elm({
            type:'Lbl',
            b_vsb: true,
            pfx: '{}'.f(pd.pfx).f(_i),
            iconName: null,
            onBtnPrs: null,
            stlCta: null,
            stlPfx: null,
          }, '{}.Lbl'.f(_itemKey)));
        };

        let _r2 = [];

        for (let [_defKey, _d_defs] of bf.e(pd.dd_defss)) {

          let _d = bf.myCM_copy(_d_defs); // _d_defs そのものを更新しないために

          _d.pfx = (pd.b_ttl != false) ? _d.pfx : ''; // title の表示 

//          _d.ini = ''; //  dff
          _d.ini = _d_defs.ini || ''; //  dff

          _d.d_ids = {
            idx: 'new', // b_dlt == true を含む
            key: _itemKey, 
            fld: _defKey
          };  // clds の二重登録を防ぐために必要

          _d.ctlVal = null; // 空白行の場合は常に null で良い？ 

          _d.onDltPrs = null; // 削除アイコンを表示しない 

          if (_d.ob_edt) {
            _d.b_edt = _d.ob_edt(_d.d_ids);
          };

//          _r.push(
          _r2.push(
            ce._elm(
              _d, 
              '{}.{}'.f(
                _d.d_ids.key, 
                _d.d_ids.fld
              )
            )
          );
        };

//console.log('2295:{}'.f(_itemKey));
        _r.push(
          <View
            key={_itemKey}
            style={{
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            }}
          >
            {_r2}
          </View>
        );
      };
      //
      if (pd.b_spr != false && bf.myCM_get_len(pd.dd_defss) > 1 && bf.myCM_get_len(global.c?.state[pd.state]) > 0) { // 複数項目の場合
        _r.push(ce._elm({
          type:'Spr',
        }, '{}.Spr'.f('last')));
      };
      //
      return (
        <ScrollView
          stickyHeaderIndices={[0]} // 一行目を見出しとして表示を固定
          style={[{
          }, pd.stlCta]}
        >
          {_r}
        </ScrollView>
      );
    };
/*
        <>
          {
          (bf.f(pd.h)) ? 
            (<ScrollView
              style={{
                height: pd.h,
              }}
            >
              {_r}
            </ScrollView>)
          :
            _r
          }
        </>

            height: 'auto',

            flex: '1',
            flexDirection: 'column',

      return (
        <>
          {_r}
        </>
      );
*/

  static Line = (pd={
    idx: '',
    pfx: '',
    ld_iss: [
      {
        fld: 0, 
        val: 0
      }
    ],
    d_defs: {},
  }) => {
    if (bf.f(pd.ld_iss) == false) return null;

    let _l_flds = pd.ld_iss.map( (_d_is, _idx) => {
      if (bf.f(_d_is?.fld)) {
        return _d_is.fld;
      }
      else {
        return '';
      };
    });

    let _n_fldCnt = bf.myCM_get_len(_l_flds);

    let _n_minDataCnt = 12;
    let _n_crrDataCnt = ( _n_fldCnt < _n_minDataCnt ) ? _n_minDataCnt : _n_fldCnt;

    let _ld_iss = pd.ld_iss.map( (_d_is, _idx) => {
      if (bf.f(_d_is?.val)) {
        return {
          x: _idx,
          y: _d_is.val,
        };
      }
      else {
        return {
          x: _idx,
          y: 0,
        };
      };
    });

    let _minVal = pd.ld_iss.reduce( (_prev, _d_is) => {
      return (_prev == null) ? _d_is.val : ((_prev < _d_is.val) ? _prev : _d_is.val);
    }, null);

    let _maxVal = pd.ld_iss.reduce( (_prev, _d_is) => {
      return (_prev == null) ? _d_is.val : ((_prev > _d_is.val) ? _prev : _d_is.val);
    }, null);

//bf.l('3523: {}, {}'.f(_maxVal, pd.d_defs.n_maxVal));


    let _viewW = ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2;
    let _xAxisIvl = _viewW / _n_minDataCnt; // x-axis interval
    let _chtW = _xAxisIvl * _n_crrDataCnt;
    let _l_ticks = bf.myCM_get_rng(pd.d_defs.n_maxVal, 0);

    let _xAxisLblH = ic.gn_fontSizeLrg * 4; // label height
    let _yAxisLblW = ic.gn_fontSizeSml * 2; // label width

//    let _viewH = ic.gn_h / 3.6; 
//    let _chtH = _viewH - _chtLblH; // chart height
    let _chtLblH = ic.gn_fontSizeLrg + ic.gn_mgnNrm * 2 + ic.gn_bdrWNrm * 2; // label height
    let _chtH = _xAxisLblH + (ic.gn_fontSizeSml + ic.gn_mgnSml) * bf.myCM_cnv('ceil', (pd.d_defs.n_maxVal / 5)); // chart height

    let _viewH = _chtH + _chtLblH;

//    let _minViewH = ic.gn_h / 3.6; 
    let _minViewH = global.c?.state.sgcd_dmns.n_h / 3.6; 

    if (_viewH < _minViewH) {
      _viewH = _minViewH;
      _chtH = _viewH - _chtLblH;
    }
//    let _viewH = _chtH;

    const [_sn_crrIdx, _setCrrIdx] = useState(null);
    useEffect( () => {
      if (pd.onPrs) {
        pd.onPrs(pd.d_ids, _sn_crrIdx);
      };
    }, [_sn_crrIdx]);

    return (
      <ScrollView
        key={(pd.idx) ? pd.idx : -1}
        horizontal={true}
        showHorizontalScrollIndicator={true}
        contentContainerStyle={{
          width: _viewW,
          height: _viewH,
          marginTop: ic.gn_mgnNrm,
          marginBottom: ic.gn_mgnNrm,
          marginLeft: 'auto',
          marginRight: 'auto',
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
        }}
      >
      <View
        key={-1}
        style={{
          width: _chtW,
          height: _viewH,
          marginTop: 0,
          marginBottom: 0,
          marginLeft: 0,
          marginRight: 0,
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
        }}
      >
        <ce.Lbl
          key={-1}
          pfx={pd.pfx}
          stlCta={{
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            height: _chtLblH,
            marginLeft: ic.gn_mgnNrm,
          }}
          stlPfx={{
          }}
        />

        <df.Vry.VictoryChart
          key={-2}
          domain={{ 
            x: [ 0, _n_crrDataCnt - 1], 
            y: [pd.d_defs.n_minVal || 0, pd.d_defs.n_maxVal || _maxVal + 1] }}
          style={{
            parent: {
            },
          }}
          padding={{
//            top: ic.gn_mgnNrm, 
            top: 0, 
            bottom: _xAxisLblH, // x-axis label の幅
            left: _yAxisLblW, // y-axis label の幅
            right: 0,
          }}
          height={_chtH}
          width={_chtW}
        >

          <df.Vry.VictoryLine
            key={'line'}
            style={{
              data: {
//                stroke: '#3ab60b',
                stroke: 'orange',
              },
              parent: {
                border: '1px solid #ccc',
              },
            }}
            data={_ld_iss}
          />

          <df.Vry.VictoryScatter
            key={'dot'}
            style={
              { 
//                data: (pd.d_defs.stlDot) ? pd.d_defs.stlDot : { fill: '#3ab60b' },
                data: (pd.d_defs.stlDot) ? pd.d_defs.stlDot : { fill: 'orange' },
              }
            }
            size={4}
            data={_ld_iss}
            labels={ _d_is => {
              //return '{}'.f(_d_is.datum.y);
              return '';
            }}
            labelcomponent={
              <df.Vry.VictoryLabel
              />
            }
            events={[
              {
                target: 'data',
                eventHandlers: {
                  onClick: () => {
                    return [
                      {
                        target: 'data',
                        mutation: _d_ps => {
                          _setCrrIdx(_d_ps.index);
                        }
                      }
                    ];
                  }
                }
              }
            ]}
          />

          <df.Vry.VictoryAxis
            key={'y-axis'}
            dependentAxis
            labelPlacement="perpendicular"
            tickFormat={(_t) => {
              return _t;
            }}
            tickValues={_l_ticks.filter( _ticks => (_ticks % 5 == 0) ? true : false)}
            style={{
              axis: { stroke: "none" },
              grid: { stroke: "grey", strokeWidth: 0.6, opacity: 0.5 },
              tickLabels: {
                fontSize: ic.gn_fontSizeSml,
                padding: 0,
                textAnchor: 'end',
              },
            }}
            offsetX={ 
              cf.myRN_chk_os('i') ? 
//                _yAxisLblW * 0.2 
                _yAxisLblW * 0.7 
//              : _yAxisLblW * 0.8
              : _yAxisLblW * 0.95
            }
          />

          <df.Vry.VictoryAxis
            key={'x-axis'}
            labelPlacement="perpendicular"
            tickFormat={ _t => {
              return (_t>=0 && _t<_n_crrDataCnt) ? _l_flds[_t] : '';
            }}
            tickValues={bf.myCM_get_rng(_n_crrDataCnt, 0)}
            style={{
              axis: { stroke: "none" },
              grid: { stroke: "grey", strokeWidth: 0.6, opacity: 0.5 },
              tickLabels: {
                fontSize: ic.gn_fontSizeSml * 1.0,
                angle: 30,
                padding: 0,
                textAnchor: 'start',
              },
            }}
          />

        </df.Vry.VictoryChart>
      </View>
      </ScrollView>
    );
  };
//            tickValues={_l_ticks}
/*
            labels={ _d_is => '{}'.f(_d_is.datum.y)}

                dx={100}
                dy={100}
                textAnchor='start'
                verticalAnchor='middle'

            labelcomponent={
              <VictoryLabel
                renderInPortal
                dy={-20}
              />
            }
 */

  static Lines = (pd={
    b_vsb: false,
    ld_iss: [],
  }) => {
    if (pd.b_vsb == false) {
      return null;
    }
    else {
      if (pd.ld_iss) {
        let _r = pd.ld_iss
        .filter(_d_is => {
          return (bf.f(_d_is)) ? true : false;
        })
        .map((_d_is, _idx) => {
          return ce.Line({
            idx: 'Line.{}'.f(_idx),
            pfx: _d_is.pfx,
            ld_iss: _d_is.ld_iss,
//            d_defs: pd.d_defs,
//            d_defs: pd.d_defs || pd.ld_defss[_idx],
            d_defs: pd.d_defs || _d_is.d_defs,
          });
        });

        return (
          <>
            <ce.Lbl
              key={'Lines.Lbl.-1'}
              pfx={pd.pfx}
            />
            {_r}
          </>
        )
      }
      else {
        return null;
      };

    };
  };

  static List = (pd={
  }) => { // 辞書型の場合、ソートできない？
    //
    if (pd.b_vsb == false) {
      return null;
    };
    //
    let _r = [];
    //
    let _ld_itemss = {};
    if (pd.state) {
      _ld_itemss = global.c?.state[pd.state];
    }
    else if (pd.ld_itemss) {
      _ld_itemss = pd.ld_itemss;
    }
    else {
      return null;
    };
    //
    let _n_cnt = 0;
    let _n_sum = 0;
    let _pastDate = '';
    //
    for (let [_idx, _d_items] of bf.e(_ld_itemss)) {
      //
      if (pd.sumFld && pd.dtmFld) {
        if (_pastDate != _d_items.val[pd.dtmFld].substr(0,10)) {
          if (_pastDate != '') {
            _n_cnt -= 1;
            _r.push(
              <View
                key={_n_cnt}
                style={{
                  height: 10 + ic.gn_bdrWNrw * 2,
                  width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                  marginTop: ic.gn_mgnLrg,
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  backgroundColor: '#e9e9e9',
                  borderWidth: ic.gn_bdrWSml,
                  borderRadius: ic.gn_bdrRdsNrm,
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Text
                  key={1}
                  style={{
                    fontSize: 10,
                    color: '#444444',
                  }}
                >
                  {'{} {}円'.f(_pastDate, _n_sum)}
                </Text>
              </View>
            );
          };
          _pastDate = _d_items.val[pd.dtmFld].substr(0,10)
          _n_sum = 0;
        };
        _n_sum += bf.n(_d_items.val[pd.sumFld]);
      };

      _r.push(
        <View
          key={_idx}
          style={{
            marginTop: ic.gn_mgnSml,
            marginBottom: ic.gn_mgnSml,
            width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <ce.Row
            key={-1}
          >
            { (pd.b_chb) ?
              <ce.Chb
                key={-1}
                b_vsb={true}
                onChg={(_b_val)=>{
                  if (pd.onChk){
                    pd.onChk(_d_items, _b_val);
                  }
                }}
                stlCta={{
                }}
              />
            : null }
            <TouchableOpacity
              key={-2}
              onPress={()=>{
                if (pd.onPrs && pd.b_prs != false) {
                  pd.onPrs(_d_items, _idx);
                };
              }}
            >
              <View
                key={-1}
                style={{
                  width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW - ((pd.b_chb) ? ic.g_chbW : 0),
                  paddingTop: ic.gn_mgnLrg,
                  paddingBottom: ic.gn_mgnLrg, // 0 is good for chat
                  paddingLeft: ic.gn_mgnNrm, // 0 is good for chat
                  paddingRight: ic.gn_mgnNrm,
                  borderWidth: 1,
                  borderColor: (pd.b_prs == true && pd.b_bdr != false) ? '#bbbbbb' : ic.g_ccdWN,
                  borderRadius: 0,
                  backgroundColor: (_d_items.backCcd) ? _d_items.backCcd : null,
                }}
              >
                <ce.Row
                  key={-1}
                >
                  { (pd.b_img) ? // (_d_items.uri) ?
                    <ce.Img
                      key={-1}
                      stlCta={{
                        height: ic.gn_iconSizeLrg,
                        width: ic.gn_iconSizeLrg,
                        marginTop: ic.gn_mgnNrm,
                        marginBottom: 'auto',
                        marginLeft: 0,
                        marginRight: ic.gn_mgnNrm,
                      }}
                      stlImg={{
                        width: ic.gn_iconSizeLrg,
                        height: ic.gn_iconSizeLrg,
                      }}
                      uri={_d_items.uri}
                      msg={_d_items.pfx.replace(/ /g, '').replace(/　/g, '').substring(0,2)}
                    />
                  : null}
                  <View
                    key={-2}
                    style={{
                      width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 4 - ic.gn_scbW - ((pd.b_chb) ? ic.g_chbW : 0) - ((!bf.f(_d_items.uri) == false) ? ic.gn_iconSizeLrg + ic.gn_mgnNrm : 0)
                    }}
                  >
                    <Text
                      key={-1}
                      style={{
                        fontSize: ic.gn_fontSizeNrm,
                        color: ic.g_fontCcdNrm,
                      }}
                    >
                      {_d_items.pfx}
                    </Text>
                    <Text
                      key={-2}
                      style={[{
                        fontSize: ic.gn_fontSizeSml,
                        color: ic.g_fontCcdSml,
                        marginRight: ic.gn_mgnNrm,
                        marginLeft: 'auto',
                      }]}
                    >
                      {_d_items.spf}
                    </Text>
                  </View>
                </ce.Row>
              </View>
            </TouchableOpacity>
          </ce.Row>
        </View>
      );
    };
    //
    if (pd.sumFld && pd.dtmFld) {
      _n_cnt -= 1;
      _r.push(
        <View
          key={_n_cnt}
          style={{
            height: 10 + ic.gn_bdrWNrw * 2,
            width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
            marginTop: ic.gn_mgnLrg,
            marginLeft: 'auto',
            marginRight: 'auto',
            backgroundColor: '#e9e9e9',
            borderWidth: ic.gn_bdrWSml,
            borderRadius: ic.gn_bdrRdsNrm,
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Text
            key={1}
            style={{
              fontSize: 10,
              color: '#444444',
            }}
          >
            {'{} {}円'.f(_pastDate, _n_sum)}
          </Text>
        </View>
      );
    };
    //
    return (
      <View
          key={-1}
          style={{
          }}
      >
        <ce.Lbl
          key={-1}
          b_vsb={(pd.pfx) ? true : false}          
          pfx={pd.pfx}
          stlCta={{
          }}
          stlPfx={{
              fontSize: ic.gn_fontSizeLrg,
              color: ic.g_fontCcdLrg,
          }}
          iconName={pd.iconName}
          onBtnPrs={pd.onBtnPrs}
        />
        {_r}
      </View>
    );
  }

    static ListBean (pd) {
        //
        let _n_col = 4; // 列数
        let _n_w = (global.c?.state.sgcd_dmns.n_w - ic.gn_scbW - ic.gn_mgnNrm * ( _n_col + 1)) / _n_col; 
        //
        let _r = [];
        bf.myCM_for_each(global.c?.state[pd.state], (_d_items) => {
            _r.push(
                <View
                    style={{
                        height: ic.gn_fontSizeSml + ic.gn_mgnNrm * 2,
                        width:  _n_w + ic.gn_fontSizeNrm,
                        margin: ic.gn_mgnNrm / 2,
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <View
                        style={{
                            height: ic.gn_fontSizeSml + ic.gn_mgnNrm * 2,
                            width: _n_w,
                            borderWidth: ic.gn_bdrWNrw,
                            borderRightWidth: 0,
                            borderColor: ic.g_bdrCcd,
                            borderTopLeftRadius: ic.gn_bdrRdsLrg,
                            borderBottomLeftRadius: ic.gn_bdrRdsLrg,
                            marginLeft: ic.gn_mgnNrm / 2,
                            marginRight: 0,
                            paddingHorizontal: ic.gn_mgnNrm,
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Text
                            style={{
                                color: ic.g_fontCcdNrm,
                                fontSize: ic.gn_fontSizeSml,
                            }}
                            numberOfLines={1}
                            ellipsizeMode='tail'
                        >
                            {_d_items.pfx}
                        </Text>
                    </View>
                    <TouchableOpacity
                        onPress={() => {
                            (pd.onPrs) ? pd.onPrs(_d_items) : null
                        }}
                    >
                        <View
                            style = {{
                                height: ic.gn_fontSizeSml + ic.gn_mgnNrm * 2,
                                width: ic.gn_fontSizeNrm,
                                borderWidth: ic.gn_bdrWNrw,
                                borderLeftWidth: 0,
                                borderColor: ic.g_bdrCcd,
                                borderTopRightRadius: ic.gn_bdrRdsLrg,
                                borderBottomRightRadius: ic.gn_bdrRdsLrg,
                                marginLeft: 0,
                                marginRight: ic.gn_mgnNrm / 2,
                            }}
                        >
                            <Text
                                style={{
                                    color: ic.g_fontCcdNrm,
                                    fontSize: ic.gn_fontSizeSml,
                                }}
                            >
                                ×
                            </Text>
                        </View>
                    </TouchableOpacity>
                </View>
            );
        });
        //
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <ScrollView
                        contentContainerStyle={[{
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            borderWidth: 0,
                            margin: 0,
                            padding: 0,
                        }]}
                        showsVerticalScrollIndicator={true}
                    >
                        <View
                            style={{
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                            }}
                        >
                            {_r}
                        </View>
                    </ScrollView>
                : null }
            </View>
        );
    }

/*
listcard の無限スクロールへの対応について <- useContext により改善される？
・本来は、listcard ごとに scroll bottom を判定し、追加で読み込むべきであるが、tecs では、下記の３点により対応を見送る
・rootlist が複数の listcart に対応していることから、
　listcard を横方向スクロールとする必要がある
・body ではなく listcard の scrollview をもとにスクロールするよう変更する必要がある
・listcard にイベントを送るため、例えば、listcard に 表示行数等の state を保持し、
　その state を rootlist において更新する必要がある？　←　いらなくなるかも

*/

    static ListCard (pd) {
        //
        let _n_col = (!bf.f(pd.n_col) == false) ? pd.n_col : 2;
        let _n_cnt = 0;
        let _n_w = (((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * (_n_col + 1)) / _n_col;
        //
        let _r1 = [];
        let _r2 = [];
        bf.myCM_for_each(global.c?.state[pd.state], (_d_items, _idx) => {
            _r1.push(
                <View
                    key={_idx}
                    style={{
                        marginTop: 0,
                        marginBottom: 'auto',
                        marginStart: 'auto',
                        marginEnd: 'auto',
                    }}
                >
                    <TouchableOpacity
                        onPress={()=>{
                            (pd.onPrs) ? pd.onPrs(_d_items) : null;
                        }}
                    >
                        <View style={{
                            width: _n_w,
                            borderWidth: 1,
                            borderColor: (pd.onPrs && pd.b_bdr != false) ? '#bbbbbb' : ic.g_ccdWN,
                            borderRadius: 0,
                            paddingTop: ic.gn_mgnLrg,
                            paddingBottom: ic.gn_mgnLrg, // 0 is good for chat
                            paddingLeft: ic.gn_mgnNrm / 2, // 0 is good for chat
                            paddingRight: ic.gn_mgnNrm / 2,
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                        }}>
                            { (pd.b_img) ?
                                <ce.Img
                                    b_edt={false}
                                    stlCta={{
                                        height: _n_w - ic.gn_mgnNrm,
                                        width: _n_w - ic.gn_mgnNrm,
                                        margin: 0,
                                    }}
                                    stlImg={{
                                        height: _n_w - ic.gn_mgnNrm,
                                        width: _n_w - ic.gn_mgnNrm,
                                    }}
                                    uri={_d_items.uri}
                                    msg={_d_items.pfx.replace(/ /g, '').replace(/　/g, '').substring(0,2)}
                                />
                            : null }
                            <View
                                style={{
                                    width: _n_w - ic.gn_mgnNrm,
                                }}
                            >
                                <Text
                                    style={{
                                        fontSize: ic.gn_fontSizeNrm,
                                        color: ic.g_fontCcdNrm,
                                        marginRight: 'auto',
                                        marginLeft: 'auto',
                                    }}
                                >
                                    {_d_items.pfx}
                                </Text>
                                <Text
                                    style={[{
                                        fontSize: ic.gn_fontSizeSml,
                                        color: ic.g_fontCcdSml,
                                        marginRight: 'auto',
                                        marginLeft: 'auto',
                                    }]}
                                >
                                    {_d_items.spf}
                                </Text>
                            </View>
                        </View>
                    </TouchableOpacity>
                </View>
            );
            //
            _n_cnt += 1;
            if ( _n_cnt >= _n_col ) {
                _n_cnt = 0;
                _r2.push(
                    <ce.Row
                        key={_idx}
                        style={{
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                        }}
                    >
                        {_r1}
                    </ce.Row>
                );
                _r1 = [];
            };
        });
        // 残り分
        _r2.push(
            <ce.Row
                key={-1}
                style={{
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                }}
            >
                {_r1}
            </ce.Row>
        );
        //
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <ScrollView
                        contentContainerStyle={[{
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            borderWidth: 0,
                            padding: 0,
                            width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                            marginTop: ic.gn_mgnNrm,
                            marginBottom: ic.gn_mgnNrm,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }]}
                        showsVerticalScrollIndicator={true}
                    >
                        <View>
                            <View>
                                { (pd.pfx) ?
                                    <ce.Row
                                        stlCta={{
                                            width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                                            marginTop: ic.gn_mgnNrm * 3,
                                            marginBottom: ic.gn_mgnNrm,
                                            marginLeft: 'auto',
                                            marginRight: 'auto',
                                            borderColor: ic.g_bdrCcd,
                                            borderBottomWidth: ic.gn_bdrWNrw,
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <ce.Lbl
                                            
                                            pfx={pd.pfx}
                                            stlCta={{
                                            }}
                                            stlPfx={{
                                                fontSize: ic.gn_fontSizeSml,
                                                color: ic.g_fontCcdSml,
                                                paddingTop: ic.gn_mgnNrm,
                                                paddingBottom: ic.gn_mgnNrm,
                                                paddingLeft: 0,
                                                paddingRight: 0,
                                                fontWeight: 'bold',
                                            }}
                                        />
                                        { (pd.b_menu) ?
                                            <TouchableOpacity
                                                onPress={()=>{
                                                    global.c?.setState({ // menu の表示
                                                        sgcb_menu: true
                                                    });
                                                }}
                                            >
                                                <View
                                                    style={{
                                                        height: ic.gn_fontSizeLrg + ic.gn_mgnNrm * 2,
                                                        width: ic.gn_fontSizeLrg + ic.gn_mgnNrm * 2,
                                                        backgroundColor: '#dddddd',
                                                        borderColor: '#dddddd',
                                                        borderRadius: (ic.gn_fontSizeLrg + ic.gn_mgnNrm * 2)/2,
                                                    }}
                                                >
                                                    <Icon
                                                        name="ellipsis-v"
                                                        type="FontAwesome"
                                                        underlayColor="transparent"
                                                        size={ic.gn_fontSizeLrg}
                                                        color={'#555555'}
                                                        style={{
                                                            marginTop: 'auto',
                                                            marginBottom: 'auto',
                                                            marginLeft: 'auto',
                                                            marginRight: 'auto',
                                                        }}
                                                    />
                                                </View>
                                            </TouchableOpacity>
                                        : null }
                                        { (pd.btnPfx) ?
                                            <ce.Btn
                                                b_vsb={true}
                                                pfx={pd.btnPfx}
                                                stlCta={{
                                                    width:ic.gn_fontSizeSml * 3,
                                                }}
                                                stlBtn={{
                                                    width:ic.gn_fontSizeSml * 3,
                                                    marginLeft: ic.gn_mgnNrm,
                                                    borderWidth: ic.gn_bdrWNrw,
                                                    borderColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                                                    backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                                                    padding: ic.gn_mgnSml,
                                                }}
                                                stlPfx={{
                                                    fontSize: ic.gn_fontSizeSml,
                                                    color: ic.g_ccdWN,
                                                }}
                                                onPrs={pd.onBtnPrs}
                                            />
                                        : null }
                                    </ce.Row>
                                : null }
                            </View>
                            {_r2}
                        </View>
                    </ScrollView>
                : null }
            </View>
        );
    }

  static ListChat (pd) {
    //
    let _r = [];
    //
    let _pastDate = '';
    let _pastTime = '';
    //
    let _cnt = 1; // 初期値分シフト
    //
    for (let [_idx, _d_items] of bf.e(global.c?.state[pd.state])) {
      if (_d_items.b_dlt == true) continue; // 20211003
      if (_pastDate != _d_items.time.substr(0,10)) {
        _cnt += 1;
        _r.push(
          <View
            key={_cnt}
            style={{
              height: 10 + ic.gn_bdrWNrw * 2,
              width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
              marginTop: ic.gn_mgnLrg,
              backgroundColor: '#e9e9e9',
              borderWidth: ic.gn_bdrWSml,
              borderRadius: ic.gn_bdrRdsNrm,
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Text
              key={1}
              style={{
                fontSize: 10,
                color: '#444444',
              }}
            >
              {_d_items.time.substr(0,10)}
            </Text>
          </View>
        );
        //
        _pastDate = _d_items.time.substr(0,10)
      };

      _cnt += 1;
      _r.push(
        <ce.Row
            key={_cnt}
            stlCta={{
              width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
              marginTop: 0,
              marginBottom: 0,
              marginLeft: 'auto',
              marginRight: 'auto',
              paddingTop: 0,
              paddingBottom: 0, // 0 is good for chat
              paddingLeft: 0, // 0 is good for chat
              paddingRight: 0,
              borderWidth: 0,
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            }}
        >
          { (pd.b_chk) ?
            ce.c(ce.Chk, { 
              key: -1,
              b_val: _d_items.b_chk ?? false,
//              b_edt: true, // ob_edt に変更要
              b_edt: (pd.ob_chk) ? pd.ob_chk(_d_items) : false, // ob_edt に変更要
              o_onPrs: _b_val => {
                global.c?.setState({
                  [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                    _next[_idx].b_chk = _b_val;
                  }),
                })
              },
              stlCta: {
                width: ic.gn_btnWSml,
              },
            })
          : null }
          { /* (pd.b_avt) ?
            <ce.Img
              key={1}
              stlCta={{
                height: ic.gn_iconSizeLrg,
                width: ic.gn_iconSizeLrg,
                marginTop: 0,
                marginBottom: 'auto',
                marginLeft: 0,
                marginRight: ic.gn_mgnNrm,
              }}
              stlImg={{
                height: ic.gn_iconSizeLrg,
                width: ic.gn_iconSizeLrg,
                marginTop: 0,
                marginBottom: 0,
                marginLeft: 0,
                marginRight: 0,
              }}
              uri={_d_items.uri}
            />
          : null */ }
          <View
            key={2}
            style={{
//              width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2 - ((pd.b_avt) ? (ic.gn_iconSizeLrg + ic.gn_mgnNrm) : 0),
              flex: 1,
              marginTop: 0,
              marginBottom: 0,
              marginLeft: 'auto',
              marginRight: 'auto',
              paddingTop: 0,
              paddingBottom: 0,
            }}
          >
            { (_pastTime != _d_items.time.substr(0,16)) ?
              <Text
                key={1}
                style={{
                  width: '100%',
                  marginTop: ic.gn_mgnLrg,
                  fontSize: ic.gn_fontSizeSml * 0.85,
                  color: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                  fontWeight: 'bold',
                }}
              >
                {_d_items.name}（{_d_items.time}）
              </Text>
            : null }
            <Text
              key={2}
              style={[{
                fontSize: ic.gn_fontSizeNrm,
                color: ic.g_fontCcdNrm,
                marginTop: 0,
                marginBottom: 0,
                minHeight: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2 + ic.gn_bdrWNrw * 1.5 * 2, // 20211003
              }]}
            >
              { (_d_items.type == 'msg') ? 
                <Text
                  key={1}
                  style={{
                    marginTop: 0,
                    marginBottom: 0,
                  }}
                >
                  {_d_items.msg}
                </Text>
              : (_d_items.type == 'file') ? 
                <ce.Link
                  key={1}
                  file={_d_items.file}
                  stlLink={{
                    color: '#ffaa00',
                  }}
                >
                  {_d_items.file.name}
                </ce.Link>
              : null }
            </Text>
          </View>
        </ce.Row>
      );
      //
      _pastTime = _d_items.time.substr(0,16);
    };

/*
              { (pd.b_edt == true) ? // 20211003
                <ce.BtnIcon
                  iconName={'trash'}
                  onPrs={()=>{
                    global.c?.setState({
                      [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                        _next[_idx].b_dlt = true;
bf.l('4404: {}'.f(_next[_idx]))
                      }),
                    })
                  }}
                  stlCta={{
                    position: 'absolute',
                    right: ic.gn_mgnNrm,
                    bottom: ic.gn_mgnNrm,
//                    top: 'auto',
//                    bottom: 'auto',
                  }}
                />
 */
    //
    if (pd.b_vsb == false) {
      return null;
    }
    //
    return (
      <ScrollView
        key={-1}
        contentContainerStyle={[{
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center',
          borderWidth: 0,
          margin: 0,
          padding: 0,
        }]}
        showsVerticalScrollIndicator={true}
      >
        { (pd.pfx) ?
        <ce.Lbl
          key={-1}
          pfx={pd.pfx}
          stlCta={{
            width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
            marginTop: ic.gn_mgnLrg,
            marginBottom: ic.gn_mgnLrg,
            marginLeft: 'auto',
            marginRight: 'auto',
            borderColor: ic.g_bdrCcd,
            borderBottomWidth: ic.gn_bdrWNrw,
          }}
          stlPfx={{
            fontSize: ic.gn_fontSizeLrg,
            color: ic.g_fontCcdLrg,
          }}
        />
        : null }
        {_r}
      </ScrollView>
    );
  }

    static ListEnt (pd) { // list entry
        //
        if (pd.b_vsb == false) { // b_vsb == false の場合は非表示
            return null;
        }
        //
        let _r = [];
        //
        let _pastHdr = '';
        //
        let _cnt = 0;
        for (let [_key, _d_items] of bf.e(global.c?.state[pd.state])) {
            //
            _cnt += 1;
            if(_d_items.hdr == _pastHdr) {
            }
            else {
                _r.push(
                    <View
                        key={_cnt}
                        style={{
                            width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                            marginTop: ic.gn_mgnSml,
                            marginBottom: ic.gn_mgnSml,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                    >
                        <ce.Msg
                            key={-1}
                            pfx={_d_items.hdr}
                            stlPfx={(pd.stlHdr) ? pd.stlHdr : null}
                        />
                    </View>
                );
            };
            //
            _pastHdr = _d_items.hdr;
            //
            _cnt += 1;
            _r.push(
                <View
                    key={_cnt}
                    style={{
                        width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                        marginTop: ic.gn_mgnSml,
                        marginBottom: ic.gn_mgnSml,
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }}
                >
                    <ce.Msg
                        key={-1}
                        pfx={_d_items.msg}
                    />
                    <ce.Msg
                        key={-2}
                        pfx={'{}時点'.f(_d_items.dtm)}
                        stlPfx={{
                            fontSize: ic.gn_fontSizeSml,
                        }}
                    />
                    <ce.Inp
                        key={-3}
                        b_vsb={true}
                        b_edt={pd.b_edt}                        
                        state={null}
                        pfx={null}
                        b_mln={true}
                        ini={_d_items.ini}
                        phd={null}
                        onFcs={null}
                        onBlur={(_s) => {
                            global.c?.setState({
                                [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                                    _next[_key].val = _s;
                                }),
                            });                            
                        }}
                        stlCta={null}
                        stlInp={null}
                    />
                </View>
            );
        };
        //
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <ScrollView
                        contentContainerStyle={[{
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            borderWidth: 0,
                            margin: 0,
                            padding: 0,
                        }, pd.stlCta]}
                        showsVerticalScrollIndicator={true}
                    >
                        <View
                            key={-1}
                        >
                            <View
                                key={-1}
                            >
                                { (pd.pfx) ?
                                <ce.Row
                                    key={-1}
                                    stlCta={{
                                        width: ((pd.n_w) ? pd.n_w : global.c?.state.sgcd_dmns.n_w) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                                        marginTop: ic.gn_mgnNrm * 3,
                                        marginBottom: ic.gn_mgnNrm,
                                        marginLeft: ic.gn_mgnNrm,
                                        marginRight: ic.gn_mgnNrm,
                                        borderColor: ic.g_bdrCcd,
                                        borderBottomWidth: ic.gn_bdrWNrw,
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                    }}
                                >
                                    <ce.Lbl
                                        key={-1}
                                        
                                        pfx={pd.pfx}
                                        stlCta={{
                                        }}
                                        stlPfx={{
                                            fontSize: ic.gn_fontSizeLrg,
                                            color: ic.g_fontCcdLrg,
                                        }}
                                    />
                                </ce.Row>
                                : null }
                            </View>
                            {_r}
                        </View>
                    </ScrollView>
                : null }
            </View>
        );
    }

    static InpTree (pd) { // inputs
        //
        if (pd.b_vsb == false) { // b_vsb == false の場合は非表示
            return null;
        }
        //
        function _fnc01(pd_items) {
            return(
                <View
                    key={pd_items.pid}
                    style={{
                        width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                        marginTop: ic.gn_mgnSml,
                        marginBottom: ic.gn_mgnSml,
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }}
                >
                    <ce.Inp
                        key={-1}
                        b_vsb={true}
                        b_edt={pd.b_edt}
                        state={null}
                        pfx={null}
                        b_mln={false}
                        ini={pd_items.ini}
                        phd={pd.phd}
                        n_pntW={((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW - ((pd_items.n_lyr || 1) - 1) * ic.gn_fontSizeNrm * 2}
                        onFcs={null}
                        onBlur={(_s) => {
                            global.c?.setState({
                                [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                                    //
                                    let _cpt = _next;
                                    //
                                    for (let [_n_idx, _key] of bf.e(pd_items.pid.split(bf.dlm))) {
                                        //
                                        if (_n_idx >= (pd_items.n_lyr || 1) - 0) { // 同階層を取得
                                            break;
                                        }
                                        //
                                        if (_n_idx == 0) {
                                            if (!bf.f(_cpt[_key])) {
                                                _cpt[_key] = {
                                                    ini: '',
                                                    clds: {},
                                                };
                                            };
                                            _cpt = _cpt[_key];
                                        }
                                        else {
                                            if (!bf.f(_cpt.clds[_key])) {
                                                _cpt.clds[_key] = {
                                                    ini: '',
                                                    clds: {},
                                                };
                                            };
                                            _cpt = _cpt.clds[_key];
                                        };
                                    };
                                    //
                                    _cpt.val = _s;
                                }),
                            });

                            global.c?.setState({
                                sgcd_items: pd_items,
                            }, ()=>{
                            });
                        }}
                        stlCta={{
                            marginLeft: 'auto',
                            marginRight: 0,
                        }}
                        stlInp={null}
                    />
                </View>
            );
        }
        //
        let _r = [];
        //
        for (let [_key, _d_items] of bf.e(global.c?.state[pd.state])) { // 現行は、3階層まで
            if (_d_items.b_dlt != true) {
                _r.push(_fnc01(bf.p(_d_items, _next =>{
                    _next.n_lyr = 1;
                    _next.pid = '{}'.f(_key);
                })));
                if (_d_items.clds) {
                    for (let [_cldKey1, _d_cldItems1] of bf.e(_d_items.clds)) {
                        if (_d_cldItems1.b_dlt != true) {
                            _r.push(_fnc01(bf.p(_d_cldItems1, _next => {
                                _next.n_lyr = 2;
                                _next.pid = '{}_{}'.f(_key, _cldKey1);
                            })));
                            if (_d_cldItems1.clds) {
                                for (let [_cldKey2, _d_cldItems2] of bf.e(_d_cldItems1.clds)) {
                                    if (_d_cldItems2.b_dlt != true) {
                                        _r.push(_fnc01(bf.p(_d_cldItems2, _next =>{
                                            _next.n_lyr = 3;
                                            _next.pid = '{}_{}_{}'.f(_key, _cldKey1, _cldKey2);
                                        })));
                                    };
                                };
                            };
                            if (pd.b_edt) {
                                let _d_items3 = {
                                    ini: '',
                                };
                                let _newKey3 = bf.myCM_get_newKey(_d_cldItems1.clds);
                                _r.push(_fnc01(bf.p(_d_items3, _next =>{
                                    _next.n_lyr = 3;
                                    _next.pid = '{}_{}_{}'.f(_key, _cldKey1, _newKey3);
                                })));
                            };
                        };
                    };
                };
                if (pd.b_edt) {
                    let _d_items2 = {
                        ini: '',
                        clds: {},
                    };
                    let _newKey2 = bf.myCM_get_newKey(_d_items.clds);
                    _r.push(_fnc01(bf.p(_d_items2, _next =>{
                        _next.n_lyr = 2;
                        _next.pid = '{}_{}'.f(_key, _newKey2);
                    })));
                };
            };
        };
        if (pd.b_edt) {
            let _d_items2 = {
                ini: '',
                clds: {},
            };
            let _newKey = bf.myCM_get_newKey(global.c?.state[pd.state]);
            _r.push(_fnc01(bf.p(_d_items2, _next =>{
                _next.n_lyr = 1;
                _next.pid = '{}'.f(_newKey);
            })));
        }
        //
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <ScrollView
                        contentContainerStyle={[{
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            borderWidth: 0,
                            margin: 0,
                            padding: 0,
                        }, pd.stlCta]}
                        showsVerticalScrollIndicator={true}
                    >
                        <View
                            key={-1}
                        >
                            <ce.Lbl
                                key={-1}
                                b_vsb={(pd.pfx) ? true : false}
                                
                                pfx={pd.pfx}
                                stlCta={{
                                }}
                                stlPfx={{
                                    fontSize: ic.gn_fontSizeLrg,
                                    color: ic.g_fontCcdLrg,
                                }}
                            />
                            {_r}
                        </View>
                    </ScrollView>
                : null }
            </View>
        );
    }

/*
    static Ldr (pd) { // loader
        //
        return (
            <>
                { (global.c?.state[pd.state]) ?
                    <View
                        style={{
                            position: 'absolute',
                            zIndex: ic.gn_zIdxLdr,
                            top: 0,
                            left: 0,
                            height: '100%',
                            width: '100%',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <View
                            style={{
                                height: 100,
                                width: 100,
                                borderRadius: ic.gn_bdrRdsNrm,
                                backgroundColor: '#eeeeee',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                // for border
                                borderWidth: ic.gn_bdrWNrw,
                                borderColor: '#eeeeee',
                            }}
                        >
                            <ActivityIndicator
                               animating = {true}
                               color = {(ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd}
                               size = "large"
                            />
                        </View>

<View
  style={{
    height: ic.gn_fontSizeNrm,
    width: global.c?.state.sgcd_dmns.n_w / 2,
    maxWidth: 300,
    borderWidth: ic.gn_bdrWNrw,
    borderColor: ic.gn_backCccd,
  }}
>
  <View
    style={{
      height: ic.gn_fontSizeNrm / 2,
      width: 100,
      borderWidth: ic.gn_bdrWNrw,
      borderColor: 'black'
    }}
  >
    <View
      style={{
        height: ic.gn_fontSizeNrm / 2 * 0.8,
        width: 80,
        backgroundColor: 'black',
      }}
    >
    </View>
  </View>
</View>

                    </View>
                : null }
            </>
        );
    }
 */

/*
  static Ldr (pd) { // loader
      //
    const [_sn_prsCrrCnt, _setPrsCrrCnt] = useState(0);
    const [_sn_prsTtlCnt, _setPrsTtlCnt] = useState(0);
    const [_sn_prsWgt, _setPrsWht] = useState(0); 
    useEffect(() => {
      global.c?.setState({
        sgcn_prs: ( _sn_prsTtlCnt > 0 ) ? _sn_prsCrrCnt / _sn_prsTtlCnt * _sn_prsWgt : 0,
      })
    }, [
      _sn_prsCrrCnt,
      _sn_prsTtlCnt,
    ]);

    return (
      <>
        { (global.c?.state[pd.state]) ?
          <View
            style={{
              position: 'absolute',
              zIndex: ic.gn_zIdxLdr,
              top: 0,
              left: 0,
              height: '100%',
              width: '100%',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <View
              style={{
                height: 100,
                width: 100,
                borderRadius: ic.gn_bdrRdsNrm,
                backgroundColor: '#eeeeee',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                // for border
                borderWidth: ic.gn_bdrWNrw,
                borderColor: '#eeeeee',
              }}
            >
              <ActivityIndicator
                animating = {true}
                color = {(ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd}
                size = "large"
              />
            </View>

            { (global.c?.state.scgn_prs > 0) ?
              <View
                style={{
                  height: 40,
                  width: 200,
                  borderWidth: 0,
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <View
                  style={{
                    height: 10,
                    width: 160,
                    backgroundColor: ic.gn_backCcd,
                    borderWidth: ic.gn_bdrWNrw,
                    borderRadius: ic.gn_bdrRdsSml,
                    borderColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                  }}
                >
                  <View
                    style={{
                      height: 10,
                      width: 160 * global.c?.state.scgn_prs / 100,
                      backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                    }}
                  >
                  </View>
                </View>
              </View>
            : null }

          </View>
        : null }
      </>
    );
  }
*/
  static Ldr (pd) { // loader
      //
    const [_sn_prsRate, _setPrsRate] = useState(0); 
    useEffect(() => {
      let _n = 
        ( global.c?.state.sgcd_prss.n_ttlCnt > 0 ) ? 
          global.c?.state.sgcd_prss.n_crrCnt / global.c?.state.sgcd_prss.n_ttlCnt * global.c?.state.sgcd_prss.n_wgt 
        : 0;
      _setPrsRate(_n);
    }, [
      global.c?.state.sgcd_prss.n_crrCnt,
      global.c?.state.sgcd_prss.n_ttlCnt,
    ]);

    return (
      <>
        { (global.c?.state[pd.state]) ?
          <View
            style={{
              position: 'absolute',
              zIndex: ic.gn_zIdxLdr,
              top: 0,
              left: 0,
              height: '100%',
              width: '100%',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <View
              style={{
                height: 100,
                width: 100,
                borderRadius: ic.gn_bdrRdsNrm,
                backgroundColor: '#eeeeee',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                // for border
                borderWidth: ic.gn_bdrWNrw,
                borderColor: '#eeeeee',
              }}
            >
              <ActivityIndicator
                animating = {true}
                color = {(ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd}
                size = "large"
              />
            </View>

            { (global.c?.state.sgcd_prss.b_vsb) ?
              <View
                style={{
                  height: 40,
                  width: 200,
                  borderWidth: 0,
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <View
                  style={{
                    height: 10,
                    width: 160,
                    backgroundColor: ic.gn_backCcd,
                    borderWidth: ic.gn_bdrWNrw,
                    borderRadius: ic.gn_bdrRdsSml,
                    borderColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                  }}
                >
                  <View
                    style={{
                      height: 10,
                      width: 160 * _sn_prsRate / 100,
                      backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                      borderWidth: ic.gn_bdrWNrw,
                      borderRadius: ic.gn_bdrRdsSml,
                      borderColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                    }}
                  >
                  </View>
                </View>
              </View>
            : null }

          </View>
        : null }
      </>
    );
  }

/*
  static InpTree2 = (pd={
    b_vsb: true,
    b_edt: true,
    state: [{
      elm: '',
      key: '',
      b_dlt: false, // dlt の状況
      flds: [
        {
          fld: '',
          ini: '',
          val: '', 
          b_uid: false, // uid の有無
          phd: '',
          type: 'Inp/Pck',
          ld_itemss: [
            {key: '', pfx: ''},
          ], // for sPck
          old_itss: _d_is => [
            {key: '', pfx: ''},
          ], // for sPck
        },
      ],
      b_cls: false, // 子要素の表示状況
      clds: [], // 子要素
    }],    
  }) => { // inputs

    if (pd.b_vsb == false) { // b_vsb == false の場合は非表示
      return null;
    }

    let _r = [];

    let _get_crrElm = (pld_elmTreess, pl_elmIdxs) => { // pld_elmTreess において pl_pntIdxs/pn_elmIdx で指定された elm を取得する
      let _d_elms = null;
      for (let [_n, _elmIdx] of bf.e(pl_elmIdxs)) {
        if (_n == 0) {
          _d_elms = pld_elmTreess[_elmIdx];
        }
        else {
          _d_elms = _d_elms.ld_cldElmss[_elmIdx];
        };
      };
      return _d_elms;
    };

    let _rdr_tree = (pd2={ // render tree
      ld_elmss: [],
      b_hdrPrs: false,
      b_btnPrs: false,
      b_edt: false,
      d_cldElmDefs: {
        b_hdrPrs: false,
        b_btnPrs: false,
        ob_btnPrs: _d_is => null,
        b_edt: false,
        d_cldElmDefs: {},
      },
      l_elmIdxs: [], // set automatically
      n_lyr: 1, // set automatically
    }) => pd2.ld_elmss?.map( (_d_elms, _elmIdx) => { // elm ごとの処理

      if (pd2.b_withCld == true && bf.f(_d_elms.ld_cldElmss) == false ) { // b_withCld == true の場合、子要素のない親要素は表示しない
        return null;
      };

      if (_d_elms.b_dlt == true) {
        return null;
      };

      //
      let _n_lyr = pd2.n_lyr || 1;
      //
      let _l_crrElmIdxs = bf.myCM_copy(pd2.l_elmIdxs || []); // 選択した要素の行番号
      _l_crrElmIdxs.push(_elmIdx);
      //
      let _l_cpts = []; // component
      _l_cpts = _d_elms.ld_fldss?.map( (_d_flds, _fldIdx) => { // fld ごとの処理
        if (_d_flds.type == 'Inp') {
          return ( 
            <ce.Inp
              key={'{}.{}.{}'.f(_d_elms.elm, _d_elms.key, _d_flds.fld)}
              b_vsb={(bf.f(pd2.ob_vsb)) ? pd2.ob_vsb(_d_elms?.d_is) : pd.b_vsb}
              b_edt={(pd2.b_edt) ? pd2.b_edt : ((bf.f(pd2.ob_edt)) ? pd2.ob_edt(_d_elms?.d_is) : null)}
              state={null}
              d_ids={null}
              ctlVal={_d_flds.ini}
              ini={null}
              pfx={_d_flds.pfx}
              b_mln={pd2.b_mln}
              phd={_d_flds.phd}
              onBlur={pd.onBlur}
              onChg={ _s => {
                global.c?.setState({
                  [pd.state] : bf.p(global.c?.state[pd.state], _next => {
                    let _d_crrElms = _get_crrElm(_next, _l_crrElmIdxs);
                    _d_crrElms.ld_fldss[_fldIdx].val = _s;
                    _d_crrElms.ld_fldss[_fldIdx].b_uid = true;
                  }),
                });
              }}
              onFcs={pd.onFcs}
              onPrs={
                (pd2.onPrs) ?
                  () => pd2.onPrs(_d_elms?.d_is)
                :
                  null
              }
              stlCta={pd2.stlCta || ((pd2.o_stlCta) ? pd2.o_stlCta(_d_elms?.d_is) : null)}
              stlInp={pd2.stlInp || ((pd2.o_stlInp) ? pd2.o_stlInp(_d_elms?.d_is) : null)}
              o_stlVal={(pd2.o_stlVal) ? (() => pd2.o_stlVal(_d_elms?.d_is)) : null}
              n_lyr={_n_lyr}
              d_btnDefs={{
                hdrIconName: (_d_elms.b_cls == true) ? 'chevron-right' : 'chevron-down',
                onHdrPrs: 
                  (pd2.b_hdrPrs == true || (bf.f(pd2.ob_hdrPrs) && pd2.ob_hdrPrs(_d_elms?.d_is) != false)) ? 
                    _d_ids => {
                      global.c?.setState({
                        [pd.state] : bf.p(global.c?.state[pd.state], _next => {
                          let _d_crrElms = _get_crrElm(_next, _l_crrElmIdxs);
                          _d_crrElms.b_cls = (_d_crrElms.b_cls) ? false : true;
                        }),
                      });
                    }
                  : null,
                btnIconName: pd2.btnIconName || 'plus',
                onBtnPrs: // 変更★
                  (pd2.b_btnPrs == true || (bf.f(pd2.ob_btnPrs) && pd2.ob_btnPrs(_d_elms?.d_is) != false)) ? 
                    _d_ids => {
                      if (pd2.onBtnPrs) {
                        let _d_crrElms = _get_crrElm(global.c?.state[pd.state], _l_crrElmIdxs);
                        pd2.onBtnPrs(_d_crrElms.d_is);
                      }
                      else {
                        global.c?.setState({
                          [pd.state] : bf.p(global.c?.state[pd.state], _next => { // 子要素の追加
                            let _d_crrElms = _get_crrElm(_next, _l_crrElmIdxs);
                            if (!bf.f(_d_crrElms.ld_cldElmss)) {
                              _d_crrElms.ld_cldElmss = [];
                            };
//                            _d_crrElms.ld_cldElmss.push(pd2.o_grtCldElm());
                            if (pd2.o_grtCldElm) {
                              _d_crrElms.ld_cldElmss.push(pd2.o_grtCldElm());
                            };
                          }),
                        });
                      };
                    }
                  : null,
                onDltPrs: 
                  (pd2.b_dltPrs == true || (bf.f(pd2.ob_dltPrs) && pd2.ob_dltPrs(_d_elms?.d_is) != false)) ? 
                    _d_ids => { // 本要素の削除
                      global.c?.setState({
                        [pd.state] : bf.p(global.c?.state[pd.state], _next => {
                          let _d_crrElms = _get_crrElm(_next, _l_crrElmIdxs);
                          _d_crrElms.b_dlt = true;
                          _d_crrElms.ld_fldss[_fldIdx].b_uid = true;
                        }),
                      });
                    }
                  : null,
              }}
            />
          )
        };

        if (_d_flds.type == 'Pck') {
//              ld_itemss={_d_flds.ld_itemss}
//              ld_itemss={_d_flds.ld_itemss || ((_d_flds.old_iss) ? _d_flds.old_iss(_d_elms?.d_is) : null)}
//              ld_itemss={_d_flds.ld_itemss || ((_d_flds.old_iss) ? _d_flds.old_iss(_get_crrElm(global.c?.state[pd.state], _l_crrElmIdxs).ld_fldss) : null)}
//bf.l('4493:{}'.f(_d_elms?.d_is))
//bf.l('4494:{}'.f(_l_crrElmIdxs))
//bf.l('4494:{}'.f(_fldIdx))
//bf.l('4495:{}'.f(_get_crrElm(global.c?.state[pd.state], _l_crrElmIdxs)))
//bf.l('4496:{}'.f(_get_crrElm(global.c?.state[pd.state], _l_crrElmIdxs).ld_fldss[_fldIdx]))
//bf.l('4502:{}'.f(_d));
//              ld_itemss={_d_flds.ld_itemss || ((_d_flds.old_iss) ? _d_flds.old_iss(_d) : null)}
          return ( 
            <ce.Pck
              key={'{}.{}.{}'.f(_d_elms.elm, _d_elms.key, _d_flds.fld)}
              b_vsb={pd.b_vsb}
              b_edt={pd2.b_edt}
              state={null}
              d_ids={null}
              ctlVal={_d_flds.ini}
              ini={null}
              pfx={_d_flds.pfx}
              phd={_d_flds.phd}
              onBlur={pd.onBlur} // (_key, _d_items) => {}
              ld_itemss={_d_flds.ld_itemss}
              onChg={ (_key, _d_is) => {
                global.c?.setState({
                  [pd.state] : bf.p(global.c?.state[pd.state], _next => {
                    let _d_crrElms = _get_crrElm(_next, _l_crrElmIdxs);
                    _d_crrElms.ld_fldss[_fldIdx].val = _key;
                    _d_crrElms.ld_fldss[_fldIdx].d_is = _d_is;
                    _d_crrElms.ld_fldss[_fldIdx].b_uid = true;
                  }),
                }, () => {
//bf.l('4531:{}'.f(_get_crrElm(global.c?.state[pd.state], _l_crrElmIdxs).ld_fldss[_fldIdx]))
                });
              }}
              stlCta={pd.stlCta}
              stlPfx={pd.stlPfx}
              n_col={pd.n_col}
              stlLbl={pd.stlLbl}
              n_lyr={_n_lyr}
            />

          )
        };
      });

      if (pd2.d_cldElmDefs && bf.f(_d_elms.ld_cldElmss && _d_elms.b_cls != true)) {
        _l_cpts.push(_rdr_tree(bf.p(pd2.d_cldElmDefs, _next => {
          _next.ld_elmss = _d_elms.ld_cldElmss;
          _next.l_elmIdxs = _l_crrElmIdxs;
          _next.n_lyr = _n_lyr + 1;
        })));
      };

//bf.l('4487:{}'.f(_d_elms.ld_cldElmss))
      return _l_cpts;
    });

    _r = _rdr_tree(bf.p(pd.d_elmDefs, _next => {
      _next.ld_elmss = global.c?.state[pd.state];
    }));

    return (
      <View
        key={-1}
      >
        <ce.Lbl
          key={-1}
          b_vsb={(pd.pfx) ? true : false}
          pfx={pd.pfx}
          iconName={'plus'}
          onBtnPrs={
            (pd.b_edt) ? 
              () => {
                global.c?.setState({
                  [pd.state] : bf.p(global.c?.state[pd.state], _next => {
                    _next.push(
                      pd.d_elmDefs.o_grtElm(),
                    )
                  }),
                }, () => {
                })
              }
            : null }
          stlCta={{
          }}
          stlPfx={{
          }}
        />
        {_r}
      </View>
    );
  }
*/

  static InpTree3 = (pd={
    b_vsb: true,
    b_edt: true,
    state: { // dld_datsss
      als: [
        {
          elm: '',
          key: '',
          b_new: false,
          b_upd: false,
          b_dlt: false,
          b_hideCld: false, // 子要素の表示状況
          d_flds: {
            fld: {
              val: '',
              sts: 'chg', 
            },
          },
          dld_cldDatsss: dld_datsss, // 子要素
        }
      ],
    },    
    dd_elmDefss: { // ddd_defsss
      als: {
        dd_fldDefs: {
          fld: {
            b_dltPrs: false,
            ob_dltPrs: _d_dats => false,
            ini: '',
            phd: '',
            type: 'Inp/Pck',
            n_col: 0,
            b_mln: false, // only for Inp
            ld_is: [
              {key: '', pfx: ''},
            ], // for Pck
            old_iss: _d_is => [
              {key: '', pfx: ''},
            ], // for Pck
          },
        },
        b_row: false,
        d_clds: ddd_defsss, 
        b_vsb: true,
        ob_vsb: _d_is => true,
        b_edt:  false,
        ob_edt: _d_is => false,
        b_hdrPrs: false,
        ob_hdrPrs: _d_is => false,
        hdrIconName: null,
        onHdrPrs: null,
        b_btnPrs: false,                  
        ob_btnPrs: _d_is => false,                  
        btnIconName: 'chevron-right',
        onBtnPrs: null,
        dltIconName: null,
        onDltPrs: null,
        o_addNewElm: null,
        stlCta: {
        },
        stlInp: {
        },
        onPrs: _d_is => {
        },
        b_hideNoCld: false,
        dd_cldDefss: {
        },
        d_chks: {
          b_vsb: false,
        }
      },
    },
  }) => { // inputs

//bf.l('4795: {}'.f(pd.state))

    if (pd.b_vsb == false) return null; // b_vsb == false の場合は非表示

    if (bf.f(global.c?.state[pd.state]) == false) return null;

/*
    const _get_dat = (pdld_datsss, pld_adrss) => { // pld_elmTreess において pl_pntIdxs/pn_datIdx で指定された dat を取得する
      let _d_dats = pld_adrss.reduce( ( _prev, _d_adrs ) => {
        if ( _prev == null ) {
          return pdld_datsss[_d_adrs.als][_d_adrs.idx];
        }
        else {
          return _prev.dld_cldDatsss[_d_adrs.als][_d_adrs.idx];
        };
      }, null);
      return _d_dats;
    };
*/
    const _get_dat = (pdld_datsss, pld_adrss, pb_prt=false) => { // pld_elmTreess において pl_pntIdxs/pn_datIdx で指定された dat を取得する
      let _ld_adrss = pld_adrss;
      if ( pb_prt && bf.f(_ld_adrss) ) _ld_adrss = _ld_adrss.slice(0,-1); // 親要素を取得する場合
      if ( bf.f(_ld_adrss) == false || bf.f(pdld_datsss) == false) {
        return pdld_datsss;
      }
      else {
        let _d_dats = _ld_adrss.reduce( ( _prev, _d_adrs ) => {
          if ( _prev == null ) {
            return pdld_datsss[_d_adrs.als][_d_adrs.idx];
          }
          else {
            return _prev.dld_cldDatsss[_d_adrs.als][_d_adrs.idx];
          };
        }, null);
        return _d_dats;
      };
    };

    const _chkNoCld = pdld_cldDatsss => {
      return Object.keys(pdld_cldDatsss)
      .reduce( ( _prev, _als ) => {
        if ( _prev == false ) return false;
        if ( bf.f(pdld_cldDatsss[_als]) == true ) return false;
        return true;
      }, true);
    };

    const _od_elmDefsIni = (pd={
      elm: '',
    }) => ({
      elm: pd.elm,
      pfx: '',
      b_vsb: true,
      ob_vsb: null, // b_newLine に影響
      b_edt: true,
      b_row: false,
      b_hideOnNoCld: false,
      b_noStep: false, // 段差の有無
      od_insDats: null, // (_d_flds, _d_dats) => ({}),
      dd_fldDefss: null,
      dd_cldDefss: null,        
      ld_sortss: null,
      b_newLine: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false, // 新規行が不要の場合は false
      b_mplLine: false,
    }); 

    const _od_fldDefsIni = (pd={
    }) => ({ // 初期値
      type: '', // Inp, Pck
      b_vsb: true,
      b_edt: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
      b_hdrPrs: false,
      btnIconName: 'plus',
      b_btnPrs: false,
      onBtnPrs: null,
      b_dltPrs: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
      ini: '',
      pfx: '',
      sfx: null,
      o_sfx: null,
      phd: '入力ください',
      ld_iss: [],
      b_mln: false,
      stlCta: null,
      stlInp: null,
      stlLbl: null,
      n_col: null,
      n_sort: 1,
    });

    const _od_insDatsIni = (pd={
      elm: '',
    }) => ({
      elm: pd.elm,
      key: null,
      idx: null,
      d_flds: {}, // _KEY が null の場合に 新規登録と判定するため _KEY に初期値を設定しないこと
      dd_stgss:{},
      b_upd: false,
      b_new: true, // b_new = true かつ b_upd = true が ins 対象 ( b_new のみで判断した場合、空白行も登録されてしまう )
      b_dlt: false,
      b_hideCld: false,
      dld_cldDatsss: null,
      dd_prtss:{},                                    
    });

    const _rdr_tree = (pd2={ // render tree
      als: '', // alias
      d_elmDefs: {}, // ddd_defsss[_als],
      ld_elmDatss: [], // dld_datsss[_als],
      ld_adrss: [], // set automatically
      n_lyr: 1, // set automatically
    }) => {

      let _d_elmDefs = bf.c(
        _od_elmDefsIni({ // 初期値の定義
          elm: pd2.als,
        }), 
        pd2.d_elmDefs || {}
      ); 

      let _ld_elmDatss = pd2.ld_elmDatss; // [] で置き換えた場合、state に値が反映されないことに注意

      if (
        _d_elmDefs.b_newLine == true &&
        bf.f(_ld_elmDatss) == false
      ) { // 空白行ありの場合
        let _d_insDats = bf.c(
          _od_insDatsIni({
            elm: _d_elmDefs.elm,
          }), 
          _d_elmDefs.d_insDats
        );
        _ld_elmDatss.push(_d_insDats);
      }


      return _ld_elmDatss
      .filter( _d_elmDats => {
        let _b = _d_elmDefs.ob_vsb ? _d_elmDefs.ob_vsb(_d_elmDats) : _d_elmDefs.b_vsb;
        return _b;
      })
      .map( (_d_dats, _datIdx) => { // elm ごとの処理

        if ( _d_elmDefs.b_hideOnNoCld && _chkNoCld(_d_dats.dld_cldDatsss) ) return null; // 子要素のない親要素は表示しない
        if ( _d_dats.b_dlt == true ) return null;

        let _ld_adrss = bf.myCM_copy(pd2.ld_adrss || []); // 選択した要素の行番号
        _ld_adrss.push({
          als: pd2.als, 
          idx: _datIdx
        });

        let _n_lyr = pd2.n_lyr || 1;

        let _l_cpts = []; // component
        _l_cpts = Object.keys(_d_dats.d_flds)
        .filter( _fld => {
          if ( bf.f(_d_elmDefs.dd_fldDefss[_fld]) == true ) return true;
          return false;
        })
        .sort( (_fld1, _fld2) => {
          let _n_sort1 = _d_elmDefs.dd_fldDefss[_fld1].n_sort || 0;
          let _n_sort2 = _d_elmDefs.dd_fldDefss[_fld2].n_sort || 0;
          if ( _n_sort1 > _n_sort2 ) return 1; 
          if ( _n_sort1 < _n_sort2 ) return -1; 
          return 0;
        })
        .map( ( _fld, _fldIdx ) => { // fld ごとの処理

          let _d_fldDefs = bf.c(
            _od_fldDefsIni({}),
            _d_elmDefs.dd_fldDefss[_fld]
          ); 

          if (_d_fldDefs.type == 'Inp') {
/*
                onBlur={null}
*/
            return ( 
              <ce.Inp
                key={'{}.{}.{}'.f(pd2.als, _d_dats.key, _fld)}
                b_vsb={ (_d_fldDefs.ob_vsb) ? _d_fldDefs.ob_vsb(_d_dats) : _d_fldDefs.b_vsb}
                b_edt={ (_d_fldDefs.ob_edt) ? _d_fldDefs.ob_edt(_d_dats) : _d_fldDefs.b_edt}
                state={null}
                d_ids={null}
                ctlVal={_d_dats.d_flds[_fld] || null}
                ini={_d_fldDefs.ini}
                pfx={_d_fldDefs.pfx}
                sfx={ (_d_fldDefs.o_sfx) ? _d_fldDefs.o_sfx(_d_dats) : _d_fldDefs.sfx}
                b_mln={_d_fldDefs.b_mln}
                phd={_d_fldDefs.phd}
                onBlur={ () => { // ios では onBlur が機能しない模様
/*
                  global.c?.setState({
                    [pd.state] : bf.p(global.c?.state[pd.state], _next => {
                      let _d_crrDats = _get_dat(_next, _ld_adrss);
                      if ( bf.f(_d_crrDats.dd_stgss[_fld]) == false ) _d_crrDats.dd_stgss[_fld] = {};
                      _d_crrDats.dd_stgss[_fld].b_chg = true;
                      _d_crrDats.b_upd = true;
//bf.l('5156: {}'.f(_d_crrDats));
                    }),
                  }, () => {
bf.l('5191: {}'.f(global.c?.state[pd.state]));
                  });
*/
                }}
                onChg={ _s => {
//bf.l('5135: {}, {}'.f(pd.state, _s))
                  global.c?.setState({
                    [pd.state] : bf.p(global.c?.state[pd.state], _next => {
                      let _d_crrDats = _get_dat(_next, _ld_adrss);
                      _d_crrDats.d_flds[_fld] = _s;
//                      if ( bf.f(_d_crrDats.dd_stgss[_fld]) == false ) _d_crrDats.dd_stgss[_fld] = {};
//                      _d_crrDats.dd_stgss[_fld].b_chg = true;
//                      _d_crrDats.b_upd = true;
//bf.l('5156: {}'.f(_d_crrDats));
                      if ( bf.f(_d_crrDats.dd_stgss[_fld]) == false ) _d_crrDats.dd_stgss[_fld] = {};
                      _d_crrDats.dd_stgss[_fld].b_chg = true;
                      _d_crrDats.b_upd = true;
                    }),
                  });
                }}
                onFcs={null}
                onPrs={
                  (_d_fldDefs.onFldPrs) ?
//                    () => _d_fldDefs.onFldPrs(_d_dats.d_flds, _d_dats)
                    () => _d_fldDefs.onFldPrs(_d_dats)
                  :
                    null
                }
                stlCta={(_d_fldDefs.o_stlCta) ? _d_fldDefs.o_stlCta(_d_dats) : _d_fldDefs.stlCta}
                stlInp={(_d_fldDefs.o_stlInp) ? _d_fldDefs.o_stlInp(_d_dats) : _d_fldDefs.stlInp}
                stlLbl={(_d_fldDefs.o_stlLbl) ? _d_fldDefs.o_stlLbl(_d_dats) : _d_fldDefs.stlLbl}
                stlSfx={(_d_fldDefs.o_stlSfx) ? _d_fldDefs.o_stlSfx(_d_dats) : _d_fldDefs.stlSfx}
                o_stlVal={(_d_fldDefs.o_stlVal) ? (() => _d_fldDefs.o_stlVal(_d_dats)) : null}
                n_col={_d_fldDefs.n_col}
                n_lyr={_n_lyr}
                d_btnDefs={{
                  hdrIconName: (_d_dats.b_hideCld == true) ? 'chevron-right' : 'chevron-down',
                  onHdrPrs: 
                    (_d_fldDefs.b_hdrPrs == true || (bf.f(_d_fldDefs.ob_hdrPrs) && _d_fldDefs.ob_hdrPrs(_d_dats) != false)) ? 
                      _d_ids => {
                        global.c?.setState({
                          [pd.state] : bf.p(global.c?.state[pd.state], _next => {
                            let _d_crrDats = _get_dat(_next, _ld_adrss);
                            _d_crrDats.b_hideCld = (_d_crrDats.b_hideCld) ? false : true;
                          }),
                        });
                      }
                    : null,
                  btnIconName: _d_fldDefs.btnIconName || 'plus',
                  onBtnPrs:
                    (_d_fldDefs.b_btnPrs == true || (_d_fldDefs.ob_btnPrs && _d_fldDefs.ob_btnPrs(_d_dats) != false)) ? 
                      _d_ids => {
                        if (_d_fldDefs.onBtnPrs) {
                          _d_fldDefs.onBtnPrs(_d_dats.d_flds, _d_dats);
                        }
                        else {
                          global.c?.setState({
                            [pd.state] : bf.p(global.c?.state[pd.state], _next => { // 子要素の追加
                              let _d_crrDats = _get_dat(_next, _ld_adrss);
                              Object.keys(_d_elmDefs.dd_cldDefss)
                              .map( _als => {
                                let _d_cldDefs = _d_elmDefs.dd_cldDefss[_als];
                                if (
                                  !_d_crrDats.dld_cldDatsss
                                ) {
                                  _d_crrDats.dld_cldDatsss = {};
                                }; 
                                if (
                                  !_d_crrDats.dld_cldDatsss[_als]
                                ) {
                                  _d_crrDats.dld_cldDatsss[_als] = [];
                                };
                                if (_d_cldDefs.d_insDats) {
                                  let _d_insDats = bf.c(
                                    _od_insDatsIni({
                                      elm: _d_cldDefs.elm || _als,
                                    }),
                                    _d_cldDefs.d_insDats || {}
                                  );
//bf.l('5041: {}'.f(_d_crrDats.dld_cldDatsss));
                                  _d_crrDats.dld_cldDatsss[_als].push(_d_insDats);
                                };
                              });
                            }),
                          });
                        };
                      }
                    : null,
                  btnStlCta: _d_fldDefs.btnStlCta,
                  onDltPrs: 
                    (_d_fldDefs.b_dltPrs == true || (_d_fldDefs.ob_dltPrs && _d_fldDefs.ob_dltPrs(_d_dats) != false)) ? 
                      _d_ids => { // 本要素の削除
                        global.c?.setState({
                          [pd.state] : bf.p(global.c?.state[pd.state], _next => {
                            let _d_crrDats = _get_dat(_next, _ld_adrss);
                            _d_crrDats.b_dlt = true;
//bf.l('5220: {}'.f(_d_crrDats));
                          }),
                        });
                      }
                    : null,
                }}
              />
            )
          };

          if ( _d_fldDefs.type == 'Pck') {
//                ctlVal={_d_fldDefs.ini}
//                ini={null}
            return ( 
              <ce.Pck
                key={'{}.{}.{}'.f(_d_dats.elm, _d_dats.key, _fld)}
                b_vsb={ (_d_fldDefs.ob_vsb) ? _d_fldDefs.ob_vsb(_d_dats) : _d_fldDefs.b_vsb}
                b_edt={ (_d_fldDefs.ob_edt) ? _d_fldDefs.ob_edt(_d_dats) : _d_fldDefs.b_edt}
                state={null}
                d_ids={null}
                ctlVal={_d_dats.d_flds[_fld] || null}
                ini={_d_fldDefs.ini}
                pfx={_d_fldDefs.pfx}
                phd={_d_fldDefs.phd}
                onBlur={null} // (_key, _d_items) => {}
                ld_iss={_d_fldDefs.ld_iss}
                onChg={ _d_is => {
                  global.c?.setState({
                    [pd.state] : bf.p(global.c?.state[pd.state], _next => {
                      let _d_crrDats = _get_dat(_next, _ld_adrss);
                      _d_crrDats.d_flds[_fld] = _d_is.key;
                      if (bf.f(_d_crrDats.dd_stgss[_fld]) == false ) _d_crrDats.dd_stgss[_fld] = {};
                      _d_crrDats.dd_stgss[_fld].b_chg = true;
                      _d_crrDats.b_upd = true;
                      _d_crrDats.dd_stgss[_fld].d_rfrs = _d_is;
                    }),
                  }, () => {
                  });
                }}
                stlCta={(_d_fldDefs.o_stlCta) ? _d_fldDefs.o_stlCta(_d_dats) : _d_fldDefs.stlCta}
                stlPfx={(_d_fldDefs.o_stlInp) ? _d_fldDefs.o_stlInp(_d_dats) : _d_fldDefs.stlInp}
                stlLbl={(_d_fldDefs.o_stlLbl) ? _d_fldDefs.o_stlLbl(_d_dats) : _d_fldDefs.stlLbl}
                stlLbl={_d_fldDefs.stlLbl}
                n_col={_d_fldDefs.n_col}
                n_lyr={_n_lyr}
              />

            )
          };
        });

        if ( _d_elmDefs.b_row == true ) { // データ項目を一行で表示する場合
          _l_cpts = [(
            <ce.Row
              key={'InpTree.{}.{}'.f(_d_dats.elm, _datIdx)}
              stlCta={{
                width: global.c?.state.sgcd_dmns.n_bdyW,
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              { (_d_elmDefs.d_chks?.b_vsb) ? // chk ありの場合
                ce.c(ce.Chk, { 
                  key: -1,
                  b_val: _d_dats.b_chk ?? _d_elmDefs.d_chks?.b_iniVal,
                  b_edt: 
                    (_d_elmDefs.d_chks?.ob_edt) ?
                      _d_elmDefs.d_chks?.ob_edt(_d_dats)
                    : (_d_elmDefs.d_chks?.b_edt != false) ? 
                      true 
                    : false, 
                  o_onPrs: _b_val => {
//bf.l('5613: {}, {}'.f(_b_val, pd.state))
                    global.c?.setState({
                      [pd.state] : bf.p(global.c?.state[pd.state], _next => {
//bf.l('5616: {}'.f(_ld_adrss))
                        let _d_crrDats = _get_dat(_next, _ld_adrss);
//bf.l('5618: {}'.f(_d_crrDats))
                        _d_crrDats.b_chk = _b_val;
//bf.l('5620: {}'.f(_d_crrDats))
                      }),
                    });
                  },
                  stlCta: {
                    width: ic.gn_btnWSml,
                  },
                })
              : null }
              {_l_cpts}
            </ce.Row>
          )];
        };

        if ( _d_elmDefs.dd_cldDefss && _d_dats.b_hideCld != true ) {
          Object.keys(_d_elmDefs.dd_cldDefss)
          .map( _als => {
            if (_d_elmDefs.dd_cldDefss && _d_dats.dld_cldDatsss) {
              let _d_cldDefs = _d_elmDefs.dd_cldDefss[_als];
              let _ld_cldDatss = _d_dats.dld_cldDatsss[_als];
              _l_cpts.push(
                _rdr_tree({
                  als: _als,
                  d_elmDefs: _d_cldDefs, 
                  ld_elmDatss: _ld_cldDatss,
                  ld_adrss: _ld_adrss,
                  n_lyr: (_d_cldDefs.b_noStep) ? _n_lyr : _n_lyr + 1,
                })
              );
            };
          });
        };

        return _l_cpts;
      });
    };

    let _r = [];
    
    Object.keys(global.c?.state[pd.state])
    .map( _als => {
      let _d_elmDefs = bf.c(
        _od_elmDefsIni({
          elm: _als
        }), 
        pd.dd_elmDefss[_als] || {}
      ); 

      let _ld_elmDatss = global.c?.state[pd.state][_als];
      let _r2 = _rdr_tree({
        als: _als,
        d_elmDefs: _d_elmDefs,
        ld_elmDatss: _ld_elmDatss,
      });

      _r.push(
        <View
          key={-1}
        >
          <ce.Lbl
            key={-1}
            b_vsb={bf.f(_d_elmDefs.pfx) ? true : false}
            pfx={_d_elmDefs.pfx}
            iconName={_d_elmDefs.d_btns?.iconName ?? 'plus'}
            onBtnPrs={
              ( _d_elmDefs.d_btns?.onPrs ) ? 
                _d_elmDefs.d_btns?.onPrs
              : (
                bf.i(global.c?.state.sgc_pageMode, ['new', 'edit']) &&
                _d_elmDefs.d_insDats 
              ) ? 
                () => {
                  global.c?.setState({
                    [pd.state] : bf.p(global.c?.state[pd.state], _next => {
                      let _d_insDats = bf.c(
                        _od_insDatsIni({
                          elm: _d_elmDefs.elm,
                        }),
                        _d_elmDefs.d_insDats || {}
                      );
                      _next[_als].push(
                        _d_insDats,
                      )
                    }),
                  }, () => {
                  })
                }
              : null }
            stlCta={{
            }}
            stlPfx={{
            }}
          />
          { _r2 }
        </View>
      );
    })

    return _r;

  }

  // mdl は root と同階層で定義する
  // 仮に mdl を bdy 内で定義した場合、bdy 内部のスクロールに合わせて、mdl の表示位置が変わってしまう
  // なお、root の zIdx は bdy の zIdx よらず打ち勝つため、root で定義した overlay を bdy 内の cpt で共有することはできない
  static Mdl(pd){

    if (global.c?.state.sgcd_mdls[pd.mdlType]?.b_showMdl != true) { // sgcd_mdls に mdlType が定義されていない場合、エラーとなる
      return null;
    };

    return (
      <View
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: ic.gn_zIdxMdl,
          backgroundColor: 'rgba(0,0,0,0.2)',
//          height: ic.gn_h,
          height: global.c?.state.sgcd_dmns.n_h,
          width: global.c?.state.sgcd_dmns.n_w,
        }}
      >
        <View
          style={[{
            backgroundColor: ic.g_ccdWN,
//            maxHeight: ic.gn_mdlH,
//            maxHeight: ic.gn_h - ic.gn_mgnNrm * 2,
            maxHeight: global.c?.state.sgcd_dmns.n_h - ic.gn_mgnNrm * 2,
            width: (global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2),
            borderRadius: ic.gn_bdrRdsNrm,
            marginTop: 'auto',
            marginBottom: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }, pd.stlMenu]}
        >
          <ce.BtnIcon
            b_vsb={true}
            iconName="close"
            onPrs={()=>{
              if (pd.onCls) {
                pd.onCls()
              }
              global.c?.setState({
                sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                  _next[pd.mdlType].b_showMdl = false;
                }),
              });
            }}
            stlCta={{
              width: (global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2),
            }}
            stlBtn={{
              backgroundColor: ic.gn_backCcd,
              marginLeft: 'auto',
              marginRight: 0,
            }}
          />
          <View
            style={{
//              maxHeight: ic.gn_mdlH - ic.gn_btnIconSize - ic.gn_mgnNrm * 2,
//              maxHeight: ic.gn_h - ic.gn_mgnNrm * 2 - ic.gn_btnIconSize - ic.gn_mgnNrm * 2,
              maxHeight: global.c?.state.sgcd_dmns.n_h - ic.gn_mgnNrm * 2 - ic.gn_btnIconSize - ic.gn_mgnNrm * 2,
              width: (global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2),
              marginTop: ic.gn_mgnNrm,
              marginBottom: ic.gn_mgnNrm,
              marginLeft: 0,
              marginRight: 0,
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 0,
              paddingRight: 0,
            }}
          >
            {(pd.children) ? pd.children : global.c?.state.sgco_mdlChd}
          </View>
        </View>
      </View>
    );
  };

    static Link (pd) {
      return (
        <Text
          style={[{
            fontSize: ic.gn_fontSizeNrm,
            color: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
            textDecorationLine: 'underline',
          }, pd.stlLink]}
          onPress={async ()=>{
            if (bf.f(pd.url)) {
              if (cf.myRN_chk_os('w')) { // web の場合
                cf.myRN_open_url(pd.url);
              }
              else { // スマホ の場合
                let _fdr = await cf.myFS_get_rootFdr();
                await cf.myFS_make_fdr(_fdr);                                    
//                let _name = _fdr + pd.children;
//                let _name = _fdr + 'test.csv';
                let _name = _fdr + encodeURI(pd.children);
                cf.myFS_open_url(pd.url, _name); // FileSystem は WEB に対応していない。サーバー側でファイル名の変更が必要か
              };
            };
            if (bf.f(pd.file)) {
              if (cf.myRN_chk_os('w') == false) {
                let _fdr = await cf.myFS_get_rootFdr();
                await cf.myFS_make_fdr(_fdr)                          
//                let _name = _fdr + 'test.csv';
                let _name = _fdr + encodeURI(pd.file.name); // 日本語ファイル名への対応
                cf.myFS_open_url(pd.file.url, _name); // FileSystem は WEB に対応していない。サーバー側でファイル名の変更が必要か
              }
              else {
                cf.myRN_open_url(pd.file.url);
                //Sharing.shareAsync(pd.file.url) // https 化すれば動く模様
              }
            };                    
            if (pd.onPrs) {
              pd.onPrs();
            };
          }}
        >
          {pd.children}
        </Text>
      )
    }

    static Mp4 (pd) {
        //
        let _r = [];

        let _o_video = null;
        //
        return (
            <>
                { (pd.b_vsb != false) ?
                    <View>
                        { (pd.pfx) ?
                            <View
                                style={{
                                    width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                                    marginTop: ic.gn_mgnNrm,
                                    marginBottom: ic.gn_mgnNrm,
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                }}
                            >
                                <Text 
                                    style={ [{
                                        fontSize: ic.gn_fontSizeSml,
                                        color: ic.g_fontCcdSml,
                                        paddingTop: ic.gn_mgnNrm,
                                        paddingBottom: ic.gn_mgnNrm,
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        fontWeight: 'bold',
                                    }, pd.stlPfx] }
                                >
                                    { pd.pfx }
                                </Text>
                            </View>
                        : null }
                        <View
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <View
                                style={[{
                                    height: (((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW) / (16/9),
                                    width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                                    marginTop: ic.gn_mgnNrm,
                                    marginBottom: ic.gn_mgnNrm,
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                }, pd.stlCta]}
                            >
                                <TouchableOpacity
                                    activeOpacity={0.0}
                                    onPress={()=>{
                                        if (pd.b_edt == true) { // 編集モードの場合
                                            cf.myIP_pick_img((_d_items) => {
                                                if ( global.c != null && pd.state != null ) {
                                                    global.c?.setState({[pd.state]:String(_d_items.uri)})
                                                };
                                                if (pd.onPrs) {
                                                    pd.onPrs(_d_items); // {height:, duration:, uri:, type:, width:}
                                                };
                                            }, 'video');                        
                                        };                                        
                                        if (pd.b_edt == false) {
                                            _o_video.getStatusAsync().then((_res)=>{
                                                if (_res.shouldPlay == false) { // 最初から再生
                                                    _o_video.setStatusAsync({
                                                        positionMillis: 0,
                                                        shouldPlay: true
                                                    });
                                                };
                                            });
                                        };
                                    }}
                                >

                                    { ((global.c != null && pd.state != null && cf.b(global.c?.state[pd.state]) == false) || (!bf.f(pd.uri) == false)) ?

                                        <Video
                                            source={{ uri: (global.c != null && pd.state != null && cf.b(global.c?.state[pd.state]) == false) ? global.c?.state[pd.state] : String(pd.uri)}}
                                            rate={1.0}
                                            volume={1.0}
                                            isMuted={true}
                                            resizeMode={Video.RESIZE_MODE_CONTAIN}
                                            shouldPlay={false}
                                            useNativeControls={true}
                                            isLooping={false}
                                            usePoster={true}
                                            ref = {(_o) => {
                                                _o_video = _o;
                                            }}
                                            style={{ 
                                                height: (((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW) / (16/9),
                                                width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                                            }}
                                        />
                                    :
                                        <View
                                            style={{
                                                height: '100%',
                                                width: '100%',
                                                backgroundColor: ic.g_ccdHP,
                                                borderRadius: ic.gn_bdrRdsNrm,
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Text
                                                style={{
                                                    fontSize: ic.gn_fontSizeNrm,
                                                    color: ic.g_ccdWN,
                                                }}
                                            >
                                                {pd.msg}
                                            </Text>
                                        </View>
                                    }
                                </TouchableOpacity>
                            </View>
                        </View>
                    </View>
                : null }
            </>
        );
    }

    static Msg = (pd={
      b_vsb: true,
      pfx: '',
      n_pntW: 0,
      stlCta: {},
      stlPfx: {},
    }) => {
      if (pd.b_vsb == false) {
        return null;
      };

      return (
        <View style={[{
          width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2,
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: ic.gn_mgnLrg,
          marginBottom: ic.gn_mgnLrg,
          paddingStart: 0,
          paddingEnd: 0,
          paddingTop: 0,
          paddingBottom: 0,
        }, pd.stlCta]}>
          <Text
            style={[{
              fontSize: ic.gn_fontSizeNrm,
              color: ic.g_fontCcdNrm,
            }, pd.stlPfx]}
          >
            { pd.pfx }
          </Text>
        </View>
      );
    }

    static Pck(pd) {
//bf.l('5481: {}'.f(pd.ld_iss))
      //
      return (
        <ce._fld
          key={-1}
          b_vsb={pd.b_vsb}
          b_edt={pd.b_edt}
          state={pd.state}
          pfx={pd.pfx}
          ini={(
            pd.ld_iss && 
            pd.ini && 
            bf.myCM_get_dct({ld_itemss:pd.ld_iss, fld:'key', val:pd.ini}) 
          ) ? bf.myCM_get_dct({ld_itemss:pd.ld_iss, fld:'key', val:pd.ini}).pfx 
            : null
          }
          d_ids={pd.d_ids}
          ctlVal={pd.ctlVal}
          phd={(pd.phd) ? pd.phd : ((pd.b_edt) ? '選択ください' : '')}
          phdCcd={pd.phdCcd}
          mdlType={'pck'}
          ld_iss={pd.ld_iss}
          b_newLine={false}
          onFldPrs={() => {
            global.c?.setState({
              sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                _next.pck.ld_iss = pd.ld_iss?.filter(_d_is => (_d_is.b_show != false) ? true : false); // b_hide == true は list 表示の対象外
              }),
            }, ()=>{
            });
          }}
          onDltPrs={pd.onDltPrs}
          onChg={(_d_items) => { // pck の場合、mdl で処理するため、onBlur が意味をなさないことに注意
            if (pd.state) { // clds でない場合
              global.c?.setState({ // clds でない場合は onChg において state に反映されて、clds の場合は 
                [pd.state]: _d_items.key,
              }, ()=>{
                if(pd.onChg){
                  pd.onChg(_d_items);
                };
              });
            }
            else { // clds の場合
              if(pd.onChg){
                pd.onChg(_d_items, pd.d_ids); // clds の二重登録を防ぐために itemKey が必要
              }
            };
          }}
          stlCta={pd.stlCta}
          stlPfx={pd.stlPfx}
          n_col={pd.n_col}
          stlLbl={pd.stlLbl}
          n_lyr={pd.n_lyr}
        />
      );
    };

  static PckMdl(pd) { // 選択された項目を d_slcItems に反映し、_fld で処理

    let _r = [];

//    for (let [_idx, _d_items] of bf.e(global.c?.state.sgcd_mdls.pck.ld_itemss)) {
    for (let [_idx, _d_items] of bf.e(global.c?.state.sgcd_mdls.pck.ld_iss)) {

      if (_d_items.b_dlt == true) { // b_dlt が true である item は表示対象外
        continue;
      };

      _r.push(
        <TouchableOpacity
          key={_idx}
          onPress={()=>{
//alert('4402:{}'.f(_d_items))
            global.c?.setState({
              sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                _next.pck.d_slcItems = _d_items;
                _next.pck.b_showMdl = false;
              }),
            }, ()=>{
//alert('4409:{}'.f(global.c?.state.sgcd_mdls.pck.d_slcItems))
            });
          }}
        >
          <View style={{
            width: (global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            marginTop: ic.gn_mgnNrm,
            marginBottom: ic.gn_mgnNrm,
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingTop: ic.gn_mgnNrm,
            paddingBottom: ic.gn_mgnNrm,
            paddingLeft: ic.gn_mgnNrm,
            paddingRight: ic.gn_mgnNrm,
            borderWidth: ic.gn_bdrWNrw * 1.5,
            borderColor: '#bbbbbb',
            borderRadius: ic.gn_bdrRdsNrm,
          }}>
            <Text
              style={{
                fontSize: ic.gn_fontSizeNrm,
                color: ic.g_fontCcdNrm,
                textAlign: 'center',
              }}
            >
              {_d_items.pfx}
            </Text>
          </View>
        </TouchableOpacity>
      );
    };

    return (
      <ce.Mdl
        key={-1}
        mdlType={'pck'}
      >
        <ScrollView
          key={-1}
          showsVerticalScrollIndicator={true}
        >
          {_r}
        </ScrollView>
      </ce.Mdl>
    );
  };

  static MenuMdl(pd) { // 選択された項目を d_slcItems に反映し、_fld で処理

    let _r = global.c?.state.sgcd_mdls.menu.ld_iss
    .filter( _d_is => (_d_is) ? true : false )
    .map( (_d_is, _idx) => {
      return (
        <TouchableOpacity
          key={_idx}
          onPress={()=>{
            global.c?.setState({
              sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                _next.menu.b_showMdl = false;
              }),
            }, ()=>{
              if (_d_is.onPrs) {
                _d_is.onPrs();
              };
            });
          }}
        >
          <View style={{
            width: (global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            marginTop: ic.gn_mgnNrm,
            marginBottom: ic.gn_mgnNrm,
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingTop: ic.gn_mgnNrm,
            paddingBottom: ic.gn_mgnNrm,
            paddingLeft: ic.gn_mgnNrm,
            paddingRight: ic.gn_mgnNrm,
            borderWidth: ic.gn_bdrWNrw * 1.5,
            borderColor: '#bbbbbb',
            borderRadius: ic.gn_bdrRdsNrm,
          }}>
            <Text
              style={{
                fontSize: ic.gn_fontSizeNrm,
                color: ic.g_fontCcdNrm,
                textAlign: 'center',
              }}
            >
              {_d_is.pfx}
            </Text>
          </View>
        </TouchableOpacity>
      );
    });

    return (
      <ce.Mdl
        key={-1}
        mdlType={'menu'}
      >
        <ScrollView
          key={-1}
          showsVerticalScrollIndicator={true}
        >
          {_r}
        </ScrollView>
      </ce.Mdl>
    );
  };

  static FileMdl(pd) { // File Inport 用のモーダル
    return (
      <ce.Mdl
        key={-1}
        mdlType={'file'}
      >
        { (df.Dzn) ?
          <df.Dzn
            key={-1}
            onDrop={ _lo_files => {
              global.c?.setState({
                sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                  _next.file.b_showMdl = false;
                }),
              }, () => {
                _lo_files.map(_o_file => {
                  bf.myFL_read({
                    mode: global.c?.state.sgcd_mdls?.file?.mode, 
                    o_file: _o_file
                  })
                  .then( _r => {
//bf.l('6262: {}'.f(_r));
                    if (global.c?.state.sgcd_mdls?.file?.onRead) {
                      global.c?.state.sgcd_mdls.file.onRead(_r);
                    };
                  });
                });
              });
            }}
            multiple={true}
          >
            {({ getRootProps, getInputProps }) => {
              return (
                <div
                  {...getRootProps()}
                  style={{
                    height: ic.gn_fontSizeNrm * 5 + ic.gn_mgnNrm * 2,
                    width: (global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2) - ic.gn_mgnNrm * 3,
                    borderWidth: ic.gn_bdrWNrm,
                    borderStyle: 'dashed',
                    borderColor: '#E0E0E0',
                    marginTop: ic.gn_mgnNrm,
                    marginBottom: ic.gn_mgnNrm,
                    marginLeft: ic.gn_mgnNrm,
                    marginRight: ic.gn_mgnNrm,
                    paddingTop: 'auto',
                    paddingBottom: 'auto',
                    paddingLeft: 'auto',
                    paddingRight: 'auto',
                    flexDirecton: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <input
                    {...getInputProps()}
                  />
                  <p style={{ margin: 'auto'}}> click or drop files here </p>
                </div>
              );
            }}
          </df.Dzn>
        : null }
      </ce.Mdl>
    );
  };

/*
          accept={'**'}
 */

//    static qrcode(pd) {
    static Qr(pd) {
        if (pd.b_vsb == false || !bf.f(pd.val)) {
            return null;
        };
        
        return (
            <>
                <ce.Lbl
                    key={-1}                    
                    pfx={pd.pfx}
                />
                <View
                    key={-2}   
                    style={{
                        width: global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                        marginLeft: 'auto',
                        marginRight: 'auto',                    
                    }}
                >
                    <QRCode
                        key={-1}
                        value={pd.val}
                    />
                </View>
            </>
        );
/*
                    <QRCode
                        key={-1}
                        value={pd.val}
                    />
 */
    };

  static _fld(pd) { // pd.ini か d_slcItems が設定された場合に値が変更される

    let _r = [];

    const [_s_id, _setId] = useState('');
    const [_s_val, _setVal] = useState(pd.ini || ''); // 前回の値が初期表示されないよう pd.ini が null の場合は '' で初期化

    useEffect(()=>{ // _s_id ではなく do_fnc を用いることで処理を効率化できないか
      let _d_slcItems = global.c?.state.sgcd_mdls[pd.mdlType]?.d_slcItems;
      if (bf.f(_d_slcItems)) {
        if (_d_slcItems.key != '') {
          if (global.c?.state.sgcd_mdls[pd.mdlType].id == _s_id) { // 同一 id の場合（ id はボタン押下時に発行 ） ※重複する key がある場合、全てに値が反映されるため
            if (pd.b_newLine == true) { // b_newLine である新規登録行は反映しない
              _setVal('');
            } else {
              if (pd.state) { // clds でない場合
                global.c?.setState({
                  [pd.state]: _d_slcItems.key,
                }, () => {
                });
              }
              else { // clds の場合
                _setVal(_d_slcItems.pfx);
              };
            };
            //
            if(pd.onChg) { // clds の場合、値を反映
              global.c?.setState({ // 同一要素を繰り返し選択可能とするためには d_slcItems の初期化が必要
                sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                  _next[pd.mdlType].d_slcItems = {};
                }),
              }, () => {
                pd.onChg(_d_slcItems);
              });
            };
          };
        };
      };
    }, [global.c?.state.sgcd_mdls[pd.mdlType]?.d_slcItems]) // 同一id かつ b_newLine 以外で d_slcItems が設定された場合に値が変更される

    useEffect(()=>{ 
      if (
        bf.f(pd.state) && 
        bf.f(global.c?.state[pd.state]) && 
        bf.f(pd.ld_iss)
      ) {
        if (
          bf.f(bf.myCM_get_dct({ld_itemss:pd.ld_iss, fld:'key', val:global.c?.state[pd.state]}))
        ) { // pd.ld_itemss に対応する値が存在する場合
          _setVal(bf.myCM_get_dct({ld_itemss:pd.ld_iss, fld:'key', val:global.c?.state[pd.state]}).pfx);
        }
        else { // pd.ld_items に対応する値が存在しない場合
          _setVal('');
        };
      };
    }, [global.c?.state[pd.state], pd.ld_iss]);

    useEffect(()=>{ 
        if (pd.ctlVal){
            if (bf.myCM_get_dct({ld_itemss:pd.ld_iss, fld:'key', val:pd.ctlVal})) {
                _setVal(bf.myCM_get_dct({ld_itemss:pd.ld_iss, fld:'key', val:pd.ctlVal}).pfx);
            };
        };
    }, [pd.ctlVal]); // pd.dd_listItems が変更された場合に初期値が反映される状況

    if (pd.b_vsb == false) {
        return null;
    };

/*
    return (
      <View
        key={-1}
        style={{
          width: (pd.n_col) ? (pd.n_col * ic.gn_fontSizeNrm) : ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
          maxWidth: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
          marginTop: ic.gn_mgnNrm,
          marginBottom: ic.gn_mgnNrm,
          marginLeft: (pd.n_col) ? ic.gn_mgnNrm : 'auto',
          marginRight: (pd.n_col) ? 0 : 'auto',
        }}
      >
        { (pd.pfx) ?
          <ce.Lbl
            key={-1}
            pfx={pd.pfx}
            stlPfx={pd.stlLbl}
          />
        : null }
        <TouchableOpacity
          key={-2}
          onPress={async ()=>{
            if (pd.b_edt) {
              //
              if (pd.onFldPrs){
                await pd.onFldPrs(); // await しないと選択項目が表示されない
              };
              //
              global.c?.setState({
                sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                  let _id = bf.myCM_gnr(10);
                  _setId(_id);
                  //
                  _next[pd.mdlType].id = _id;
                  _next[pd.mdlType].b_showMdl = true;
                }),
              });
            }
          }}
        >
          <View
            key={-1}
            style={[{
              width: (pd.n_col) ? (pd.n_col * ic.gn_fontSizeNrm) : ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ((pd.n_lyr || 1) - 1) * ic.gn_fontSizeNrm * 2 - ic.gn_mgnNrm * 2,
              marginLeft: ((pd.n_lyr || 1) > 1) ? 'auto' : 0,
              marginRight: 0,
              minHeight: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2 + ic.gn_mgnNrm * 2,
              paddingTop: ic.gn_mgnNrm,
              paddingBottom: ic.gn_mgnNrm,
              paddingLeft: ic.gn_mgnNrm,
              paddingRight: ic.gn_mgnNrm,
              borderWidth: ic.gn_bdrWNrw * 1.5,
              borderColor: (pd.b_edt == true) ? ic.g_bdrCcd : ic.g_ccdWN,
              borderRadius: ic.gn_bdrRdsNrm,
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'flex-start',
            }, pd.stlCta]}
          >
            <TextInput
              key={-1}
              editable={false}
              multiline={false}
              placeholder={pd.phd}
              placeholderTextColor={pd.phdCcd}
              value={(_s_val) ? _s_val : ''}
              style={[{
                width: '100%',
                fontSize: ic.gn_fontSizeNrm,
//                color: 'black',
                color: ic.g_fontCcdNrm,
                opacity: 1,
              }, pd.stlPfx]}
              disabledInputStyle={{
//                color: 'black',
                color: ic.g_fontCcdNrm,
                opacity: 1,
              }}
            />
          </View>
        </TouchableOpacity>
        { (pd.onDltPrs) ?
          <ce.BtnIcon
            key={-3}
            b_vsb={pd.b_edt}
            iconName="trash"
            onPrs={()=>{
              if (pd.onDltPrs) {
                pd.onDltPrs(pd.d_ids);
              };
            }}
            stlCta={{
              position: 'absolute',
              top: ic.gn_mgnNrm,
              right: ic.gn_mgnNrm,
              backgroundColor: ic.gn_backCcd,
            }}
          />
        : null }
      </View>
    );
*/


    return (
      <View
        key={-1}
        style={{
          width: (pd.n_col) ? (pd.n_col * ic.gn_fontSizeNrm) : ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
          maxWidth: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
          marginTop: ic.gn_mgnNrm,
          marginBottom: ic.gn_mgnNrm,
          marginLeft: (pd.n_col) ? ic.gn_mgnNrm : 'auto',
          marginRight: (pd.n_col) ? 0 : 'auto',
        }}
      >
        { (pd.pfx) ?
          <ce.Lbl
            key={-1}
            pfx={pd.pfx}
            stlPfx={pd.stlLbl}
          />
        : null }
        <TouchableOpacity
          key={-2}
          onPressIn={async ()=>{
            if (pd.b_edt) {
              //
              if (pd.onFldPrs){
                await pd.onFldPrs(); // await しないと選択項目が表示されない
              };
              //
              global.c?.setState({
                sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                  let _id = bf.myCM_gnr(10);
                  _setId(_id);
                  //
                  _next[pd.mdlType].id = _id;
                  _next[pd.mdlType].b_showMdl = true;
                }),
              });
            }
          }}
          style={[{
//            height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2,
            minHeight: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2 + ic.gn_mgnNrm * 2,
            width: (pd.n_col) ? (pd.n_col * ic.gn_fontSizeNrm) : ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ((pd.n_lyr || 1) - 1) * ic.gn_fontSizeNrm * 2 - ic.gn_mgnNrm * 2,
            marginLeft: ((pd.n_lyr || 1) > 1) ? 'auto' : 0,
            marginRight: 0,
            paddingTop: ic.gn_mgnNrm,
            paddingBottom: ic.gn_mgnNrm,
            paddingLeft: ic.gn_mgnNrm,
            paddingRight: ic.gn_mgnNrm,
            borderWidth: ic.gn_bdrWNrw * 1.5,
            borderColor: (pd.b_edt == true) ? ic.g_bdrCcd : ic.g_ccdWN,
            borderRadius: ic.gn_bdrRdsNrm,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
//            backgroundColor: 'black',
          }, pd.stlCta]}
        >
          <Text
            style={[{
              width: '100%',
              fontSize: ic.gn_fontSizeNrm,
              color: ic.g_fontCcdNrm,
              opacity: 1,
            }, pd.stlPfx]}
          >{bf.f(_s_val) ? _s_val : pd.phd}</Text>
        </TouchableOpacity>
        { (pd.onDltPrs) ?
          <ce.BtnIcon
            key={-3}
            b_vsb={pd.b_edt}
            iconName="trash"
            onPrs={()=>{
              if (pd.onDltPrs) {
                pd.onDltPrs(pd.d_ids);
              };
            }}
            stlCta={{
              position: 'absolute',
              top: ic.gn_mgnNrm,
              right: ic.gn_mgnNrm,
              backgroundColor: ic.gn_backCcd,
            }}
          />
        : null }
      </View>
    );
  };

  static PckDate(pd){
    return (
      <ce._fld
        key={-1}
        b_vsb={pd.b_vsb}
        b_edt={pd.b_edt}                
        pfx={pd.pfx}
        val={global.c?.state[pd.state]}
        o_mdlChd={(
          <View
            key={1}
            style={{
//              height: ic.gn_mdlH / 2 + ic.gn_mgnLrg * 2,
              height: (global.c?.state.sgcd_dmns.n_h - ic.gn_mgnNrm * 2) / 2 + ic.gn_mgnLrg * 2,
            }}
          >
            <View
              key={1}
              style={{
//                height: ic.gn_mdlH / 2 - ic.gn_mgnLrg * 2,
                height: (global.c?.state.sgcd_dmns.n_h - ic.gn_mgnNrm * 2) / 2 - ic.gn_mgnLrg * 2,
              }}
            >
              <Calendar
                key={1}
                monthFormat={'yyyy年　MM月'}
                markedDates={(bf.f(global.c?.state[pd.state])) ? {[global.c?.state[pd.state]] : {selected: true, selectedColor: ''}} : null}
                renderArrow={ _drc => {
                  if(_drc === 'left') {
                    return (
                      <Icon type="FontAwesome5" name="arrow-left" />
                    );
                  }
                  else {
                    return (
                      <Icon type="FontAwesome5" name="arrow-right" />
                    );
                  }
                }}
                onDayPress={(_d_dates) => {
                  if (global.c?.state[pd.state] != _d_dates.dateString) { // 値が変更されている場合のみ実行
                    global.c?.setState({
                      [pd.state]: _d_dates.dateString,
                    }, ()=>{
                      if(pd.onChg){
                        pd.onChg(_d_dates.dateString);
                      }
                    });
                  };
                  //
                  global.c?.setState({
                    sgcb_showMdl: false,
                  });
                }}
              />
            </View>
          </View>
        )}
      />
    );
  };
  
  static ListRdb (pd) { // radio button
      //
      let _r = [];
      //
      bf.myCM_for_each(pd.ld_itemss, (_d_items) => {
          _r.push(
              <>
                  <Text
                      style={{
                          width: global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                          marginStart: 'auto',
                          marginEnd: 'auto',
                      }}
                  >
                      {_d_items.pfx}
                  </Text>
                  <ce.Rdb
                      
                      state={_d_items.state}
                      ld_itemss={ic.gld_yesNo}
                  />
              </>
          );
      });
      //
      return (
          <>
              {_r}
          </>
      );
  }
  
  static Rdb (pd) { // radio button
      //
      let _r = [];
      //
      bf.myCM_for_each(pd.ld_itemss, (_d_items) => {
          _r.push(
              <>
                  <RadioButton
                      value={_d_items.key}
                      status={ global.c?.state[pd.state] == _d_items.key ? 'checked' : 'unchecked' }
                      onPress={() => {
                          global.c?.setState({
                              [pd.state]: _d_items.key,
                          });
                      }}
                  />
                  <Text>{_d_items.pfx}</Text>
              </>
          );
      });
      //
      return (
          <ce.Row
              stlCta={[{
                  width: global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                  marginStart: 'auto',
                  marginEnd: 'auto',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
              }, pd.stlCta]}
          >
              {_r}
          </ce.Row>
      );
  }

static Rdr = (pd={
  idx: '',
  pfx: '',
  ld_iss: [],
//  d_is: {},
  d_defs: {
    n_minVal: 0,
    n_maxVal: 0,
    d_valLbls: {
    },
  },
}) => { // radar chart

  if (bf.f(pd.ld_iss) == false) return null;

/*
  let _n_fldCnt = bf.myCM_get_len(_l_flds);
  let _l_flds = pd.ld_iss.map( (_d_is, _idx) => {
    return _d_is.fld ?? '';
  });
  let _ld_iss = pd.ld_iss.map( (_d_is, _idx) => {
    if (bf.f(_d_is?.val)) {
      return {
        x: _idx,
        y: _d_is.val,
      };
    }
    else {
      return {
        x: _idx,
        y: 0,
      };
    };
  });
*/
  let _n_fldCnt = bf.myCM_get_len(pd.ld_iss);
  let _l_flds = Array(_n_fldCnt).fill();
  pd.ld_iss.map( (_d_is, _idx) => {
//    _l_flds[(_idx == 0) ? 0 : (_n_fldCnt - (_idx + 1) + 1)] = _d_is.fld ?? '';
    let _n = (_idx == 0) ? 0 : (_n_fldCnt - _idx);
    _l_flds[_n] = _d_is.fld ?? '';
  });
  let _ld_iss = Array(_n_fldCnt).fill();
  pd.ld_iss.map( (_d_is, _idx) => {
//    _ld_iss[(_idx == 0) ? 0 : (_n_fldCnt - (_idx + 1) + 1)] =  
    let _n = (_idx == 0) ? 0 : (_n_fldCnt - _idx);
    _ld_iss[_n] =  
      bf.f(_d_is?.val) ? 
        {
          x: _n,
          y: _d_is.val,
        }
      :
        {
          x: _n,
          y: 0,
        };
  });

//  let _viewH = global.c?.state.sgcd_dmns.n_h / 2.4; 
  let _viewH = global.c?.state.sgcd_dmns.n_h / 2.4; 
  let _lblH = ic.gn_fontSizeLrg + ic.gn_mgnNrm * 2 + ic.gn_bdrWNrm * 2; // label height
  let _chtH = _viewH - _lblH; // chart height
  let _chtW = ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2;

  return (
    <View
      key={(pd.idx) ? pd.idx : -1}
      style={[{
        width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
        height: _viewH,
        backgroundColor: '#ffffff',
        marginTop: ic.gn_mgnNrm,
        marginBottom: ic.gn_mgnNrm,
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
      }, pd.stlCta]}
    >
      <ce.Lbl
        key={-1}
        pfx={pd.pfx}
        stlCta={{
          hegiht: _lblH,
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
        }}
        stlPfx={{
        }}
      />
      <df.Vry.VictoryChart
        key={-2}
        polar
        domain={{ x: [0, _n_fldCnt], y: [pd.d_defs.n_minVal, pd.d_defs.n_maxVal] }}
        style={{
          parent: {
          },
        }}        
        padding={{
/*
          top: ic.gn_fontSizeNrm * 1, 
          bottom: ic.gn_fontSizeNrm * 1,
          left: ic.gn_fontSizeNrm * 1,
          right: ic.gn_fontSizeNrm * 1,
*/
          top: ic.gn_fontSizeNrm * 1.2, 
          bottom: ic.gn_fontSizeNrm * 1.2,
          left: ic.gn_fontSizeNrm * 0,
          right: ic.gn_fontSizeNrm * 0,
/*
          padding={{
            top:0, 
            bottom: _xAxisLblH, // x-axis label の幅
            left: _yAxisLblW, // y-axis label の幅
            right: 0,
          }}
*/ 
       }}
        height={_chtH}
        width={_chtW}
      >
        <df.Vry.VictoryGroup
          key={-1}
          colorScale={
            ['orange']
          }
          style={{
            data: {
              fillOpacity:0.2, 
              strokeWidth: 2
            }
          }}
        >
          <df.Vry.VictoryArea
            key={-1}
            data={_ld_iss}
          />
        </df.Vry.VictoryGroup>

        <df.Vry.VictoryPolarAxis
          key={-2}
          dependentAxis
          labelPlacement="perpendicular"
          axisValue={0}
          tickFormat={(_t) => '　{}'.f(pd.d_defs.d_valLbls[_t] ?? '')} // 時計回り
          tickValues={bf.myCM_get_keys(pd.d_defs.d_valLbls)}
          tickLabelComponent={
            <df.Vry.VictoryLabel
              key={-1}
              textAnchor={'start'}
              labelPlacement='perpendicular'
              style={{
                fontSize: ic.gn_fontSizeSml * 1.0,
              }}
            />
          }
          style={{
            axis: { stroke: "none" },
            grid: { stroke: "grey", strokeWidth: 0.4, opacity: 0.5 }
          }}
        />

        <df.Vry.VictoryPolarAxis
          key={-3}
          labelPlacement="vertical"
          tickFormat={(_t) => {
            return _l_flds[_t] // 時計回り
          }}
          tickValues={bf.myCM_get_rng(_n_fldCnt, 0)}
          tickLabelComponent={
            <df.Vry.VictoryLabel
              key={-1}
              textAnchor={'middle'}
              labelPlacement='vertical'
              style={{
                fontSize: ic.gn_fontSizeSml * 1.0,
              }}
            />
          }
          style={{
            axis: { stroke: "none" },
            grid: { stroke: "grey", strokeWidth: 0.6, opacity: 0.5 }
          }}
        />
      </df.Vry.VictoryChart>
    </View>
  )
}

static Rdrs = (pd={
  b_vsb: false,
//    lld_isss: [],
  ld_iss: [],
  n_minVal: 0,
  n_maxVal: 0,
}) => {
  if (pd.b_vsb == false) {
    return null;
  }
  else {
    if (pd.ld_iss) {
      let _r = pd.ld_iss
      .filter(_d_is => {
        return (bf.f(_d_is)) ? true : false;
      })
      .map((_d_is, _idx) => {
        return ce.Rdr({
          idx: 'Rdr.{}'.f(_idx),
          pfx: _d_is.pfx,
          ld_iss: _d_is.ld_iss,
          d_defs: pd.d_defs || _d_is.d_defs,
        });

      });

      return (
        <>
          <ce.Lbl
            key={'Rdrs.Lbl.-1'}
            pfx={pd.pfx}
          />
          {_r}
        </>
      )
    }
    else {
      return null;
    };
  };
};

/*
static Chts = (pd={ // charts
  b_vsb: false,
  pfx: '',
  ldd_isss: [],
}) => {

  if (pd.b_vsb == false) return null;
  if (bf.f(pd.ld_iss) == false) return null;

  let _r = pd.ld_iss
  .map((_d_is, _idx) => {
//bf.l('6234: {}, {}'.f(_idx, _d_is))
    switch (_d_is.type) {
      case 'lbl':
        return ce.Lbl({
          key: 'Chts.Lbl.{}'.f(_idx),
          pfx: _d_is.pfx,
        });
        break;
      case 'line':
        return ce.Line({
          idx: 'Chts.Line.{}'.f(_idx),
          pfx: _d_is.pfx,
          ld_iss: _d_is.ld_iss,
          d_defs: _d_is.d_defs,
          onPrs: _d_is.onPrs,
          d_ids: {
            idx: _idx,
          },
        });
        break;
      case 'rdr':
        return ce.Rdr({
          idx: 'Chts.Rdr.{}'.f(_idx),
          pfx: _d_is.pfx,
          ld_iss: _d_is.ld_iss,
          d_defs: _d_is.d_defs,
          onPrs: _d_is.onPrs,
          d_ids: {
            idx: _idx,
          },
        });
        break;
      default:
        bf.l('incorrect chart type at {}'.f(_d_is))
        return null;
        break;
    };
  });

  return (
    <>
      <ce.Lbl
        key={'Chts.Lbl'}
        pfx={pd.pfx}
      />
      {_r}
    </>
  )
};
*/

static CfmMdl = (pd) => { // confirm modal

  let _r = [];
  global.c?.state.sgcd_mdls.cfm.ld_btnss.map( (_d_btns, _idx) => {
    _r.push(
      ce.c(ce.Btn, {
        key: _idx,
        pfx: _d_btns.pfx,
        onPrs: () => {
          global.c?.setState({
            sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
              _next.cfm.b_showMdl = false;
            }),
          }, () => {
            if (_d_btns.o_onPrs) _d_btns.o_onPrs();
          });
        },
        stlCta: {
          width: ic.gn_bntWLrg,
        },
      })
    );
  });

  let _w = (global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2) - ic.gn_mgnNrm - ic.gn_scbW;
//bf.l('7040: {}'.f(_w, (global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2), ic.gn_mgnNrm, ic.gn_scbW))  
  _r = ce.c(View, {
    key: -2,
    style: {
      width: _w,
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
    },
  }, _r);

  return (
    ce.c(ce.Mdl, {
      key: 'CfmMdl',
      mdlType: 'cfm',
    }, [
      ce.c(ce.Msg, {
        key: -1,
        pfx: global.c?.state.sgcd_mdls.cfm.msg,
        stlCta: {
//          width: (global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2) - ic.gn_mgnNrm - ic.gn_barW,
          width: _w,
          marginLeft: ic.gn_mgnNrm,
          marginRight: ic.gn_mgnNrm,
          flexDirection: 'column',
          justifyContnt: 'center',
          alignItems: 'center',
        },
      }),
      _r
    ])
  );
};

static Chts = (pd={ // charts
  b_vsb: false,
  pfx: '',
  ldd_isss: [],
  n_vsbIdx: -1,
}) => {

  if (pd.b_vsb == false) return null;
  if (bf.f(pd.ldd_isss) == false) return null;

  let _r = [];
  pd.ldd_isss
  .map((_dd_iss, _idx) => {

    Object.keys(_dd_iss)
    .map( _als => {
      let _d_is = _dd_iss[_als];
      if (bf.f(_d_is) == false) return null; // 空白データは除外
      switch (_d_is.type) {
        case 'lbl':
          _r.push(
            ce.Lbl({
              idx: 'Chts.Lbl.{}.{}'.f(_idx, _als),
              pfx: _d_is.pfx,
              d_ids: {
                idx: _idx,
                als: _als,
              },
            })
          );
          break;
        case 'line':
          _r.push(
            ce.Line({
              idx: 'Chts.Line.{}.{}'.f(_idx, _als),
              pfx: _d_is.pfx,
              ld_iss: _d_is.ld_iss,
              d_defs: _d_is.d_defs,
              onPrs: _d_is.onPrs,
              d_ids: {
                idx: _idx,
                als: _als,
              },
            })
          );
          break;
        case 'rdr':
          _r.push(
            ce.Rdr({
              idx: 'Chts.Rdr.{}.{}'.f(_idx, _als),
              pfx: _d_is.pfx,
              ld_iss: _d_is.ld_iss,
              d_defs: _d_is.d_defs,
              onPrs: _d_is.onPrs,
              d_ids: {
                idx: _idx,
                als: _als,
              },
            })
          );
          break;
        default:
          bf.l('incorrect chart type at {}'.f(_d_is))
          return null;
          break;
      };
    });
  });

  return (
    <>
      <ce.Lbl
        key={'Chts.Lbl'}
        b_vsb={(bf.f(pd.pfx)) ? true : false}
        pfx={pd.pfx}
      />
      {_r}
    </>
  )
};

    static Rfr (pd) { // referer
        //
        const [_s_crrTextInp, _setTextInp] = useState('');
        //
        useEffect(()=>{
            if (global.c?.state[pd.state]) {
                if (pd.onChgKey){
                    pd.onChgKey(global.c?.state[pd.state])
                    .then((_s)=>{
                        _setTextInp(_s);
                    });
                };
            };
        }, [global.c?.state[pd.state]]);
        //
        return (
            <View 
                style={ [{
                    width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                    margin: ic.gn_mgnNrm,
                }, pd.stlCta] }
            >
                <ce.Lbl
                    key={-1} 
                    pfx={pd.pfx}
                />
                <TextInput 
                    key={-2} 
                    editable={pd.b_edt}
                    multiline={false}
                    placeholder={pd.phd}
                    style={ [{
                        color: ic.g_fontCcdNrm,
                        fontSize: ic.gn_fontSizeNrm,
                        borderWidth: ic.gn_bdrWNrw * 1.5,
                        borderColor: (pd.b_edt == true) ? ic.g_bdrCcd : ic.g_ccdWN,
                        borderRadius: ic.gn_bdrRdsNrm,
                        paddingTop: ic.gn_mgnNrm,
                        paddingBottom: ic.gn_mgnNrm,
                        paddingLeft: ic.gn_mgnNrm,
                        paddingRight: ic.gn_mgnNrm,
                        borderRadius: (pd.b_bdr) ? ic.gn_bdrRdsNrm : 0,
                        minHeight: ic.gn_fontSizeNrm * 3,
                    }, pd.stlInp] }
                    value={_s_crrTextInp}
                    onChangeText={(_newTextInp)=>{
                        if (pd.onChgStr) {
                            pd.onChgStr(_newTextInp, _s_crrTextInp);
                        };
                        _setTextInp(_newTextInp);
                    }}
                />
            </View>
        );
    }

/*
    static PckFilesMdl(pd){
        return (
            <ce.Mdl
                key={-1}
                b_vsb={global.c?.state.sgcd_mdls.pckFiles.b_showMdl}
                
                mdlType={'pckFiles'}
            >
                <ce.Files
                    key={-1}
                    
                    b_vsb={true}
                    b_edt={true}
                    pfx='添付ファイル'
                    state='sld_filess'
                    n_pntW={(global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2)}
                />
                <ce.Btn
                    key={-2}
                    b_vsb={(bf.myCM_get_len(global.c?.state.sld_filess)>0) ? true : false}
                    b_rvs={false}
                    pfx='送る'
                    onCls={()=>{
                        global.c?.setState({
                            sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                                _next.pckFiles.b_showMdl = false;
                            }),
                        });
                    }}
                    onPrs={()=>{
                        //
                        cf.myRN_ldr_show(global.c); // ldr の表示
                        //
                        // 幹となるメッセージの追加
                        bf.myCM_for_each(global.c?.state.sld_filess, (_d_files)=>{
                            let _d_vals = {
                                ct20b11k: global.c?.state.sgcd_pagePntKeys.cm10_key, // お客様 am1d_key
                                ct20cy20: global.c?.state.sgc_cm10_key, // 送信者 am1d_key
                                ct20012p: global.c?.state.sgc_user_pfx, // 送信者名
                                ct20012a: cf.myRN_get_uri(global.c?.state.sgc_user_img), // 送信者画像
                                ct20c110: '', // 送信番号
                                ct20c410: '20', // 送信区分：ファイル
                                ct20c610: _d_files.name, // 送信内容
                                ct20cy10: bf.myDT_get_now(),
                            }
                            cf.myCB_call_iud('ins', 'ct20', _d_vals, '')
                            .then((_d_ct20s)=>{
                                // ct10 形式に変更要
                                let _d_vals = {
                                    at3d0110: global.c?.state.sgcd_pagePntKeys.cm10_key, // お客さま am1d_key
                                    at3d0120: global.c?.state.sgc_cm10_key,   // 登録者 am1d_key
                                    at3d012p: global.c?.state.user_pfx,       // 登録者名
                                    at3d012a: global.c?.state.user_img,       // 登録者画像
                                    ct10l11k: _d_ct20s._KEY,                // リンク先メッセージ ct20_key
                                    at3d013p: 'メッセージの添付ファイル',       // リンク先表記：固定文言
                                    at3d0710: '10',                         // リンク先区分：メッセージ
                                    at3d1010: '',                           // ファイル番号：自動
                                    at3d1010: _d_files.name,                // ファイル表記
                                    ct10c610: '',                           // ファイル
                                    at3d3110: '0',                          // DROPBOX反映状況：未反映
                                    at3d3210: '',                           // DROPBOX反映日時
                                    at3dz830: '0',                          // 削除区分：未削除
                                    at3dz920: bf.myDT_get_now(),            // 登録日時：現在日時
                                };
                                cf.myCB_call_iud('ins', 'at3d', _d_vals, '')
                                .then((_d_at3ds)=>{
                                    cf.myCB_call_upl('at3d', 'ct10c610', _d_at3ds._KEY, _d_files);
                                });
                            });
                        })
                        .then(()=>{
                            p_porps.o_this.load(true, 1); // 追加分を表示
                            //
                            global.c?.setState({
                                sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                                    _next.pckFiles.b_showMdl = false;
                                }),
                            });
                            //
                            cf.myRN_ldr_hide(global.c); // ldr の非表示
                            //
                            if (global.c?.state.sgc_cm10_key != global.c?.state.sgcd_pagePntKeys.cm10_key) { // お客さまが送信者でない場合
                                cf.myCB_call_slc({
                                  ctr: 'nlm',
                                  elm: 'am1d', 
                                  n_dms: 2, 
                                  cnd: bf.q('[_KEY]={}'.f(global.c?.state.sgcd_pagePntKeys.cm10_key))
                                })
                                .then((_d_am1ds) => {
                                    cf.myCB_call_eml(_d_am1ds.am1d1030, '新規メッセージのお知らせ', '{}さんが、新規にメッセージを登録しました'.f(global.c?.state.sgc_user_pfx))
                                });
                            };
                        });

                    }}
                    stlCta={{
                        width: (global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                    }}
                />
            </ce.Mdl>
        );
    };
*/

  static PckFilesMdl = (pd={
    state: '',
    onPrs: () => {},
  }) => {
//          b_edt={true}
    return (
      <ce.Mdl
        key={-1}
        b_vsb={global.c?.state.sgcd_mdls.pckFiles.b_showMdl}
        mdlType={'pckFiles'}
      >
        <ce.Files
          key={-1}
          b_vsb={true}
          b_lblBtnVsb={true}
          ob_dltBtnVsb={() => true}
          pfx='添付ファイル'
          state={pd.state}
          n_pntW={(global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2)}
        />
        <ce.Btn
          key={-2}
          b_vsb={(bf.myCM_get_len(global.c?.state[pd.state])>0) ? true : false}
          b_rvs={false}
          pfx='送る'
          onCls={()=>{
            global.c?.setState({
              sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                _next.pckFiles.b_showMdl = false;
              }),
            });
          }}
          onPrs={pd.onPrs}
          stlCta={{
            width: (global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
          }}
        />
      </ce.Mdl>
    );
  };

static PckSch = (pd) => {
  return (
    <ce._fld
      key={-1}
      b_vsb={pd.b_vsb}
      b_edt={pd.b_edt}
      pfx={pd.pfx}
      ini={pd.ini}
      mdlType={'pckSch'}
      b_newLine={pd.b_newLine}
      onChg={pd.onChg}
      onDltPrs={pd.onDltPrs}
    />
  );
};

    static PckSchMdl(pd) {
        return (
            <ce.Mdl
                key={-1}
                mdlType={'pckSch'}
            >
                <View 
                    key={-1}
                    style={ [{
//                        height: ic.gn_mdlH * 0.6,
                        height: (global.c?.state.sgcd_dmns.n_h - ic.gn_mgnNrm * 2) * 0.6,
                    }] }
                >
                    <View 
                        key={-1}
                        style={ [{
                            width: (global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2) - ic.gn_mgnNrm * 2,
                            
                            marginLeft: 'auto',
                            marginRight: 'auto',

                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                        }] }
                    >
                        <Icon
                            key={-1}
                            name='search'
                            color={(ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd}
                            size={ic.gn_iconSizeSml}
                        />
                        <TextInput 
                            key={-2}
                            editable={true}
                            multiline={false}
                            placeholder={'検索文字を入力ください'}
                            style={{
                                width: global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm - ic.gn_iconSizeSml - ic.gn_mgnNrm - ic.gn_mgnNrm - ic.gn_btnWNrm - ic.gn_mgnNrm,
                                color: ic.g_fontCcdNrm,
                                fontSize: ic.gn_fontSizeNrm,
                                borderWidth: ic.gn_bdrWNrw * 1.5,
                                borderColor: ic.g_bdrCcd,
                                borderRadius: ic.gn_bdrRdsNrm,
                                marginTop: ic.gn_mgnNrm,
                                marginBottom: ic.gn_mgnNrm,
                                marginLeft: ic.gn_mgnNrm,
                                marginRight: 0,
                                paddingTop: ic.gn_mgnNrm,
                                paddingBottom: ic.gn_mgnNrm,
                                paddingLeft: ic.gn_mgnNrm,
                                paddingRight: ic.gn_mgnNrm,
                                borderRadius: (pd.b_mln || pd.b_bdr != false) ? ic.gn_bdrRdsNrm : 0,
                                minHeight: (pd.b_mln) ? ic.gn_fontSizeNrm * 8 : ic.gn_fontSizeNrm * 3,
                            }}
                            onChangeText={(_schKey)=>{
                                if (pd.onPckSchMdlEnt) {
                                    pd.onPckSchMdlEnt(_schKey);
                                };
                            }}
                        />
                    </View>
                    <ce.List
                        key={-2}
                        b_vsb={true}                    
                        state={null}
                        ld_itemss={global.c?.state.sgcd_mdls.pckSch.ld_itemss}
                        pfx={''}
                        b_chb={false}
                        b_prs={true}
                        onPrs={(_d_items, _key) => {
                            global.c?.setState({
                                sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                                    _next.pckSch.d_slcItems = _d_items;
                                    _next.pckSch.b_showMdl = false;
                                }),
                            });
                        }} 
                    />
                </View>
            </ce.Mdl>
        );
    };

  static PckSchs = (pd) => {
      //
      let _r = [];
      //
      for (let [_key, _d_items] of  bf.e(global.c?.state[pd.state])) {
        //
//bf.l('5920:{}, {}'.f(_key, _d_items))
/*
        _r.push(
          <>
            { (_d_items.b_dlt != true) ?
              <ce.PckSch
                key={_key}
                idx={_key}
                b_vsb={true}
                b_edt={pd.b_edt}
                pfx={''}
                b_newLine={false}
                ini={_d_items.pfx}
                onChg={(_d_slcItems)=>{
                  if (_d_slcItems.key != '') {
                    global.c?.setState({
                      [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                        _next[_key] = _d_slcItems;
                      }),
                    });
                  };
                }}
                onDltPrs={()=>{
                  global.c?.setState({
                    [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                      _next[_key].b_dlt = true;
                    }),
                  });
                }}
              />
            : null }
          </>
        );
              idx={_key}
*/
        if (_d_items.b_dlt != true) {
          _r.push(
            <ce.PckSch
              key={_key}
              b_vsb={true}
              b_edt={pd.b_edt}
              pfx={''}
              b_newLine={false}
              ini={_d_items.pfx}
              onChg={(_d_slcItems)=>{
                if (_d_slcItems.key != '') {
                  global.c?.setState({
                    [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                      _next[_key] = _d_slcItems;
                    }),
                  });
                };
              }}
              onDltPrs={()=>{
                global.c?.setState({
                  [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                    _next[_key].b_dlt = true;
                  }),
                });
              }}
            />
          );
        };
      };
      //
      _r.push(
        <ce.PckSch
          key={-1}
          b_vsb={true}
          b_edt={pd.b_edt}
          pfx={''}
          b_newLine={true}
          ini={''}
          onChg={(_d_slcItems)=>{
            if (_d_slcItems.key != '') {
              global.c?.setState({
                [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                  _next.push(_d_slcItems);
                }),
              });
            };
          }}
        />
      );
      //
      return (
        <View
          key={-1}
        >
          { (pd.pfx) ?
            <ce.Lbl
              key={-2}
              pfx={pd.pfx}
            />
          : null }
          {_r}
        </View>
      );
  }

  static Root (pd) {

    let _r = [];

/*
    const [_sd_dmns, _setDmns] = useState({ n_w: 0, n_h: 0 });
    useEffect(() => {
      bf.l('7826: {}'.f(global.c?.state.sgcd_dmns?.n_h));
      if (bf.f(global.c?.state.sgcd_dmns)) {
        _setDmns(global.c?.state.sgcd_dmns);
      }
    }, [
      global.c?.state.sgcd_dmns,
    ]);
*/

    if (pd.backImg) {
      _r.push(
        <ImageBackground
          key={-1}
          style={{
//            height:global.c?.state.sgcd_dmns.n_h, 
//            width: global.c?.state.sgcd_dmns.n_w,
//            height: global.c?.state.sgcd_dmns.n_h, 
//            height: _sn_h, 
            height: global.c?.state.sgcd_dmns?.n_h ?? 0, 
//            width: global.c?.state.sgcd_dmns?.n_w ?? 0, 
            width: '100%', 
            backgroundColor: ic.g_ccdWN,
//            backgroundColor: 'black',
          }}
          source={pd.backImg}
        >
          { pd.children }
        </ImageBackground>
      );
    }
    else {
      _r.push(
        <View
          key={-1}
          style={[{
//            height:global.c?.state.sgcd_dmns.n_h, 
//            height: global.c?.state.sgcd_dmns.n_h, 
//            height: _sn_h, 
//            width: global.c?.state.sgcd_dmns.n_w,
            height: global.c?.state.sgcd_dmns?.n_h ?? 0, 
//            width: global.c?.state.sgcd_dmns?.n_w ?? 0, 
            width: '100%', 
            backgroundColor: ic.g_ccdWN,
//            backgroundColor: 'black',
          }, pd.stlCta]}
        >
          { pd.children }
        </View>
      );
    };

    return (
      <View 
        key={-1}
        style={[{ // hdr/ bdy/ ftr を中央配置するために必要
//          height: global.c?.state.sgcd_dmns.n_h, 
//          height: global.c?.state.sgcd_dmns.n_h, 
//          height: _sn_h, 
          height: global.c?.state.sgcd_dmns?.n_h ?? 0, 
//          flex: 1,
//            width: global.c?.state.sgcd_dmns?.n_w ?? 0, 
          width: '100%', 
          flexDirection: 'column',
          justifyContent: 'flex-start', 
          alignItems: 'center',
          backgroundColor: ic.g_baseCcd,                
//          backgroundColor: 'black',
        }]}
      >
        {_r}
        <ce.PckMdl
          key={-2}
        />
        <ce.PckSchMdl
          key={-3}
          onPckSchMdlEnt={pd.onPckSchMdlEnt}
        />
        <ce.FileMdl
          key={-4}
        />
        {
          ce.c(ce.CfmMdl, {
            key: -5,
          })
        }
        <ce.MenuMdl
          key={-6}
        />
        <ce.Ldr
          key={-7}
          state="sgcb_showLdr"
        />
      </View>
    );
  }

  static RootDtl (pd) {

    const [_sb_schVsb, _setSchVsb] = useState(false);

/*
    const [_sn_h, _setH] = useState(0);
    useEffect(() => {
      bf.l('7900: {}'.f(global.c?.state.sgcd_dmns?.n_h));
      _setH(global.c?.state.sgcd_dmns?.n_h ?? 0);
    }, [
      global.c?.state.sgcd_dmns?.n_h,
    ]);
*/

//    const _sd_dmns = useWindowDimensions();
//    const _n_h = Dimensions.get('window').height;

/*
        <ce.Top
          key={-2}
          n_h={pd.d_tops?.n_h}
          n_pntW={pd.n_pntW}
          ld_defss={pd.d_tops?.ld_defss}
        />

 */
//    let _top = ((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY) + ((pd.d_tops?.n_h) ? pd.d_tops?.n_h : 0);
//bf.l('7281: {}'.f(_top))
/*
              cf.myRN_chk_os('a') ?
                ic.gn_bdyY + ((pd.d_tops?.n_h) ? pd.d_tops?.n_h : 0)
              : ((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY) + ((pd.d_tops?.n_h) ? pd.d_tops?.n_h : 0)
*/
//let _h = global.c?.state.sgcd_dmns?.n_h - (ic.gn_hdrH + ic.gn_ftrH) - ((pd.d_btms?.n_h) ? pd.d_btms?.n_h : 0) - ((pd.d_tops?.n_h) ? pd.d_tops?.n_h : 0);
//bf.l('7975: {}'.f(_h))
    return (
      <ce.Root
        key={-1}
        backImg={pd.backImg}
        onPckSchMdlEnt={pd.onPckSchMdlEnt}
      >
        <ce.Bdy
          key={-1}
          stlCta={{
//            height: global.c?.state.sgcd_dmns.n_h - (global.c?.state.sgcd_dmns.n_hdrH + ic.gn_ftrH) - ((pd.d_btms?.n_h) ? pd.d_btms?.n_h : 0),
            top: ic.gn_bdyY - (global.c?.state.sgcn_dy ?? 0) + (pd.d_tops?.n_h ?? 0),
//            height: _n_h - (global.c?.state.sgcd_dmns.n_hdrH + ic.gn_ftrH) - ((pd.d_btms?.n_h) ? pd.d_btms?.n_h : 0) - ((pd.d_tops?.n_h) ? pd.d_tops?.n_h : 0),
//            height: _sd_dmns.height - (global.c?.state.sgcd_dmns.n_hdrH + ic.gn_ftrH) - ((pd.d_btms?.n_h) ? pd.d_btms?.n_h : 0) - ((pd.d_tops?.n_h) ? pd.d_tops?.n_h : 0),
//            height: global.c?.state.sgcd_dmns.n_h - (global.c?.state.sgcd_dmns.n_hdrH + ic.gn_ftrH) - ((pd.d_btms?.n_h) ? pd.d_btms?.n_h : 0) - ((pd.d_tops?.n_h) ? pd.d_tops?.n_h : 0),
//            height: _sn_h - (global.c?.state.sgcd_dmns.n_hdrH + ic.gn_ftrH) - ((pd.d_btms?.n_h) ? pd.d_btms?.n_h : 0) - ((pd.d_tops?.n_h) ? pd.d_tops?.n_h : 0),
//            height: global.c?.state.sgcd_dmns.n_h - (global.c?.state.sgcd_dmns.n_hdrH + ic.gn_ftrH) - ((pd.d_btms?.n_h) ? pd.d_btms?.n_h : 0) - ((pd.d_tops?.n_h) ? pd.d_tops?.n_h : 0),
            height: global.c?.state.sgcd_dmns.n_h - (ic.gn_hdrH + ic.gn_ftrH) - ((pd.d_btms?.n_h) ? pd.d_btms?.n_h : 0) - ((pd.d_tops?.n_h) ? pd.d_tops?.n_h : 0),
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'center',
            backgroundColor: (pd.backCcd) ? pd.backCcd : ic.gn_backCcd,
//            backgroundColor: 'black',
          }}
          stlInr={pd.d_bdys?.d_stlInrs}
          n_bdyW={pd.n_bdyW}
          b_ste={pd.b_ste}
          b_ctr={pd.b_ctr}
          onScrTop={pd.onBdyScrTop}
          onScrBtm={pd.onBdyScrBtm}
        >
          { ce._elms(pd.d_bdys?.ld_defss) }
        </ce.Bdy>
            
        <ce.Top
          key={-2}
          n_h={pd.d_tops?.n_h}
          n_pntW={pd.n_pntW}
          ld_defss={pd.d_tops?.ld_defss}
        />

        <ce.Btm
          key={-3}
          b_vsb={pd.d_btms?.b_vsb}
          n_h={pd.d_btms?.n_h}
          n_pntW={pd.n_pntW}
          ld_defss={pd.d_btms?.ld_defss}
        />

        <ce.Hdr 
          key={-4}
          pfx={pd.d_hdrs?.pfx}
          b_logo={pd.d_hdrs?.b_logo}
          logo={pd.d_hdrs?.logo}
          b_sch={(pd.onSchEnt) ? true : false}
          onSchPrs={()=>{
            _setSchVsb(true);
          }}
          b_leftVsb={pd.d_hdrs?.d_leftBtns?.b_vsb}
          leftIconName={
            (pd.d_hdrs?.d_leftBtns?.iconName) ? pd.d_hdrs?.d_leftBtns?.iconName :
            (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 'remove' : 
            (bf.i(global.c?.state.sgc_pageMode, ['show'])) ? 'arrow-left' : 
            null
          }
          leftPfx={
            (pd.d_hdrs?.d_leftBtns?.pfx) ? pd.d_hdrs?.d_leftBtns?.pfx :
            (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 'キャンセル' : 
            (bf.i(global.c?.state.sgc_pageMode, ['show'])) ? '戻る' : 
            null
          }
          onLeftPrs={()=>{
            if (pd.d_hdrs?.d_leftBtns?.onPrs) {
              pd.d_hdrs?.d_leftBtns?.onPrs();
            }
            else {
              if (bf.i(global.c?.state.sgc_pageMode, ['new'])) {
//                cf.myRN_move_bwd();
//bf.l('7355: {}, {}'.f(global.c?.state.sgc_pageRole, global.c?.state.sgc_pageName))
                let _d = iv.o_gdd_ftrDefss()[global.c?.state.sgc_pageRole][global.c?.state.sgc_pageName].d_leftBtns.d_pageInfs;
                cf.myRN_move_fwd(_d);
              }
              else if (bf.i(global.c?.state.sgc_pageMode, ['edit'])) {
                global.c?.load(); // キャンセル時のリロード
                cf.myRN_set_pageMode('show');
              }
              else if (bf.i(global.c?.state.sgc_pageMode, ['show'])) {
                if (pd.d_hdrs?.d_leftBtns?.d_pageInfs) {
//alert('7230: {}'.f(pd.d_hdrs?.d_leftBtns?.d_pageInfs))
                  cf.myRN_move_fwd(pd.d_hdrs?.d_leftBtns?.d_pageInfs);
                }
                else {
//                  cf.myRN_move_bwd();
                  let _d = iv.o_gdd_ftrDefss()[global.c?.state.sgc_pageRole][global.c?.state.sgc_pageName].d_leftBtns.d_pageInfs;
                  cf.myRN_move_fwd(_d);
                };
              };
            };
          }}
          stlLeftBtn={pd.stlLeftBtn}
          stlLeftPfx={pd.stlLeftPfx}
          b_rhtVsb={pd.b_rhtVsb}
          rhtIconName={
            (pd.rhtIconName) ? pd.rhtIconName :
            (bf.i(global.c?.state.sgc_pageMode, ['show'])) ? 'pencil' : 
            (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 'check' :
            null
          }
          rhtPfx={
            (pd.rhtPfx) ? pd.rhtPfx : 
            (bf.i(global.c?.state.sgc_pageMode, ['show'])) ? '変更' : 
            (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? '登録・反映' :
            null
          }
          onRhtPrs={()=>{
            if (pd.onRhtPrs) {
              pd.onRhtPrs();
            }
            else {
              if (bf.i(global.c?.state.sgc_pageMode, ['new'])) {
                global.c?.ins();
              }
              else if (bf.i(global.c?.state.sgc_pageMode, ['edit'])) {
                global.c?.upd();
              }
              else if (bf.i(global.c?.state.sgc_pageMode, ['show'])) {
                cf.myRN_set_pageMode('edit');
              };
            };
          }}
          stlRhtBtn={{
            backgroundColor: 
              (bf.i(global.c?.state.sgc_pageMode, ['show'])) ? 
                ic.g_backCcd
              :
                (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
            borderColor:
              (bf.i(global.c?.state.sgc_pageMode, ['show'])) ?
                ic.g_backCcd
              :
                (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
          }}
          stlRhtPfx={{
            color: 
              (bf.i(global.c?.state.sgc_pageMode, ['show'])) ?
                (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd
              :
                ic.g_backCcd, 
          }}
          b_subVsb={pd.d_hdrs?.d_subMenus?.b_vsb}
          subIconName={ (pd.d_hdrs?.d_subMenus?.iconName) ? pd.d_hdrs?.d_subMenus?.iconName : 'ellipsis-h' }
          subPfx={ (pd.d_hdrs?.d_subMenus?.pfx) ? pd.d_hdrs?.d_subMenus?.pfx : 'サブメニュー' } 
          onSubPrs={
            bf.f(pd.d_hdrs?.d_subMenus?.o_onPrs) ?
              pd.d_hdrs?.d_subMenus?.o_onPrs
            : bf.f(pd.d_hdrs?.d_subMenus?.ld_iss) ?
              () => {
                if (bf.f(pd.d_hdrs?.d_subMenus?.ld_iss)) {
                  global.c?.setState({
                    sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                      _next.menu.ld_iss = pd.d_hdrs?.d_subMenus?.ld_iss;
                      _next.menu.b_showMdl = true;
                    }),
                  }, () => {
                  });
                };
              }
            : null
          }
        />

        {(pd.lo_hdrs) ?
          ce.c(View, {
            key: -5,
            style: {
              position: 'absolute',
              zIndex: ic.gn_zIdxHdr + 2,
              top: (ic.gn_hdrY ?? 0) - (global.c?.state.sgcn_dy ?? 0),
              left: 0,
              height: ic.gn_hdrH,
//              width: global.c?.state.sgcd_dmns.n_w,
              width: global.c?.state.sgcd_dmns.n_w,
              flexDirection: 'column',
              justifyContent: cf.myRN_chk_os('i') ? 'flex-end' : 'center',
              alignItems: 'center',
              backgroundColor: ic.g_ccdWN,
              borderColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
              borderBottomWidth: ic.gn_bdrWNrm,
            },
          }, pd.lo_hdrs)
        : null }

        <ce.HdrSch
          key={-6}
          b_vsb={_sb_schVsb}
          onEnt={pd.onSchEnt}
          onCls={ () => {
            global.c?.setState({
              sgcd_schs: bf.p(global.c?.state.sgcd_schs, _next => {
                _next.word = '';
              }),
            }, () => {
              _setSchVsb(false);
            });
          }}
        />

        <ce.Ftr
          key={-7}
          dd_defss={iv.o_gdd_ftrDefss()}
        />

        {(pd.lo_ftrs) ?
          ce.c(View, {
            key: -8,
            style: {
              position: 'absolute',
              zIndex: ic.gn_zIdxFtr + 1,
//              top: ic.gn_ftrY,
              top: ic.gn_hdrH + global.c?.state.sgcd_dmns.n_bdyH,
              left: 0,
              height: ic.gn_ftrH,
//              width: global.c?.state.sgcd_dmns.n_w,
              width: global.c?.state.sgcd_dmns.n_w,
              flexDirection: 'row',
              justifyContent: 'space-around',
              alignItems: 'flex-start',
              backgroundColor: ic.g_ccdWN,
              padding: ic.gn_mgnNrm,
              borderTopWidth: ic.gn_bdrWNrm,
              borderTopColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].ftrCcd : ic.gdd_ccdDefss.cmn.ftrCcd,
            },
          }, pd.lo_ftrs)
        : null }

      </ce.Root>
    );
  };
/*
          onCls={async()=>{
            if (pd.onSchEnt) {
              await pd.onSchEnt('');
            }
            _setSchVsb(false);
          }}
 */

/*
  static RootList (pd) {

//    let _r = [];

    const [_sb_trsVsb, _setTrsVsb] = useState(false);
    const [_sd_chbs, _setChbs] = useState({});
    const [_sn_topH, _setTopH] = useState(0);

//    for (let [_idx, _d_defs] of bf.e(pd.d_bdys?.ld_defss)) {
    let _r = pd.d_bdys?.ld_defss.map( (_d_defs, _idx) => {
      if (_d_defs.type == 'ListCard') {
        return (
          <ce.ListCard
            key={_idx}
            n_col={_d_defs.n_col}
            pfx={_d_defs.pfx}
            state={_d_defs.state}
            b_chb={false}
            b_img={_d_defs.b_img}
            b_bdr={_d_defs.b_bdr} // 枠線の表示
            b_menu={_d_defs.b_menu} // メニューの表示
            onPrs={(_d_items) => {
              let _d_pageInfs = {
                sgc_pageRole: _d_defs.nextRole,
                sgc_pageName: _d_defs.nextPage,
                sgc_pageKey: _d_items.key,
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
                sgcb_pageEdt: _d_defs.b_edt,
              };
              cf.myRN_move_fwd(_d_pageInfs);
            }} 
            btnPfx={_d_defs.btnPfx}
            onBtnPrs={_d_defs.onBtnPrs}
          />
        );
      }
      else {
        return (
          <ce.List
            key={_idx}
            pfx={_d_defs.pfx}
            state={_d_defs.state}
            b_chb={_sb_trsVsb}
            b_img={_d_defs.b_img}
            b_prs={true}
            b_bdr={_d_defs.b_bdr} // 枠線の表示
            onPrs={(_d_items, _idx) => {
              if (_d_defs.onPrs) {
                _d_defs.onPrs(_d_items, _idx);
              } else {
                if (_d_defs.nextRole && _d_defs.nextPage) {
                  let _d_pageInfs = {
                    sgc_pageRole: _d_defs.nextRole,
                    sgc_pageName: _d_defs.nextPage,
                    sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => {
                      if (_d_defs.pagePntKeyName) { // UserList 等において dtl へ key を引き継ぐために必要
                        _next[_d_defs.pagePntKeyName] = _d_items.key;
                      };
                    }),
                    sgc_pageKey: _d_items.key,
                    sgc_pageMode: 'show',
                    sgc_pagePrc: '',
                    sgcb_pageEdt: _d_defs.b_edt,
                  };
                  cf.myRN_move_fwd(_d_pageInfs);
                };
              };
            }} 
            btnPfx={_d_defs.btnPfx}
            onBtnPrs={_d_defs.onBtnPrs}
            onChk={(_d_items, _b_val)=>{
              let _d_chbs = _sd_chbs;
              _d_chbs[_d_items.key] = _b_val;
              _setChbs(_d_chbs);
            }}
            dtmFld={_d_defs.dtmFld}
            sumFld={_d_defs.sumFld}
          />
        );
      };
    });

    return (
      <ce.Root
      >
        <ce.Bdy
          key={-1}
          stlCta={{
            top: ((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY) + _sn_topH,
            height: ic.gn_h - (ic.gn_hdrH + ic.gn_ftrH + _sn_topH),
          }}
          b_ste={false}
          onScrTop={pd.onBdyScrTop}
          onScrBtm={pd.onBdyScrBtm}
          n_bdyW={pd.n_bdyW}
        >
          { (pd.onChgPck) ?
            <ce.Pck
              b_vsb={true}
              b_edt={true}
              state={'sgc_schPck'}
              pfx={pd.schPckPfx}
              ld_itemss={pd.ld_schPckItemss}
              onChg={(_idx, _key, _key_old)=>{
                if(pd.onChgPck){
                  pd.onChgPck(_idx, _key, _key_old);
                };
              }}
            />
          : null }
          { (pd.onChgEnt) ?
            <ce.Sch 
              state='sgc_schEnt'
              onChg={(_sch)=>{
                if ( _sch == '' ) { // キーワードが空白の場合
                  bf.myCM_for_each(pd.ld_bdyDefss, (_d_defs) => {
                    global.c?.setState({[_d_defs.state]:[]});
                  });
                };
                if ( _sch != '' && pd.onChgEnt != null ){ // _sch が空白の場合は実行されない
                  pd.onChgEnt(_sch);
                };
              }}
              phd='type here ...'
            />
          : null }

          {_r}

        </ce.Bdy>

        <ce.Hdr 
          key={-2}
          b_logo={pd.b_logo}
          b_sch={pd.b_sch}
          onSchPrs={()=>{
            global.c?.setState({
              sgcd_schs: bf.p(global.c?.state.sgcd_schs, _next =>{
                _next.b_showSch = true;
                _next.word = '';
              }),
            });
            _setTopH(bf.f(pd.d_tops?.n_h) ? pd.d_tops?.n_h : 0);
          }}
          pfx={pd.d_hdrs?.pfx}
          b_leftVsb={pd.d_hdrs?.d_leftBtns.b_vsb}
          leftIconName={pd.d_hdrs?.d_leftBtns.iconName}
          leftPfx={pd.d_hdrs?.d_leftBtns.pfx}
          onLeftPrs={()=>{
            if (pd.d_hdrs?.d_leftBtns.onPrs) {
              pd.d_hdrs?.d_leftBtns.onPrs();
            };
            if (pd.d_hdrs?.d_leftBtns.d_pageInfs) {
              cf.myRN_move_fwd(pd.d_hdrs?.d_leftBtns.d_pageInfs);
            };
            if (pd.d_hdrs?.d_leftBtns.pfx == '戻る') {
//              cf.myRN_move_bwd();
              let _d = iv.o_gdd_ftrDefss()[global.c?.state.sgc_pageRole][global.c?.state.sgc_pageName].d_leftBtns.d_pageInfs;
              cf.myRN_move_fwd(_d);
            };
          }}

          stlLeftBtn={pd.stlLeftBtn}
          stlLeftPfx={pd.stlLeftPfx}
          b_rhtVsb={pd.b_rhtVsb}
          rhtIconName={pd.rhtIconName}
          rhtPfx={pd.rhtPfx}
          onRhtPrs={pd.onRhtPrs}
          stlRhtBtn={{
            backgroundColor: ic.g_backCcd,
            borderColor: ic.g_backCcd,
          }}
          stlRhtPfx={{
            color:  (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd, 
          }}
          b_trs={pd.b_trs}
          onTrsPrs={()=>{
            _setTrsVsb(true);
          }}
        />

        <ce.HdrSch
          key={-3}
          b_vsb={global.c?.state.sgcd_schs.b_showSch}
          phd={pd.schPhd}
          onEnt={(_schKey)=>{
            global.c?.setState({
              sgcd_schs: bf.p(global.c?.state.sgcd_schs, _next =>{
                _next.word = _schKey
              }),
            }, ()=>{
              if (pd.onSchEnt) {
                pd.onSchEnt()
              };
            })
          }}
          onCls={async()=>{
            global.c?.setState({
              sgcd_schs: bf.p(global.c?.state.sgcd_schs, _next =>{
                _next.b_showSch = false;
                _next.word = '';
              }),
            }, ()=>{
              if (pd.onSchEnt) {
                pd.onSchEnt();
              }
            });
            _setTopH(0);
          }}
        />

        <ce.HdrTrs
          key={-4}
          b_vsb={_sb_trsVsb}
          onPrs={()=>{
            if (pd.onTrsPrs) {
              pd.onTrsPrs(_sd_chbs);
            };
          }}
          onCls={async()=>{
            _setTrsVsb(false);
          }}
        />

        <ce.Top
          key={-5}
          b_vsb={global.c?.state.sgcd_schs.b_showSch}
          n_h={(_sn_topH) ? _sn_topH : 0}
          n_pntW={pd.n_pntW}
          ld_defss={pd.d_tops?.ld_defss}
        />

        <ce.Ftr
          key={-6}
          dd_defss={iv.gdd_ftrDefss}
        />
      </ce.Root>
    );
  }
*/

    static Row (pd) { // row
        return (
            <View
                style={[{
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                }, pd.stlCta]}>
                { pd.children }
            </View>
        );
    }

    static Sch (pd) {
        return (
            <View 
                style={ [{
                    width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                    marginTop: ic.gn_mgnLrg,
                    marginBottom: ic.gn_mgnLrg,
                    marginLeft: 'auto',
                    marginRight: 'auto',

                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignSelf: 'center',
                    borderWidth: ic.gn_bdrWNrw * 1.5,
                    borderColor: ic.g_ccdHP,
                    borderRadius: ic.gn_bdrRdsNrm,
                }, pd.stlCta] }
            >
                <ce.Icon
                    stlCta={{
                        height: ic.gn_iconSizeSml,
                        width: ic.gn_iconSizeSml,
                        marginTop: 'auto',
                        marginBottom: 'auto',
                        marginLeft: ic.gn_mgnNrm,
                    }}
                    name='search'
                    n_size={ic.gn_iconSizeSml}
                    ccd={(ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd}
                    margin={ic.gn_mgnNrm}
                />
                <ce.Inp
                    stlCta={[{
                        width: ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW) - ic.gn_scbW - ic.gn_iconSizeSml - ic.gn_mgnNrm * 5 - ic.gn_bdrWNrm * 2,
                        marginLeft: 'auto',
                        marginRight: 'auto',

                    }, pd.stlInpCta]}
                    stlInp={[{
                        borderColor: ic.g_ccdWN,
                    }, pd.stlInpInp]}
                    
                    
                    state={pd.state}
                    b_edt={true}
                    phd={pd.phd}
                    onChg={(_sch)=>{                        
                        global.c?.setState({[pd.state]:_sch});
                        if (pd.onChg){
                            pd.onChg(_sch);
                        };
                    }}
                    onLay={pd.onLay}
                />
            </View>
        );
    }

    static Spr (pd) { // separator
        return (
            <View
                style={[{
                    height: 0,
                    width: global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                    borderWidth: 0,
                    borderBottomWidth: ic.gn_bdrWNrw,
                    borderColor: ic.g_ccdWN,
                    borderBottomColor: ic.g_ccdHP,
                    marginTop: ic.gn_mgnLrg,
                    marginBottom: ic.gn_mgnLrg,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                }, pd.stlCta]}>
            </View>
        );
    }

    static Sti (pd) { // step indicator
        return (
            <View
                style={[{
//                    width: global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                    width: global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                    flex: 1,
                    flexDirection: 'column',
                    justifyContent: 'center', 
                    alignItems: 'stretch',
                    margin: ic.gn_mgnNrm * 2,
                }]}
            >
                <StepIndicator
                    customStyles = {{
                        stepIndicatorSize: ic.gn_fontSizeSml * 2,
                        currentStepIndicatorSize:ic.gn_fontSizeSml * 2.6,
                        separatorStrokeWidth: 2,
                        currentStepStrokeWidth: 3,
                        stepStrokeCurrentColor: ic.g_ccdON,
                        stepStrokeWidth: 3,
                        stepStrokeFinishedColor: ic.g_ccdON,
                        stepStrokeUnFinishedColor: ic.g_ccdHN,
                        separatorFinishedColor: ic.g_ccdON,
                        separatorUnFinishedColor: ic.g_ccdHN,
                        stepIndicatorFinishedColor: ic.g_ccdON,
                        stepIndicatorUnFinishedColor: ic.g_ccdWN,
                        stepIndicatorCurrentColor: ic.g_ccdWN,
                        stepIndicatorLabelFontSize: ic.gn_fontSizeSml,
                        currentStepIndicatorLabelFontSize: ic.gn_fontSizeSml,
                        stepIndicatorLabelCurrentColor: ic.g_ccdON,
                        stepIndicatorLabelFinishedColor: ic.g_ccdWN,
                        stepIndicatorLabelUnFinishedColor: ic.g_ccdHN,
                        labelColor: ic.g_ccdHN,
                        labelSize: ic.gn_fontSizeSml,
                        currentStepLabelColor: ic.g_ccdON
                    }}
                    labels={pd.l_pfx}
                    stepCount={pd.l_pfx.length}
                    currentPosition={pd.n_step}
                />
            </View>
        );
    }

    static Tck(pd){
        //
        const [_s_val, _setVal] = useState(0);
        //
        useEffect(() => {
            let _n_cnt = 0;
            let _id = setInterval(() => {
                _n_cnt += 1;
                if (_n_cnt >= pd.n_cnt) {
                    _setVal(pd.n_val);
                    clearInterval(_id);
                }
                else {
                    _setVal(bf.myCM_get_rnd(999));
                };
            }, 250);
        }, [pd.n_val]);
        //
        return (
            <>
                {(pd.b_vsb) ?
                    <View
                        style={[{
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }, pd.stlCta]}
                    >
                        <Ticker
                            textStyle={[{
                                fontSize: ic.gn_fontSizeNrm,
                                fontWeight: 'bold',
                                color: ic.g_ccdWN,
                            }, pd.stlPfx]}
                            duration={250}
                        >
                            {'{}'.f(bf.myCM_pdd(_s_val, 3))}
                        </Ticker>
                    </View>
                : null }
            </>
        );
    }

  static Top (pd) {
    return (
      <View
        style={{
          position: 'absolute',
          zIndex: ic.gn_zIdxBdy,
//          top: ((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY) + ic.gn_h - (ic.gn_hdrH + ((pd.n_h) ? pd.n_h : 0) + ic.gn_ftrH),
          top: ic.gn_hdrH,
//          left: (global.c?.state.sgcd_dmns.n_w - ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW)) / 2,
          left: (global.c?.state.sgcd_dmns.n_w - ((pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW)) / 2,
          height: (pd.n_h) ? pd.n_h : 0,
          width: (pd.n_pntW) ? pd.n_pntW : global.c?.state.sgcd_dmns.n_bdyW,
          justifyContent: 'center',
        }}
      >                
        { (pd.ld_defss) ? ce._elms(pd.ld_defss) : null }
      </View>
    );
  };

    static Tree(pd){
        //
        let _r1 = [];
        let _r2 = [];
        //
        let _ld_itemss = global.c?.state[pd.state];
        //
        let _topH = ic.gn_fontSizeNrm + ic.gn_mgnLrg * 2;
        //
        let _w = (global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 27;
        let _h = (global.c?.state.sgcd_dmns.n_bdyH - _topH - ic.gn_mgnNrm * 2) / 3 - ic.gn_bdrWNrw * 2;
        //
        function _fnc01(pn_x, pn_y, pn_w, pn_h, p_pfx, p_key) {
            return (
                <View
                    style={{
                        height: pn_w,
                        width: pn_h,
                        transform: [{ rotate: '90deg'}],
                        position: 'absolute',
                        zIndex: 10,
                        top: pn_y - pn_w/2,
                        left: pn_x - pn_h/2,
                        backgroundColor: (p_key != 0) ? ic.g_ccdWN : '#eeeeee',
                        borderColor: (p_key != 0) ? ic.g_ccdHN : ic.g_ccdWN,                        
                        borderWidth: ic.gn_bdrWNrw,
                        borderRadius: ic.gn_bdrRdsNrm,
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <TouchableOpacity
                        onPress={()=>{
                            if (pd.onPrs && p_key != 0) {
                                pd.onPrs(p_key);
                            };
                        }}
                    >
                        <Text
                            style={{
                                lineHeight: pn_w, 
                                height: pn_w,
                                width: pn_h,
                                color: ic.g_fontCcdNrm,
                                fontSize: (ic.gn_fontSizeNrm > pn_w * 0.8) ? pn_w * 0.8 : ic.gn_fontSizeNrm,
                                marginStart: 0, 
                                marginEnd: 0, 
                                marginTop: 0, 
                                marginBottom: 0, 
                                paddingStart: ic.gn_mgnNrm, 
                                paddingEnd: 0, 
                                paddingTop: 0, 
                                paddingBottom: 0, 
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            {p_pfx}
                        </Text>
                    </TouchableOpacity>
                </View>
            );
        };
        //
        // １階層目
        let _cnt1 = 0;
        bf.myCM_for_each(_ld_itemss, (_d_items1)=>{
            if (_d_items1.pntKey == '') {
                _cnt1 += 1;
                let _x = (global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 2 / 1 + (global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 1 * (_cnt1 -1) - _w / 2 + ic.gn_mgnNrm;
                let _y = ic.gn_hdrH + _h * (1 - 1) + ic.gn_mgnNrm + _topH;
                _r1.push(
                    <>
                        <ce.Row
                            stlCta={{
                                width: global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            { (pd.b_leftPrs) ?
                                <ce.Btn
                                    
                                    stlCta={{
                                        width: ic.gn_btnWSml,
                                    }}
                                    stlBtn={{
                                        width: ic.gn_btnWSml,
                                    }}
                                    pfx='＜'
                                    onPrs={pd.onLeftPrs}
                                />
                            :
                                <View
                                    style={{
                                        width: ic.gn_btnWSml,
                                    }}
                                >
                                </View>
                            }
                            <View
                                style={{
                                    height: _topH,
                                    width: global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2 - ic.gn_btnWSml * 2,
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <Text
                                >
                                    {_d_items1.pfx}
                                </Text>
                            </View>
                            { (pd.b_RhtPrs) ?
                            <ce.Btn
                                
                                stlCta={{
                                    width: ic.gn_btnWSml,
                                }}
                                stlBtn={{
                                    width: ic.gn_btnWSml,
                                }}
                                pfx='＞'
                                onPrs={pd.onRhtPrs}
                            />
                            :
                                <View
                                    style={{
                                        width: ic.gn_btnWSml,
                                    }}
                                >
                                </View>
                            }
                        </ce.Row>
                    </>
                );
                //
                // ダミー
                //
                // ２階層目
                for (let _cnt2 of [1,2,3]) {
                    let _x = (global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 2 / 3 + (global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 3 * (_cnt2 -1) - _w / 2 + ic.gn_mgnNrm ;
                    let _y = ic.gn_hdrH + _topH + _h * (2 - 2) + ic.gn_mgnNrm;
                    _r2.push(_fnc01(_x, _y, _w, _h, '', 0));
                    //
                    // ３階層目
                    for (let _cnt3 of [1,2,3]) {
                        let _x = (global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 2 / 9 + (global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 9 * (_cnt3  + (_cnt2 - 1) * 3 - 1) - _w / 2 + ic.gn_mgnNrm ;
                        let _y = ic.gn_hdrH + _h * (3 - 2) + ic.gn_mgnNrm + _topH;
                        _r2.push(_fnc01(_x, _y, _w, _h, '', 0));
                        //
                        // ４階層目
                        for (let _cnt4 of [1,2,3]) {
                            let _x = (global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 2 / 27 + (global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 27 * (_cnt4 + (_cnt3 - 1) * 3  + (_cnt2 - 1) * 9 - 1) - _w / 2 + ic.gn_mgnNrm ;
                            let _y = ic.gn_hdrH + _h * (4 - 2) + ic.gn_mgnNrm + _topH;
                            _r2.push(_fnc01(_x, _y, _w, _h, '', 0));
                        };
                    };
                };
                //
                // 実データ
                //
                // ２階層目
                let _cnt2 = 0;
                bf.myCM_for_each(_ld_itemss, (_d_items2)=>{
                    if (_d_items2.pntKey == _d_items1.key) {
                        _cnt2 += 1;
                        let _x = (global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 2 / 3 + (global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 3 * (_cnt2 -1) - _w / 2 + ic.gn_mgnNrm ;
                        let _y = ic.gn_hdrH + _topH + _h * (2 - 2) + ic.gn_mgnNrm;
                        _r2.push(_fnc01(_x, _y, _w, _h, _d_items2.pfx, _d_items2.key));
                        //
                        // ３階層目
                        let _cnt3 = 0;
                        bf.myCM_for_each(_ld_itemss, async (_d_items3)=>{
                            if (_d_items3.pntKey == _d_items2.key) {
                                _cnt3 += 1;
                                let _x = (global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 2 / 9 + (global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 9 * (_cnt3  + (_cnt2 - 1) * 3 - 1) - _w / 2 + ic.gn_mgnNrm ;
                                let _y = ic.gn_hdrH + _h * (3 - 2) + ic.gn_mgnNrm + _topH;
                                _r2.push(_fnc01(_x, _y, _w, _h, _d_items3.pfx, _d_items3.key));
                                //
                                // ４階層目
                                let _cnt4 = 0;
                                await bf.myCM_for_each(_ld_itemss, (_d_items4)=>{
                                    if (_d_items4.pntKey == _d_items3.key) {
                                        _cnt4 += 1;
                                        let _x = (global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 2 / 27 + (global.c?.state.sgcd_dmns.n_w - ic.gn_mgnNrm * 2) / 27 * (_cnt4 + (_cnt3 - 1) * 3  + (_cnt2 - 1) * 9 - 1) - _w / 2 + ic.gn_mgnNrm ;
                                        let _y = ic.gn_hdrH + _h * (4 - 2) + ic.gn_mgnNrm + _topH;
                                        _r2.push(_fnc01(_x, _y, _w, _h, _d_items4.pfx, _d_items4.key));
                                    };
                                });
                            };
                        });
                    };
                });
            };
        });
        //
        return (
            <>
                <View>
                    {_r1}
                </View>
                <View
                    style={{
                    }}
                >
                    {_r2}
                </View>
            </>
        );
    }
}
